<template>
  <svg
    id="Aquarena_Rutsche"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 540 480"
    style="enable-background: new 0 0 540 480"
    xml:space="preserve"
  >
    <linearGradient id="grad2_1" x1="5%" y1="10%" x2="90%" y2="10%">
      <stop offset="5%" style="stop-color: #00ffff; stop-opacity: 1" />
      <stop offset="50%" style="stop-color: #ff00ff; stop-opacity: 1" />
      <stop offset="95%" style="stop-color: #ffff00; stop-opacity: 1" />
    </linearGradient>
    <linearGradient id="grad3_1" x1="5%" y1="20%" x2="90%" y2="10%">
      <stop offset="0%" style="stop-color: #14b4f0; stop-opacity: 1" />
      <stop offset="25%" style="stop-color: #ffffff; stop-opacity: 1" />
      <stop offset="50%" style="stop-color: #14b4f0; stop-opacity: 1" />
      <stop offset="75%" style="stop-color: #ffffff; stop-opacity: 1" />
      <stop offset="100%" style="stop-color: #14b4f0; stop-opacity: 1" />
    </linearGradient>
    <linearGradient id="grad1_1" x1="5%" y1="0%" x2="90%" y2="0%">
      <stop offset="0%" style="stop-color: #f08c1e; stop-opacity: 1" />
      <stop offset="15%" style="stop-color: #f0dc1e; stop-opacity: 1" />
      <stop offset="40%" style="stop-color: #8cc83c; stop-opacity: 1" />
      <stop offset="60%" style="stop-color: #00ffff; stop-opacity: 1" />
      <stop offset="80%" style="stop-color: #14b4f0; stop-opacity: 1" />
      <stop offset="95%" style="stop-color: #ee82ee; stop-opacity: 1" />
    </linearGradient>

    <g id="Tube__x28_Basis_x29_">
      <path
        class="st0"
        d="M515.3,303.52c-0.07-0.39-0.15-0.78-0.25-1.16c-0.12-0.87-0.3-1.71-0.56-2.52c-0.18-0.9-0.45-1.76-0.78-2.59
		c-0.23-0.84-0.52-1.64-0.88-2.41c-0.29-0.87-0.66-1.71-1.1-2.51c-0.35-0.85-0.78-1.67-1.28-2.43c-0.39-0.79-0.84-1.54-1.35-2.24
		c-0.47-0.84-1.01-1.62-1.63-2.35c-0.51-0.79-1.1-1.52-1.75-2.2c-0.53-0.72-1.13-1.39-1.78-2c-0.16-0.19-0.33-0.37-0.5-0.55
		c-0.46-1.87-1.43-3.46-2.93-4.59c0,0,0,0,0,0s-0.87-0.69-2.02-1.22c-0.91-0.46-1.92-0.73-2.97-0.85c-0.15-0.1-0.3-0.2-0.45-0.3
		c-0.8-0.64-1.67-1.2-2.59-1.67c-0.8-0.58-1.65-1.09-2.56-1.5c-0.86-0.58-1.78-1.08-2.76-1.47c-0.66-0.4-1.35-0.76-2.07-1.05
		c-0.56-0.3-1.15-0.55-1.75-0.78c-0.58-0.29-1.18-0.54-1.79-0.76c-0.6-0.28-1.2-0.53-1.84-0.73c-0.56-0.25-1.14-0.47-1.74-0.64
		c-0.6-0.25-1.22-0.46-1.85-0.64c-0.62-0.25-1.27-0.46-1.93-0.63c-0.64-0.25-1.29-0.45-1.97-0.61c-0.65-0.24-1.32-0.44-2.01-0.59
		c-0.63-0.22-1.27-0.4-1.94-0.53c-0.63-0.21-1.27-0.37-1.93-0.5c-0.64-0.2-1.29-0.36-1.96-0.48c-0.67-0.21-1.37-0.36-2.08-0.47
		c-0.69-0.21-1.4-0.35-2.13-0.46c-0.7-0.2-1.41-0.34-2.15-0.44c-0.17-0.05-0.35-0.08-0.53-0.12c-0.62-1.08-1.39-1.77-2.3-1.93
		c-0.02,0-0.05,0-0.07,0c0,0,0,0,0,0c0,0,0-0.01,0-0.01s-0.66-0.07-1.01-0.13c-0.88-0.15-1.8,0.22-2.7,0.99
		c-0.62-0.14-1.26-0.24-1.91-0.3c-0.69-0.16-1.4-0.26-2.13-0.32c-0.7-0.15-1.41-0.25-2.14-0.3c-0.7-0.15-1.42-0.23-2.15-0.28
		c-0.73-0.15-1.48-0.23-2.24-0.27c-0.73-0.14-1.48-0.22-2.25-0.25c-0.73-0.13-1.49-0.21-2.25-0.23c-0.73-0.12-1.48-0.2-2.25-0.21
		c-0.73-0.11-1.48-0.19-2.25-0.19c-0.7-0.1-1.4-0.17-2.12-0.17c-0.02,0-0.04,0-0.06,0c-0.66-0.09-1.32-0.15-2.01-0.15
		c-0.05,0-0.1,0.01-0.15,0.01c-0.63-0.08-1.26-0.14-1.91-0.14c-0.08,0-0.15,0.01-0.23,0.01c-0.6-0.07-1.2-0.12-1.82-0.12
		c-0.11,0-0.21,0.01-0.31,0.02c-0.57-0.07-1.14-0.11-1.73-0.11c-0.13,0-0.26,0.02-0.39,0.02c-0.54-0.06-1.08-0.09-1.63-0.09
		c-0.16,0-0.31,0.02-0.47,0.02c-0.5-0.05-1.02-0.08-1.53-0.08c-0.22,0-0.43,0.02-0.65,0.03c-0.44-0.04-0.89-0.07-1.34-0.07
		c-0.28,0-0.55,0.03-0.82,0.04c-0.38-0.03-0.76-0.06-1.15-0.06c-0.33,0-0.66,0.03-0.99,0.05c-0.32-0.02-0.63-0.05-0.95-0.05
		c-0.39,0-0.78,0.03-1.16,0.06c-0.25-0.01-0.5-0.04-0.75-0.04c-0.45,0-0.89,0.03-1.34,0.07c-0.19-0.01-0.37-0.03-0.55-0.03
		c-0.52,0-1.03,0.03-1.54,0.08c-0.12,0-0.25-0.02-0.37-0.02c-0.56,0-1.12,0.04-1.67,0.1c-0.13,0-0.26-0.02-0.39-0.02
		c-0.58,0-1.14,0.04-1.7,0.1c-0.11,0-0.21-0.02-0.32-0.02c-0.59,0-1.17,0.04-1.74,0.11c-0.08,0-0.16-0.01-0.25-0.01
		c-0.61,0-1.2,0.05-1.79,0.12c-0.06,0-0.12-0.01-0.18-0.01c-0.21,0-0.41,0.01-0.61,0.02c-0.26-1.46-0.51-2.27-0.74-2.26c0,0,0,0,0,0
		c-0.26-0.01-1.36,0-1.74,0c-0.11,0.62-0.22,1.44-0.31,2.44c-0.13,0.01-0.27,0.02-0.4,0.04c-0.01,0-0.02,0-0.03,0
		c-0.67,0-1.32,0.06-1.96,0.14c-0.68,0-1.35,0.07-2,0.16c-0.67,0.01-1.33,0.07-1.98,0.17c-0.67,0.02-1.32,0.08-1.97,0.18
		c-0.66,0.02-1.31,0.09-1.95,0.19c-0.66,0.03-1.31,0.09-1.94,0.2c-0.65,0.03-1.3,0.1-1.93,0.22c-0.65,0.04-1.3,0.11-1.92,0.23
		c-0.65,0.04-1.29,0.12-1.92,0.24c-0.64,0.05-1.27,0.13-1.88,0.25c-0.63,0.05-1.24,0.14-1.84,0.27c-0.63,0.06-1.24,0.15-1.85,0.28
		c-0.63,0.06-1.24,0.16-1.85,0.29c-0.63,0.06-1.25,0.17-1.85,0.31c-0.65,0.07-1.29,0.19-1.92,0.34c-0.66,0.07-1.3,0.2-1.93,0.35
		c-0.66,0.08-1.31,0.21-1.94,0.37c-0.67,0.08-1.32,0.21-1.95,0.38c-0.67,0.09-1.33,0.22-1.97,0.4c-0.68,0.09-1.34,0.23-1.98,0.41
		c-0.68,0.1-1.35,0.24-2,0.43c-0.69,0.11-1.37,0.25-2.03,0.45c-0.7,0.11-1.39,0.26-2.05,0.46c-0.69,0.12-1.37,0.26-2.02,0.47
		c-0.7,0.12-1.38,0.28-2.04,0.49c-0.71,0.12-1.4,0.29-2.08,0.5c-0.72,0.13-1.43,0.3-2.11,0.52c-0.74,0.13-1.45,0.31-2.15,0.54
		c-0.27,0.05-0.53,0.11-0.8,0.17c-0.89-0.88-1.75-1.31-2.49-1.14c-0.33,0.07-0.97,0.26-0.97,0.26s0,0.01,0,0.01
		c0.04-0.01,0.09-0.03,0.13-0.04c-0.79,0.17-1.34,0.92-1.7,2.18c0,0.01,0,0.01,0,0.02c0,0-0.51,0.11-1.04,0.29
		c-0.57,0.11-1.14,0.26-1.69,0.43c-0.59,0.11-1.17,0.26-1.73,0.45c-0.6,0.12-1.2,0.27-1.77,0.46c-0.62,0.12-1.22,0.27-1.81,0.47
		c-0.63,0.12-1.25,0.28-1.85,0.47c-0.59,0.11-1.16,0.25-1.73,0.43c0.01-0.06,0-0.12,0.01-0.18c0.17-0.74,0.29-1.49,0.35-2.26
		c0.18-0.74,0.3-1.5,0.36-2.28c0.18-0.75,0.3-1.51,0.36-2.3c0.01-0.04,0.02-0.07,0.02-0.11c0,0,0.01-0.01,0.01-0.01
		c1.2-0.93,1.99-2.05,2.22-3.34c0,0,0.01,0,0.01,0s0-0.03,0.01-0.06c0,0,0,0,0-0.01c0,0,0,0,0-0.01c0.03-0.21,0.13-0.83,0.19-1.18
		c0.21-1.33-0.19-2.68-1.07-3.96c0.03-0.22,0.06-0.43,0.08-0.66c0.18-0.76,0.31-1.55,0.37-2.36c0.18-0.77,0.31-1.55,0.37-2.36
		c0.19-0.77,0.31-1.56,0.37-2.36c0.19-0.77,0.31-1.56,0.37-2.36c0.19-0.77,0.31-1.56,0.37-2.36c0.18-0.77,0.31-1.55,0.37-2.36
		c0.18-0.76,0.31-1.55,0.37-2.36c0.18-0.76,0.31-1.55,0.37-2.35c0.07-0.28,0.12-0.56,0.17-0.84c1.18-0.92,1.97-2.04,2.2-3.32
		c0,0,0.01,0,0.01,0s0-0.03,0.01-0.06c0,0,0,0,0-0.01c0,0,0,0,0-0.01c0.03-0.21,0.13-0.83,0.19-1.18c0.21-1.33-0.2-2.69-1.08-3.98
		c0.16-0.7,0.28-1.42,0.34-2.16c0.17-0.73,0.3-1.49,0.36-2.26c0.17-0.73,0.29-1.47,0.36-2.24c0.17-0.72,0.29-1.46,0.35-2.21
		c0.17-0.71,0.29-1.44,0.35-2.19c0.16-0.7,0.28-1.42,0.34-2.16c0.16-0.69,0.28-1.4,0.34-2.13c0.16-0.68,0.27-1.38,0.33-2.1
		c0.15-0.67,0.27-1.36,0.33-2.06c0.1-0.44,0.18-0.89,0.24-1.35c1.17-0.92,1.95-2.03,2.18-3.3c0,0,0.01,0,0.01,0s0-0.03,0.01-0.06
		c0,0,0,0,0-0.01c0,0,0,0,0-0.01c0.03-0.21,0.13-0.83,0.19-1.18c0.21-1.33-0.19-2.67-1.07-3.96c0.12-0.55,0.21-1.11,0.26-1.68
		c0.13-0.58,0.22-1.17,0.28-1.77c0.12-0.56,0.21-1.13,0.27-1.72c0.12-0.54,0.2-1.1,0.26-1.66c0.11-0.53,0.2-1.06,0.25-1.61
		c0.11-0.51,0.19-1.03,0.24-1.55c0.1-0.5,0.18-1,0.23-1.52c0.1-0.48,0.17-0.97,0.22-1.47c0.09-0.46,0.16-0.93,0.21-1.41
		c0.08-0.44,0.15-0.89,0.2-1.34c0.08-0.42,0.15-0.85,0.19-1.28c0.07-0.42,0.14-0.84,0.18-1.27c0.14-0.72,0.22-1.45,0.25-2.2
		c0.07-0.34,0.12-0.69,0.17-1.05c1.14-0.99,1.86-2.14,2.02-3.43c0,0,0.01-0.01,0.01-0.01s0-0.03,0.01-0.06c0,0,0,0,0-0.01
		c0,0,0,0,0-0.01c0.02-0.21,0.09-0.84,0.13-1.19c0.16-1.5-0.44-2.98-1.62-4.34c-0.01-0.4-0.03-0.81-0.06-1.2
		c0.01-0.27,0.04-0.55,0.04-0.82c0-0.61-0.05-1.2-0.12-1.79c0-0.11,0.02-0.21,0.02-0.32c0-0.75-0.07-1.49-0.18-2.21
		c-0.01-0.95-0.1-1.87-0.28-2.77c-0.05-0.82-0.16-1.62-0.33-2.4c-0.08-0.86-0.24-1.69-0.45-2.5c-0.11-0.88-0.29-1.73-0.55-2.55
		c-0.13-0.75-0.32-1.48-0.56-2.19c-0.17-0.85-0.43-1.67-0.74-2.47c-0.2-0.78-0.45-1.54-0.76-2.27c-0.22-0.74-0.5-1.46-0.83-2.15
		c-0.26-0.79-0.59-1.56-0.97-2.29c-0.27-0.69-0.57-1.36-0.93-2c-0.3-0.72-0.67-1.41-1.07-2.07c-0.19-0.42-0.41-0.83-0.64-1.23
		c0.01-1.91-0.53-3.69-1.69-5.14c0,0,0,0,0,0s-0.67-0.88-1.66-1.69c-0.6-0.52-1.27-0.95-2.01-1.3c-0.01-0.02-0.02-0.03-0.04-0.05
		c-0.4-0.6-0.85-1.16-1.32-1.69c-0.43-0.62-0.91-1.2-1.43-1.74c-0.44-0.59-0.91-1.15-1.43-1.67c-0.41-0.52-0.86-1.02-1.34-1.48
		c-0.44-0.54-0.92-1.04-1.43-1.51c-0.47-0.55-0.98-1.06-1.52-1.54c-0.48-0.54-0.98-1.04-1.53-1.51c-0.47-0.51-0.96-0.99-1.5-1.43
		c-0.45-0.47-0.94-0.92-1.45-1.33c-0.46-0.47-0.95-0.91-1.47-1.31c-0.53-0.53-1.1-1.01-1.71-1.46c-0.56-0.57-1.16-1.09-1.81-1.56
		c-0.55-0.55-1.15-1.06-1.77-1.52c-0.54-0.55-1.14-1.04-1.76-1.5c-0.54-0.54-1.13-1.02-1.75-1.47c-0.53-0.52-1.11-0.99-1.71-1.43
		c-0.02-0.02-0.04-0.04-0.06-0.06c-0.16-0.78-0.4-1.45-0.74-2.12c-0.02-0.04-0.04-0.07-0.04-0.07s-0.32-0.58-0.49-0.88
		c-1.51-2.29-3.83-3.4-6.5-3.38c-0.03-0.02-0.06-0.05-0.09-0.08c-0.46-0.44-0.95-0.84-1.46-1.22c-0.45-0.43-0.92-0.82-1.42-1.19
		c-0.44-0.42-0.9-0.8-1.38-1.16c-0.42-0.41-0.87-0.78-1.34-1.14c-0.41-0.4-0.85-0.77-1.3-1.12c-0.4-0.39-0.82-0.75-1.26-1.1
		c-0.4-0.4-0.82-0.77-1.26-1.12c-0.39-0.39-0.8-0.76-1.23-1.11c-0.38-0.39-0.78-0.76-1.2-1.1c-0.36-0.37-0.73-0.72-1.13-1.05
		c-0.33-0.35-0.68-0.68-1.05-1c-0.32-0.35-0.66-0.68-1.01-0.99c-0.31-0.34-0.63-0.67-0.97-0.99c-0.3-0.34-0.6-0.67-0.93-0.98
		c-0.32-0.38-0.66-0.75-1.01-1.09c-0.38-0.47-0.78-0.91-1.21-1.33c-0.41-0.54-0.84-1.06-1.32-1.54c-0.38-0.51-0.78-0.99-1.21-1.45
		c-0.37-0.53-0.78-1.02-1.21-1.49c-0.39-0.57-0.83-1.11-1.29-1.62c-0.38-0.58-0.81-1.12-1.27-1.63c-0.03-0.05-0.07-0.1-0.1-0.15
		c-0.01-1.61-0.46-3.04-1.37-4.21c0,0,0-0.01,0-0.01s-0.02-0.02-0.05-0.06c0,0,0,0,0-0.01c0,0,0,0,0,0
		c-0.15-0.19-0.6-0.75-0.86-1.07c-0.82-1.01-1.93-1.71-3.24-2.11c-0.11-0.15-0.22-0.3-0.34-0.44c-0.34-0.53-0.71-1.05-1.11-1.54
		c-0.33-0.52-0.69-1.02-1.08-1.49c-0.32-0.5-0.67-0.99-1.05-1.44c-0.31-0.48-0.65-0.95-1.02-1.39c-0.3-0.46-0.63-0.9-0.98-1.32
		c-0.32-0.47-0.67-0.92-1.04-1.35c-0.32-0.45-0.66-0.87-1.02-1.29c-0.36-0.49-0.75-0.96-1.16-1.4c-0.44-0.56-0.91-1.09-1.43-1.58
		c-0.5-0.61-1.07-1.17-1.66-1.7c-0.56-0.64-1.16-1.24-1.81-1.78c-0.55-0.61-1.15-1.18-1.79-1.7c-0.58-0.64-1.22-1.23-1.9-1.76
		c-0.6-0.66-1.26-1.26-1.97-1.8c-0.61-0.66-1.27-1.26-1.99-1.8c-0.6-0.64-1.26-1.23-1.97-1.76c-0.59-0.62-1.23-1.18-1.91-1.7
		c-0.56-0.58-1.16-1.11-1.81-1.6c-0.52-0.53-1.07-1.01-1.66-1.46c-0.47-0.48-0.98-0.91-1.51-1.32c-0.16-0.16-0.35-0.3-0.52-0.45
		c-0.18-0.78-0.43-1.45-0.79-2.11c-0.02-0.04-0.04-0.07-0.04-0.07s-0.33-0.57-0.51-0.86c-3.44-4.98-10.6-4.21-16.98,1.93
		s-9.04,14.93-6.4,20.54c0.52,1.05,0.96,1.46,0.96,1.46s0.05,0.05,0.05,0.05c1.14,1.28,3.06,2.12,4.81,2.29
		c0.38,0.36,0.78,0.69,1.2,1.01c0.51,0.52,1.07,0.99,1.65,1.43c0.55,0.56,1.14,1.07,1.77,1.54c0.57,0.59,1.18,1.13,1.84,1.62
		c0.58,0.61,1.2,1.16,1.87,1.67c0.57,0.61,1.19,1.17,1.86,1.68c0.56,0.6,1.16,1.16,1.8,1.66c0.53,0.58,1.1,1.12,1.71,1.6
		c0.49,0.54,1.01,1.05,1.57,1.52c0.38,0.42,0.79,0.83,1.22,1.21c0.3,0.35,0.62,0.69,0.95,1.01c0.21,0.26,0.45,0.5,0.68,0.74
		c0.18,0.23,0.37,0.46,0.57,0.68c0.22,0.29,0.43,0.58,0.67,0.85c0.24,0.34,0.48,0.67,0.74,0.98c0.28,0.41,0.58,0.81,0.9,1.2
		c0.3,0.45,0.61,0.88,0.96,1.29c0.31,0.48,0.65,0.94,1.01,1.38c0.33,0.51,0.68,1,1.07,1.46c0.34,0.53,0.71,1.05,1.12,1.54
		c0.17,0.27,0.36,0.54,0.54,0.8c-0.1,1.85,0.34,3.51,1.39,4.82c0.28,0.34,0.72,0.9,0.85,1.05c0.01,0.01,0.01,0.02,0.02,0.03
		c0.94,1.17,2.28,1.91,3.86,2.27c0.34,0.47,0.69,0.92,1.08,1.35c0.43,0.65,0.92,1.26,1.45,1.83c0.47,0.7,1.01,1.34,1.59,1.95
		c0.49,0.7,1.04,1.36,1.64,1.97c0.48,0.65,1.01,1.27,1.59,1.84c0.45,0.59,0.92,1.15,1.45,1.66c0.4,0.49,0.83,0.96,1.29,1.4
		c0.41,0.49,0.85,0.94,1.32,1.37c0.42,0.48,0.86,0.93,1.34,1.35c0.42,0.47,0.87,0.92,1.36,1.34c0.43,0.47,0.89,0.91,1.37,1.32
		c0.43,0.45,0.87,0.88,1.35,1.27c0.42,0.43,0.87,0.84,1.34,1.22c0.43,0.43,0.88,0.84,1.36,1.22c0.43,0.44,0.9,0.84,1.39,1.22
		c0.45,0.45,0.94,0.86,1.45,1.25c0.46,0.45,0.95,0.86,1.46,1.25c0.46,0.45,0.96,0.86,1.48,1.25c0.47,0.45,0.97,0.87,1.49,1.26
		c0.47,0.45,0.98,0.87,1.51,1.26c0.48,0.46,0.99,0.88,1.52,1.27c0.44,0.42,0.92,0.8,1.41,1.17c0.13,0.43,0.27,0.86,0.45,1.26
		c0.5,1.06,0.93,1.48,0.93,1.48s0.05,0.05,0.05,0.05c1.12,1.32,3.05,2.2,4.81,2.4c-0.01-0.01-0.03-0.03-0.04-0.04
		c0.08,0.06,0.15,0.12,0.23,0.18c0.5,0.49,1.04,0.93,1.61,1.35c0.51,0.5,1.05,0.95,1.62,1.37c0.52,0.51,1.08,0.98,1.66,1.41
		c0.53,0.53,1.11,1.01,1.71,1.46c0.53,0.54,1.12,1.03,1.73,1.49c0.46,0.47,0.95,0.9,1.46,1.31c0.4,0.41,0.83,0.78,1.28,1.14
		c0.39,0.4,0.8,0.79,1.24,1.14c0.36,0.38,0.74,0.74,1.14,1.08c0.33,0.36,0.68,0.7,1.05,1.03c0.32,0.36,0.65,0.7,1.01,1.03
		c0.33,0.39,0.67,0.75,1.04,1.1c0.33,0.41,0.68,0.8,1.06,1.17c0.28,0.36,0.59,0.7,0.9,1.04c0.03,0.04,0.07,0.08,0.1,0.13
		c0.01,2.37,0.87,4.57,2.65,6.33c0.28,0.24,0.81,0.7,0.81,0.7s0.02,0,0.04,0.01c0.6,0.48,1.28,0.87,2,1.19
		c0.06,0.12,0.12,0.25,0.19,0.37c0.18,0.43,0.38,0.85,0.59,1.25c0.14,0.36,0.29,0.7,0.45,1.05c0.14,0.43,0.3,0.85,0.48,1.26
		c0.12,0.42,0.27,0.83,0.43,1.23c0.1,0.38,0.2,0.75,0.33,1.12c0.1,0.51,0.23,1,0.39,1.49c0.07,0.41,0.17,0.82,0.27,1.22
		c0.06,0.46,0.14,0.92,0.24,1.37c0.05,0.53,0.12,1.05,0.22,1.56c0.03,0.44,0.07,0.87,0.13,1.29c0.01,0.56,0.04,1.1,0.11,1.64
		c0,0.08-0.01,0.16-0.01,0.24c-0.81,0.88-1.32,1.86-1.44,2.94c-0.04,0.38-0.1,1-0.12,1.17c0,0.01-0.01,0.02-0.01,0.03
		c-0.14,1.33,0.34,2.66,1.28,3.89c-0.01,0.12-0.03,0.24-0.04,0.37c-0.12,0.56-0.2,1.13-0.25,1.71c-0.09,0.47-0.16,0.95-0.21,1.44
		c-0.07,0.39-0.14,0.78-0.17,1.18c-0.08,0.41-0.14,0.83-0.19,1.25c-0.08,0.43-0.15,0.87-0.2,1.32c-0.09,0.45-0.16,0.91-0.21,1.38
		c-0.1,0.48-0.17,0.96-0.22,1.46c-0.1,0.5-0.18,1.02-0.23,1.54c-0.11,0.52-0.19,1.06-0.24,1.6c-0.11,0.54-0.2,1.09-0.25,1.65
		c-0.12,0.56-0.21,1.13-0.26,1.71c-0.12,0.57-0.21,1.16-0.27,1.76c-0.11,0.51-0.18,1.03-0.24,1.56c-1.21,0.94-2,2.08-2.21,3.39
		c-0.06,0.38-0.16,0.99-0.18,1.16c0,0.01-0.01,0.02-0.01,0.03c-0.21,1.32,0.19,2.67,1.06,3.95c-0.09,0.47-0.16,0.94-0.2,1.42
		c-0.15,0.67-0.26,1.36-0.32,2.06c-0.16,0.68-0.27,1.38-0.33,2.09c-0.16,0.69-0.27,1.4-0.33,2.13c-0.16,0.7-0.28,1.42-0.34,2.16
		c-0.17,0.71-0.28,1.44-0.34,2.18c-0.17,0.72-0.29,1.46-0.35,2.21c-0.17,0.73-0.29,1.47-0.35,2.24c-0.17,0.73-0.29,1.49-0.36,2.26
		c-0.16,0.69-0.27,1.39-0.34,2.11c-1.23,0.95-2.03,2.1-2.24,3.42c-0.06,0.38-0.16,0.99-0.18,1.16c0,0.01-0.01,0.02-0.01,0.03
		c-0.21,1.32,0.19,2.66,1.05,3.94c-0.04,0.3-0.08,0.59-0.11,0.89c-0.18,0.76-0.31,1.54-0.37,2.35c-0.18,0.76-0.31,1.55-0.37,2.36
		c-0.18,0.77-0.31,1.55-0.37,2.36c-0.19,0.77-0.31,1.56-0.37,2.36c-0.19,0.77-0.31,1.56-0.37,2.37c-0.19,0.77-0.31,1.56-0.37,2.37
		c-0.18,0.77-0.31,1.55-0.37,2.36c-0.18,0.77-0.31,1.55-0.37,2.36c-0.05,0.2-0.08,0.41-0.12,0.61c-1.21,0.94-2.01,2.08-2.22,3.4
		c-0.06,0.38-0.16,0.99-0.18,1.16c0,0.01-0.01,0.02-0.01,0.03c-0.21,1.33,0.19,2.68,1.07,3.97c0-0.02,0.01-0.05,0.01-0.07
		c-0.01,0.08-0.02,0.16-0.03,0.25c-0.18,0.75-0.3,1.52-0.36,2.3c-0.18,0.74-0.3,1.51-0.36,2.29c-0.17,0.74-0.3,1.49-0.36,2.27
		c-0.17,0.73-0.29,1.48-0.35,2.25c-0.17,0.72-0.29,1.46-0.35,2.22c-0.17,0.72-0.28,1.45-0.35,2.2c-0.16,0.71-0.28,1.43-0.34,2.17
		c-0.13,0.57-0.24,1.15-0.3,1.74c-0.32-0.82-0.71-1.61-1.16-2.36c-0.39-0.84-0.84-1.64-1.37-2.38c-0.47-0.85-1.02-1.65-1.64-2.39
		c-0.55-0.83-1.19-1.59-1.89-2.29c-0.58-0.71-1.22-1.36-1.92-1.95c-0.46-0.47-0.94-0.92-1.45-1.33c-0.47-0.46-0.98-0.89-1.52-1.29
		c-0.12-0.11-0.25-0.22-0.37-0.33c0-0.01,0-0.01,0-0.02c-0.21-0.8-0.53-1.51-0.94-2.17c0,0,0-0.01,0-0.01s-0.36-0.56-0.55-0.85
		c-1.66-2.25-4.18-3.24-7.04-2.96c-0.29-0.18-0.57-0.37-0.88-0.53c-0.57-0.39-1.18-0.72-1.8-1.03c-0.6-0.38-1.22-0.72-1.87-1.02
		c-0.61-0.37-1.25-0.72-1.91-1c-0.57-0.33-1.17-0.62-1.78-0.87c-0.59-0.33-1.21-0.61-1.85-0.86c-0.65-0.35-1.33-0.64-2.03-0.89
		c-0.66-0.34-1.35-0.63-2.07-0.86c-0.66-0.32-1.34-0.6-2.05-0.81c-0.64-0.29-1.3-0.54-1.98-0.74c-0.65-0.29-1.32-0.52-2.02-0.71
		c-0.69-0.3-1.41-0.53-2.15-0.72c-0.72-0.3-1.48-0.53-2.25-0.71c-0.74-0.28-1.5-0.52-2.29-0.69c-0.71-0.25-1.43-0.47-2.19-0.61
		c-0.71-0.25-1.45-0.44-2.21-0.58c-0.73-0.24-1.48-0.43-2.25-0.56c-0.74-0.24-1.5-0.41-2.29-0.54c-0.78-0.25-1.6-0.41-2.43-0.53
		c-0.81-0.24-1.65-0.41-2.51-0.51c-0.81-0.22-1.64-0.39-2.49-0.47c-0.79-0.2-1.59-0.35-2.43-0.42c-0.8-0.2-1.62-0.34-2.46-0.4
		c-0.8-0.19-1.62-0.32-2.46-0.37c-0.56-0.13-1.13-0.22-1.71-0.28l0-0.01c0-1.48-0.08-2.37-0.26-2.38c0,0,0,0,0,0
		c-0.14-0.01-1.26-0.16-1.38-0.18c-0.15,0.7-0.3,1.48-0.45,2.31c-0.16-0.01-0.32-0.03-0.48-0.04c-0.69-0.13-1.4-0.2-2.12-0.23
		c-0.7-0.12-1.42-0.19-2.15-0.21c-0.71-0.11-1.44-0.18-2.18-0.18c-0.65-0.09-1.31-0.15-1.99-0.15c-0.04,0-0.07,0.01-0.11,0.01
		c-0.6-0.07-1.21-0.12-1.84-0.12c-0.08,0-0.16,0.01-0.25,0.01c-0.56-0.06-1.13-0.1-1.71-0.1c-0.13,0-0.26,0.02-0.39,0.02
		c-0.52-0.05-1.05-0.09-1.59-0.09c-0.21,0-0.4,0.02-0.61,0.03c-0.46-0.04-0.91-0.07-1.38-0.07c-0.3,0-0.59,0.03-0.89,0.04
		c-0.37-0.03-0.74-0.06-1.11-0.06c-0.39,0-0.78,0.03-1.17,0.06c-0.28-0.02-0.56-0.04-0.84-0.04c-0.49,0-0.98,0.03-1.46,0.07
		c-0.19-0.01-0.37-0.03-0.56-0.03c-0.56,0-1.1,0.04-1.64,0.09c-0.13,0-0.25-0.02-0.38-0.02c-0.61,0-1.2,0.05-1.79,0.12
		c-0.08,0-0.15-0.01-0.23-0.01c-0.66,0-1.3,0.06-1.94,0.14c-0.03,0-0.05,0-0.08,0c-0.74,0-1.46,0.07-2.16,0.17
		c-0.8,0.01-1.57,0.09-2.33,0.21c-0.8,0.02-1.58,0.1-2.34,0.25c-0.78,0.04-1.55,0.12-2.29,0.28c-0.74,0.05-1.46,0.15-2.17,0.31
		c-0.74,0.06-1.46,0.18-2.16,0.34c-0.76,0.07-1.5,0.21-2.22,0.39c-0.8,0.09-1.57,0.25-2.33,0.46c-0.79,0.11-1.57,0.27-2.32,0.5
		c-0.74,0.12-1.46,0.29-2.16,0.51c-0.53,0.1-1.05,0.23-1.56,0.38c-2.94-0.93-5.96-0.64-8.59,1.09c-0.31,0.23-0.89,0.67-0.89,0.67
		s0,0.01-0.01,0.02c-0.66,0.54-1.23,1.18-1.73,1.88c-0.01,0.01-0.01,0.02-0.02,0.04c-0.03,0.01-0.05,0.02-0.08,0.04
		c-0.76,0.25-1.5,0.56-2.2,0.93c-0.72,0.26-1.42,0.57-2.08,0.94c-0.66,0.26-1.3,0.58-1.91,0.93c-0.74,0.32-1.45,0.7-2.13,1.13
		c-0.71,0.34-1.4,0.71-2.05,1.15c-0.63,0.33-1.24,0.7-1.82,1.12c-0.71,0.39-1.38,0.85-2.02,1.34c-0.65,0.4-1.28,0.84-1.87,1.33
		c-0.64,0.42-1.23,0.9-1.8,1.41c-0.67,0.48-1.3,1-1.88,1.58c-0.61,0.48-1.17,1.01-1.69,1.57c-0.79,0.67-1.51,1.42-2.15,2.23
		c-0.81,0.77-1.53,1.63-2.15,2.57c-0.46,0.54-0.88,1.11-1.26,1.71c-3.09,2.31-5.37,5.72-6.15,9.8c-0.33,1.74-0.37,3.46-0.15,5.12
		c-1.8-1.63-4.14-2.71-6.72-3.12c-0.1-0.07-0.19-0.15-0.29-0.22c-0.53-0.44-1.1-0.84-1.69-1.21c-0.54-0.43-1.12-0.83-1.72-1.18
		c-0.54-0.41-1.1-0.78-1.69-1.11c-0.52-0.37-1.06-0.73-1.62-1.03c-0.48-0.33-0.98-0.64-1.51-0.92c-0.5-0.34-1.02-0.64-1.56-0.92
		c-0.78-0.52-1.62-0.97-2.49-1.34c-0.91-0.63-1.9-1.17-2.94-1.59c-0.92-0.61-1.91-1.11-2.95-1.51c-0.89-0.56-1.85-1.03-2.86-1.4
		c-0.87-0.52-1.78-0.95-2.75-1.29c-0.15-0.09-0.32-0.16-0.47-0.24c-0.37-0.71-0.79-1.29-1.31-1.84c-0.03-0.04-0.06-0.06-0.06-0.06
		s-0.47-0.46-0.71-0.71c-2.16-1.84-4.78-2.24-7.43-1.37c-0.01,0-0.02-0.01-0.03-0.01c-0.67-0.31-1.37-0.58-2.09-0.8
		c-0.61-0.27-1.25-0.51-1.9-0.7c-0.58-0.25-1.18-0.45-1.79-0.63c-0.53-0.22-1.08-0.4-1.64-0.55c-0.45-0.17-0.92-0.33-1.39-0.46
		c-0.37-0.13-0.74-0.25-1.13-0.36c-0.28-0.1-0.56-0.18-0.84-0.26c-0.18-0.06-0.37-0.12-0.55-0.17c-0.08-0.03-0.16-0.05-0.24-0.08
		c-0.09-0.03-0.19-0.05-0.28-0.08c-0.57-0.24-1.16-0.45-1.76-0.62c-0.58-0.25-1.19-0.46-1.81-0.64c-0.58-0.25-1.19-0.46-1.81-0.64
		c-0.58-0.25-1.19-0.46-1.81-0.64c-0.58-0.25-1.19-0.46-1.81-0.64c-0.58-0.25-1.19-0.46-1.81-0.64c-0.54-0.24-1.11-0.43-1.68-0.6
		c-0.42-0.67-0.89-1.21-1.44-1.72c-0.03-0.03-0.06-0.05-0.06-0.05s-0.5-0.43-0.77-0.65c-2.19-1.59-4.7-1.84-7.16-0.93
		c-0.51-0.21-1.02-0.39-1.55-0.54c-0.58-0.25-1.19-0.46-1.81-0.64c-0.02-0.01-0.04-0.02-0.06-0.02c-0.42-0.67-0.89-1.21-1.44-1.71
		c-0.03-0.03-0.06-0.05-0.06-0.05s-0.51-0.42-0.77-0.64c-4.91-3.54-11.39-0.41-15.35,7.51c-3.96,7.92-3.51,17.1,0.86,21.5
		c0.84,0.82,1.39,1.05,1.39,1.05s0.06,0.03,0.06,0.03c1.51,0.83,3.63,0.97,5.35,0.54c0.56,0.24,1.13,0.44,1.72,0.61
		c0.58,0.25,1.19,0.46,1.81,0.64c0.49,0.21,1,0.39,1.52,0.55c0.28,0.38,0.57,0.74,0.9,1.07c0.84,0.82,1.39,1.06,1.39,1.06
		s0.06,0.03,0.06,0.03c1.5,0.84,3.61,0.98,5.33,0.56c0.54,0.23,1.09,0.42,1.66,0.58c0.58,0.25,1.19,0.46,1.81,0.64
		c0.58,0.25,1.19,0.46,1.81,0.64c0.58,0.25,1.19,0.46,1.81,0.64c0.58,0.25,1.19,0.46,1.81,0.64c0.58,0.25,1.19,0.46,1.81,0.64
		c0.56,0.24,1.15,0.45,1.75,0.63c0.51,0.22,1.03,0.41,1.57,0.57c0.11,0.03,0.22,0.06,0.33,0.09c0.18,0.06,0.36,0.1,0.54,0.15
		c0.24,0.08,0.49,0.15,0.73,0.22c0.3,0.1,0.6,0.2,0.91,0.28c0.35,0.13,0.71,0.25,1.08,0.35c0.4,0.15,0.81,0.29,1.23,0.41
		c0.47,0.19,0.96,0.36,1.46,0.51c0.55,0.24,1.11,0.43,1.69,0.6c0.59,0.26,1.19,0.49,1.82,0.68c0.19,0.09,0.39,0.17,0.58,0.25
		c0.2,0.31,0.42,0.61,0.66,0.88c0.77,0.89,1.3,1.17,1.3,1.17s0.06,0.04,0.06,0.04c1.44,0.96,3.54,1.27,5.28,0.98
		c-0.02-0.02-0.06-0.04-0.08-0.06c0.14,0.05,0.28,0.12,0.43,0.17c0.74,0.42,1.51,0.78,2.32,1.07c0.75,0.45,1.54,0.83,2.36,1.15
		c0.75,0.48,1.55,0.89,2.39,1.23c0.78,0.52,1.61,0.97,2.49,1.34c0.54,0.37,1.1,0.71,1.68,1.01c0.41,0.27,0.84,0.53,1.28,0.76
		c0.42,0.28,0.85,0.55,1.29,0.79c0.38,0.27,0.78,0.51,1.19,0.74c0.37,0.26,0.75,0.51,1.14,0.74c0.36,0.27,0.72,0.52,1.1,0.76
		c0.33,0.27,0.68,0.51,1.04,0.75c0.2,0.41,0.43,0.8,0.67,1.18c0.26,0.39,0.78,1.12,0.78,1.12s0.02,0.01,0.05,0.02
		c1.58,2.18,3.74,3.7,6.16,4.54c0.31,0.38,0.62,0.76,0.97,1.11c0.27,0.37,0.56,0.73,0.87,1.07c0.32,0.48,0.68,0.94,1.05,1.38
		c0.29,0.46,0.61,0.91,0.95,1.34c0.27,0.46,0.57,0.91,0.88,1.34c0.29,0.56,0.62,1.09,0.98,1.6c0.26,0.53,0.54,1.05,0.86,1.54
		c0.17,0.39,0.36,0.76,0.56,1.13c0.13,2.02,0.66,3.93,1.58,5.59c0.23,0.4,0.7,1.17,0.7,1.17s0.02,0.01,0.04,0.02
		c1.43,2.3,3.48,3.97,5.85,4.98c-0.02-0.02-0.04-0.05-0.06-0.07c0.11,0.11,0.2,0.23,0.31,0.33c0.51,0.65,1.07,1.25,1.67,1.8
		c0.6,0.71,1.25,1.37,1.97,1.96c0.53,0.57,1.11,1.11,1.73,1.59c0.59,0.6,1.24,1.15,1.93,1.65c0.61,0.58,1.27,1.12,1.98,1.59
		c0.57,0.5,1.17,0.95,1.81,1.35c0.63,0.52,1.3,0.99,2.01,1.4c0.65,0.5,1.33,0.97,2.06,1.36c0.59,0.42,1.2,0.81,1.85,1.14
		c0.6,0.42,1.24,0.79,1.91,1.11c0.65,0.43,1.34,0.8,2.05,1.13c0.65,0.4,1.32,0.77,2.02,1.07c0.17,0.1,0.34,0.18,0.51,0.27
		c0.38,0.63,0.81,1.23,1.31,1.75c1.33,1.32,2.92,1.7,3.99,1.82c0.88,0.09,1.41,0.1,2.38-0.08c0.38,0.17,0.77,0.32,1.17,0.46
		c0.59,0.28,1.19,0.53,1.81,0.72c0.55,0.25,1.11,0.47,1.69,0.65c0.57,0.24,1.16,0.43,1.76,0.6c0.59,0.23,1.2,0.43,1.82,0.58
		c0.61,0.23,1.23,0.42,1.88,0.56c0.62,0.21,1.25,0.4,1.9,0.54c0.59,0.19,1.19,0.34,1.8,0.46c0.63,0.2,1.29,0.34,1.95,0.45
		c0.66,0.19,1.34,0.34,2.03,0.44c0.67,0.19,1.36,0.33,2.07,0.42c0.69,0.18,1.39,0.32,2.11,0.4c0.67,0.16,1.35,0.28,2.05,0.35
		c0.66,0.15,1.34,0.26,2.03,0.32c0.67,0.15,1.36,0.24,2.07,0.3c0.69,0.15,1.41,0.23,2.14,0.28c0.73,0.14,1.48,0.22,2.24,0.26
		c0.74,0.13,1.49,0.21,2.26,0.23c0.74,0.12,1.5,0.2,2.28,0.21c0.73,0.11,1.47,0.18,2.23,0.18c0.01,0,0.02,0,0.03,0
		c0.66,0.09,1.34,0.15,2.03,0.15c0.05,0,0.11-0.01,0.16-0.01c0.63,0.08,1.26,0.14,1.91,0.14c0.1,0,0.19-0.01,0.29-0.01
		c0.59,0.07,1.19,0.12,1.8,0.12c0.14,0,0.28-0.02,0.41-0.02c0.55,0.06,1.11,0.1,1.68,0.1c0.18,0,0.36-0.02,0.54-0.03
		c0.51,0.05,1.03,0.08,1.55,0.08c0.26,0,0.51-0.03,0.77-0.04c0.44,0.04,0.88,0.07,1.33,0.07c0.35,0,0.68-0.03,1.02-0.05
		c0.36,0.03,0.71,0.05,1.07,0.05c0.43,0,0.85-0.03,1.28-0.06c0.12,0.01,0.24,0.01,0.36,0.02c0.16,0.79,0.33,1.56,0.52,2.31
		c0.45-0.01,1.27-0.03,1.37-0.03c0,0,0,0,0,0c0.18-0.02,0.31-0.87,0.39-2.31c0.08,0.01,0.17,0.01,0.26,0.01
		c0.56,0,1.12-0.04,1.66-0.1c0.14,0,0.27,0.02,0.41,0.02c0.61,0,1.2-0.05,1.79-0.12c0.09,0,0.18,0.01,0.26,0.01
		c0.62,0,1.22-0.05,1.82-0.12c0.02,0,0.04,0,0.06,0c0.66,0,1.31-0.06,1.96-0.14c0.71,0,1.4-0.07,2.09-0.17
		c0.72-0.01,1.42-0.08,2.11-0.19c0.72-0.02,1.43-0.1,2.12-0.22c0.73-0.03,1.44-0.11,2.14-0.24c0.72-0.04,1.43-0.12,2.13-0.27
		c0.69-0.05,1.38-0.14,2.04-0.29c0.7-0.06,1.38-0.16,2.05-0.31c0.7-0.06,1.38-0.18,2.05-0.34c0.74-0.07,1.46-0.22,2.17-0.4
		c0.75-0.09,1.48-0.24,2.2-0.43c0.75-0.1,1.49-0.25,2.2-0.46c0.74-0.12,1.46-0.27,2.16-0.49c0.7-0.12,1.39-0.29,2.05-0.5
		c0.7-0.13,1.38-0.31,2.05-0.54c0.73-0.14,1.43-0.35,2.11-0.6c0.76-0.16,1.49-0.39,2.2-0.67c0.76-0.18,1.49-0.41,2.2-0.7
		c0.71-0.19,1.41-0.42,2.07-0.71c0.69-0.2,1.36-0.44,2-0.73c0.71-0.21,1.39-0.49,2.05-0.8c0.75-0.24,1.47-0.55,2.17-0.9
		c0.68-0.24,1.33-0.52,1.96-0.85c1.93-0.1,3.79-0.64,5.46-1.7c0.13-0.08,0.25-0.18,0.37-0.27c0,0,0,0,0,0
		c0.07-0.04,0.14-0.07,0.2-0.11c1.04-0.67,1.93-1.49,2.68-2.43c0.47-0.26,0.92-0.53,1.36-0.84c0.68-0.36,1.32-0.78,1.93-1.24
		c0.71-0.41,1.39-0.86,2.02-1.38c0.75-0.46,1.45-0.99,2.1-1.57c0.84-0.58,1.62-1.26,2.33-2c0.81-0.66,1.55-1.4,2.2-2.21
		c0.72-0.69,1.37-1.44,1.94-2.25c0.42-0.46,0.81-0.94,1.17-1.44c0.01,0.11,0.03,0.21,0.04,0.32c0,0.06-0.01,0.12-0.01,0.19
		c0,0.72,0.07,1.42,0.17,2.11c0.01,0.84,0.09,1.66,0.23,2.47c0.03,0.82,0.12,1.64,0.28,2.42c0.05,0.74,0.16,1.47,0.32,2.18
		c0.07,0.77,0.21,1.52,0.39,2.26c0.09,0.82,0.26,1.62,0.48,2.4c0.12,0.78,0.28,1.55,0.52,2.29c0.13,0.72,0.31,1.42,0.54,2.1
		c0.14,0.71,0.35,1.4,0.6,2.08c-0.77,3.31-0.21,6.62,1.86,9.36c0.26,0.3,0.76,0.88,0.76,0.88s0.02,0,0.04,0.01
		c0.59,0.63,1.26,1.17,1.99,1.63c0.18,0.36,0.37,0.72,0.58,1.06c0.33,0.74,0.71,1.45,1.15,2.13c0.33,0.67,0.7,1.32,1.13,1.93
		c0.35,0.67,0.77,1.3,1.22,1.91c0.4,0.71,0.86,1.38,1.37,2.01c0.39,0.62,0.82,1.21,1.29,1.76c0.41,0.62,0.88,1.19,1.38,1.74
		c0.31,0.43,0.65,0.84,1.01,1.23c0.27,0.35,0.56,0.69,0.86,1.01c0.21,0.27,0.42,0.53,0.65,0.78c0,0.01,0,0.01,0,0.02
		c-1.45,2.77-1.85,5.64-1.22,8.91c0.16,0.8,0.38,1.57,0.67,2.31c-0.04,0.4-0.07,0.81-0.08,1.22c-0.09,0.67-0.15,1.34-0.15,2.03
		c0,0.3,0.03,0.59,0.04,0.89c-0.02,0.32-0.05,0.64-0.05,0.97c0,0.69,0.06,1.35,0.15,2.02c0.01,1.07,0.14,2.11,0.36,3.11
		c0.1,1.09,0.32,2.15,0.65,3.16c0.2,1.08,0.51,2.13,0.93,3.12c0.27,0.96,0.63,1.89,1.08,2.76c0.26,0.7,0.55,1.38,0.91,2.03
		c0.26,0.6,0.57,1.18,0.9,1.74c0.28,0.6,0.6,1.18,0.95,1.74c0.29,0.58,0.61,1.15,0.98,1.68c0.32,0.59,0.7,1.15,1.09,1.69
		c0.35,0.59,0.73,1.15,1.15,1.69c0.35,0.56,0.73,1.09,1.15,1.59c0.39,0.58,0.83,1.11,1.3,1.63c0.42,0.57,0.87,1.11,1.36,1.62
		c0.41,0.52,0.85,1.02,1.32,1.48c0.46,0.56,0.97,1.07,1.5,1.55c0.49,0.55,1,1.07,1.57,1.54c0.46,0.48,0.95,0.94,1.48,1.36
		c0.15,0.16,0.32,0.3,0.48,0.44c0.22,0.69,0.5,1.35,0.85,1.96c0.98,1.58,2.44,2.32,3.45,2.68c-0.13-0.07-0.25-0.13-0.37-0.2
		c0.81,0.4,1.71,0.62,2.7,0.67c0.58,0.45,1.19,0.86,1.83,1.22c0.6,0.44,1.22,0.83,1.88,1.18c0.6,0.42,1.24,0.79,1.91,1.12
		c0.69,0.46,1.42,0.86,2.19,1.2c0.69,0.43,1.41,0.82,2.17,1.13c0.67,0.39,1.36,0.73,2.09,1.01c0.69,0.39,1.41,0.72,2.16,0.99
		c0.78,0.42,1.61,0.77,2.46,1.05c0.77,0.38,1.56,0.71,2.4,0.96c0.76,0.36,1.55,0.66,2.37,0.88c0.78,0.36,1.6,0.64,2.44,0.86
		c0.82,0.36,1.68,0.64,2.57,0.85c0.89,0.37,1.81,0.66,2.77,0.85c0.85,0.33,1.74,0.58,2.65,0.75c0.88,0.32,1.79,0.57,2.73,0.72
		c0.9,0.32,1.84,0.55,2.81,0.69c0.84,0.28,1.71,0.49,2.6,0.62c0.78,0.24,1.59,0.41,2.42,0.53c0.71,0.2,1.45,0.35,2.2,0.44
		c0.72,0.18,1.45,0.33,2.21,0.41c0.68,0.16,1.37,0.29,2.09,0.35c0.68,0.16,1.38,0.27,2.1,0.33c0.69,0.15,1.39,0.25,2.11,0.3
		c0.7,0.15,1.42,0.23,2.15,0.28c0.45,0.09,0.91,0.15,1.38,0.19c0,0,0,0,0,0.01c0.03,1.48,0.13,2.35,0.31,2.37c0,0,0,0,0,0
		c0.21,0.04,1.1,0.13,1.41,0.17c0.16-0.58,0.34-1.37,0.54-2.31c0.29,0.02,0.58,0.05,0.87,0.06c0.74,0.12,1.49,0.2,2.26,0.21
		c0.72,0.11,1.45,0.18,2.21,0.18c0.01,0,0.02,0,0.03,0c0.65,0.09,1.31,0.15,1.99,0.15c0.05,0,0.1-0.01,0.16-0.01
		c0.61,0.08,1.23,0.13,1.86,0.13c0.1,0,0.19-0.01,0.28-0.01c0.57,0.07,1.15,0.11,1.74,0.11c0.14,0,0.27-0.02,0.41-0.02
		c0.53,0.06,1.07,0.09,1.62,0.09c0.19,0,0.38-0.02,0.57-0.03c0.48,0.05,0.96,0.07,1.45,0.07c0.28,0,0.55-0.03,0.82-0.04
		c0.4,0.03,0.8,0.06,1.2,0.06c0.36,0,0.72-0.03,1.07-0.05c0.32,0.02,0.63,0.05,0.95,0.05c0.45,0,0.89-0.03,1.32-0.07
		c0.23,0.01,0.46,0.04,0.7,0.04c0.52,0,1.04-0.03,1.55-0.08c0.16,0,0.31,0.02,0.46,0.02c0.57,0,1.13-0.04,1.68-0.1
		c0.11,0,0.22,0.02,0.33,0.02c0.61,0,1.21-0.05,1.8-0.12c0.07,0,0.14,0.01,0.2,0.01c0.65,0,1.29-0.06,1.92-0.14
		c0.02,0,0.05,0,0.07,0c0.72,0,1.42-0.07,2.1-0.16c0.76-0.01,1.51-0.08,2.24-0.2c0.76-0.02,1.51-0.09,2.23-0.22
		c0.76-0.03,1.5-0.11,2.22-0.25c0.73-0.04,1.46-0.13,2.16-0.27c0.7-0.05,1.4-0.15,2.07-0.29c0.7-0.06,1.39-0.17,2.06-0.32
		c0.71-0.07,1.39-0.19,2.07-0.35c0.74-0.08,1.46-0.23,2.17-0.41c0.74-0.09,1.45-0.24,2.15-0.43c0.73-0.11,1.45-0.25,2.14-0.46
		c0.7-0.12,1.39-0.27,2.06-0.48c0.67-0.12,1.32-0.28,1.96-0.49c0.63-0.12,1.25-0.29,1.85-0.49c1.26,0.7,2.5,0.92,3.65,0.6
		c0,0,0.01,0,0.01,0s0.02-0.01,0.06-0.02c0,0,0,0,0.01,0c0,0,0,0,0,0c0.18-0.05,0.74-0.22,1.06-0.31c1.2-0.35,2.16-1.3,2.86-2.65
		c0.17-0.07,0.35-0.13,0.52-0.2c0.63-0.18,1.23-0.41,1.82-0.67c0.66-0.2,1.3-0.46,1.92-0.75c0.67-0.22,1.31-0.49,1.94-0.8
		c0.66-0.24,1.3-0.51,1.91-0.83c0.62-0.24,1.22-0.51,1.8-0.83c0.6-0.25,1.18-0.54,1.74-0.86c0.64-0.28,1.24-0.6,1.83-0.96
		c0.74-0.35,1.45-0.74,2.12-1.19c0.82-0.4,1.61-0.87,2.34-1.4c0.91-0.44,1.77-0.97,2.57-1.58c0.88-0.46,1.72-0.99,2.49-1.61
		c0.87-0.48,1.69-1.05,2.44-1.69c0.79-0.48,1.53-1.02,2.22-1.63c0.76-0.48,1.46-1.03,2.12-1.64c0.07-0.05,0.14-0.11,0.21-0.16
		c1.82-0.62,3.46-1.63,4.77-3.09c0.1-0.12,0.19-0.24,0.29-0.36c0,0,0,0,0,0c0.05-0.06,0.11-0.11,0.17-0.16
		c0.75-0.84,1.34-1.77,1.8-2.76c0.2-0.22,0.41-0.44,0.6-0.67c0.56-0.53,1.08-1.1,1.56-1.71c0.62-0.61,1.17-1.29,1.67-2
		c0.53-0.58,1.02-1.2,1.45-1.86c0.51-0.6,0.96-1.26,1.37-1.94c0.5-0.64,0.96-1.32,1.35-2.04c0.42-0.59,0.78-1.22,1.11-1.87
		c0.43-0.66,0.81-1.36,1.13-2.08c0.36-0.61,0.68-1.25,0.95-1.91c0.36-0.67,0.66-1.37,0.92-2.09c0.32-0.67,0.61-1.35,0.84-2.07
		c0.27-0.63,0.49-1.28,0.68-1.95c0.26-0.66,0.48-1.35,0.64-2.06c0.1-0.27,0.18-0.55,0.26-0.82c-0.02,0.08-0.04,0.16-0.06,0.24
		c0.65-0.58,1.21-1.22,1.67-1.93c0.01,0,0.02-0.01,0.02-0.01s0.37-0.63,0.57-0.96c1.49-2.94,1.37-6.12-0.08-9.05
		c0.01-0.08,0.02-0.16,0.03-0.24c0.07-0.44,0.12-0.88,0.15-1.33c0.08-0.48,0.13-0.96,0.17-1.45c0.09-0.51,0.14-1.03,0.18-1.55
		c0.09-0.54,0.16-1.09,0.19-1.65c0.1-0.57,0.17-1.15,0.2-1.75c0.11-0.6,0.17-1.21,0.21-1.83c0.11-0.62,0.18-1.26,0.22-1.91
		c0.06-0.31,0.1-0.63,0.14-0.95c0-0.01,0-0.01,0-0.01c0.55-0.66,1.02-1.38,1.37-2.15c0.01,0,0.02-0.01,0.02-0.01
		s0.28-0.68,0.42-1.03c0.87-2.61,0.6-5.22-0.58-7.57c0.04-0.34,0.06-0.69,0.08-1.04c0.15-0.74,0.23-1.5,0.26-2.28
		c0.15-0.75,0.23-1.52,0.26-2.3c0.15-0.75,0.23-1.53,0.26-2.32c0.15-0.76,0.23-1.54,0.27-2.33c0.01-0.07,0.02-0.14,0.03-0.21
		c0.55-0.66,1.02-1.38,1.37-2.14c0.01,0,0.02-0.01,0.02-0.01s0.28-0.68,0.42-1.03c0.87-2.6,0.6-5.2-0.57-7.55
		c0.02-0.21,0.04-0.43,0.05-0.64c0.15-0.73,0.22-1.49,0.26-2.26c0.14-0.72,0.22-1.46,0.25-2.22c0.14-0.71,0.21-1.44,0.25-2.18
		c0.13-0.69,0.21-1.4,0.24-2.13c0.02-0.1,0.03-0.2,0.04-0.29c0,0.03-0.01,0.07-0.01,0.1c0.55-0.66,1.02-1.38,1.37-2.15
		c0.01,0,0.02-0.01,0.02-0.01s0.28-0.68,0.42-1.03c0.88-2.62,0.6-5.25-0.6-7.62c0.01-0.11,0.03-0.21,0.04-0.32
		c0.09-0.52,0.15-1.05,0.18-1.58c0.08-0.49,0.14-0.98,0.17-1.48c0.07-0.45,0.12-0.91,0.15-1.37c0.06-0.41,0.11-0.83,0.14-1.25
		c0.06-0.39,0.1-0.79,0.13-1.19c0.02-0.14,0.03-0.28,0.05-0.42c0.55-0.67,1-1.39,1.35-2.17c0.01,0,0.02-0.01,0.02-0.01
		s0.27-0.68,0.41-1.04C518.52,309.8,517.66,306.35,515.3,303.52z M253.71,318.19c-1.55,0.23-3.04,0.75-4.4,1.62
		c-0.13,0.08-0.25,0.18-0.38,0.27c-0.07,0.04-0.14,0.07-0.2,0.11c-0.65,0.41-1.22,0.89-1.76,1.42c-0.13,0.06-0.26,0.11-0.38,0.17
		c-0.47,0.17-0.93,0.36-1.37,0.57c-0.53,0.17-1.03,0.37-1.53,0.59c-0.56,0.17-1.1,0.37-1.63,0.59c-0.54,0.16-1.07,0.33-1.59,0.55
		c-0.51,0.14-1.01,0.3-1.49,0.48c-0.52,0.12-1.02,0.28-1.52,0.45c-0.56,0.12-1.1,0.28-1.64,0.46c-0.59,0.12-1.16,0.27-1.73,0.45
		c-0.59,0.11-1.18,0.25-1.74,0.42c-0.56,0.1-1.11,0.22-1.65,0.38c-0.55,0.09-1.09,0.2-1.62,0.35c-0.56,0.08-1.1,0.18-1.64,0.32
		c-0.57,0.07-1.12,0.17-1.67,0.3c-0.61,0.06-1.2,0.17-1.79,0.3c-0.61,0.06-1.21,0.15-1.79,0.27c-0.61,0.05-1.21,0.13-1.8,0.25
		c-0.58,0.04-1.15,0.11-1.71,0.22c-0.57,0.03-1.13,0.1-1.68,0.19c-0.57,0.03-1.13,0.08-1.68,0.17c-0.57,0.02-1.13,0.07-1.68,0.15
		c-0.57,0.01-1.13,0.06-1.68,0.13c-0.59,0-1.17,0.05-1.74,0.12c-0.02,0-0.04,0-0.06,0c-0.61,0-1.2,0.05-1.79,0.12
		c-0.09,0-0.18-0.01-0.26-0.01c-0.56,0-1.12,0.04-1.66,0.1c-0.14,0-0.27-0.02-0.41-0.02c-0.52,0-1.03,0.03-1.53,0.08
		c-0.03,0-0.06,0-0.09,0c0,0,0,0,0.01,0c-0.22-1.47-0.43-2.31-0.61-2.31c-0.03,0.17-0.03,0.17,0,0c-0.22-0.01-1.11,0.01-1.42,0.01
		c-0.08,0.59-0.16,1.38-0.24,2.32c-0.09,0-0.19-0.01-0.28-0.01c-0.35,0-0.68,0.03-1.02,0.05c-0.36-0.03-0.71-0.05-1.07-0.05
		c-0.26,0-0.51,0.03-0.77,0.04c-0.44-0.04-0.88-0.07-1.33-0.07c-0.18,0-0.36,0.02-0.54,0.03c-0.51-0.05-1.03-0.08-1.55-0.08
		c-0.14,0-0.28,0.02-0.41,0.02c-0.55-0.06-1.11-0.1-1.68-0.1c-0.1,0-0.19,0.01-0.29,0.01c-0.59-0.07-1.19-0.12-1.8-0.12
		c-0.05,0-0.11,0.01-0.16,0.01c-0.63-0.08-1.26-0.14-1.91-0.14c-0.01,0-0.02,0-0.03,0c-0.6-0.08-1.21-0.14-1.84-0.14
		c-0.59-0.09-1.18-0.14-1.79-0.16c-0.58-0.1-1.17-0.16-1.77-0.18c-0.57-0.1-1.15-0.17-1.75-0.21c-0.59-0.12-1.19-0.19-1.8-0.23
		c-0.59-0.12-1.19-0.21-1.81-0.26c-0.58-0.13-1.17-0.22-1.77-0.28c-0.55-0.13-1.11-0.23-1.69-0.29c-0.51-0.12-1.02-0.22-1.55-0.29
		c-0.49-0.13-1-0.23-1.51-0.31c-0.48-0.13-0.97-0.24-1.46-0.33c-0.47-0.14-0.95-0.26-1.44-0.35c-0.49-0.15-0.99-0.28-1.49-0.38
		c-0.42-0.14-0.85-0.25-1.28-0.35c-0.39-0.14-0.79-0.25-1.2-0.36c-0.37-0.14-0.75-0.27-1.13-0.37c-0.35-0.14-0.71-0.28-1.07-0.39
		c-0.42-0.18-0.85-0.33-1.29-0.47c-0.45-0.2-0.92-0.39-1.4-0.55c-0.45-0.21-0.6-0.24-0.65-0.27c-0.4-0.72-0.88-1.33-1.43-1.87
		c0,0,0-0.01,0-0.01s-0.48-0.45-0.73-0.69c-1.84-1.52-4.07-1.99-6.37-1.49c-0.16-0.09-0.31-0.18-0.47-0.26
		c-0.44-0.29-0.9-0.56-1.37-0.8c-0.45-0.31-0.92-0.61-1.4-0.87c-0.37-0.27-0.76-0.52-1.16-0.75c-0.37-0.29-0.76-0.56-1.16-0.82
		c-0.42-0.35-0.85-0.67-1.3-0.97c-0.34-0.3-0.7-0.58-1.07-0.85c-0.33-0.32-0.68-0.62-1.05-0.9c-0.37-0.38-0.76-0.74-1.17-1.08
		c-0.27-0.29-0.55-0.56-0.84-0.83c-0.05-0.06-0.1-0.11-0.15-0.17c0.1,0.05,0.2,0.09,0.3,0.14c0.55,0.38,1.14,0.72,1.74,1.03
		c0.34,0.6,0.72,1.18,1.17,1.69c1.27,1.37,2.85,1.82,3.91,1.98c0.44,0.06,0.74,0.1,1.34,0.1c0.37,0,0.74-0.03,1.12-0.09
		c-0.03-0.01,0.22,0.09,0.38,0.15c0.82,0.42,1.68,0.77,2.58,1.04c0.79,0.38,1.62,0.68,2.48,0.92c0.81,0.36,1.67,0.65,2.55,0.87
		c0.9,0.38,1.84,0.67,2.82,0.86c0.83,0.31,1.69,0.55,2.59,0.71c0.84,0.29,1.71,0.51,2.61,0.65c0.84,0.27,1.72,0.46,2.61,0.59
		c0.76,0.22,1.54,0.38,2.35,0.47c0.7,0.17,1.41,0.31,2.14,0.38c0.67,0.15,1.35,0.26,2.05,0.32c0.67,0.15,1.36,0.24,2.07,0.29
		c0.71,0.15,1.44,0.23,2.18,0.27c0.73,0.14,1.47,0.22,2.23,0.24c0.73,0.13,1.48,0.2,2.25,0.22c0.74,0.11,1.48,0.19,2.25,0.19
		c0.66,0.09,1.34,0.15,2.02,0.15c0.04,0,0.08-0.01,0.12-0.01c0.62,0.08,1.25,0.13,1.89,0.13c0.08,0,0.16-0.01,0.25-0.01
		c0.58,0.07,1.17,0.11,1.77,0.11c0.13,0,0.25-0.02,0.37-0.02c0.54,0.06,1.09,0.1,1.65,0.1c0.17,0,0.33-0.02,0.49-0.02
		c0.51,0.05,1.02,0.08,1.54,0.08c0.24,0,0.48-0.02,0.72-0.04c0.43,0.04,0.87,0.07,1.31,0.07c0.32,0,0.63-0.03,0.94-0.05
		c0.36,0.03,0.73,0.06,1.1,0.06c0.39,0,0.78-0.03,1.16-0.06c0.29,0.02,0.58,0.04,0.88,0.04c0.46,0,0.92-0.03,1.37-0.07
		c0.22,0.01,0.45,0.03,0.67,0.03c0.52,0,1.04-0.03,1.55-0.08c0.16,0.01,0.32,0.02,0.49,0.02c0.29,0,0.57-0.03,0.85-0.05
		c0.17,0.79,0.34,1.55,0.54,2.3c0.45-0.01,1.27-0.04,1.37-0.04c0,0,0,0,0,0c0.18-0.02,0.3-0.87,0.37-2.33
		c0.22-0.02,0.44-0.04,0.66-0.06c0.1,0,0.19,0.01,0.29,0.01c0.62,0,1.23-0.05,1.84-0.12c0.06,0,0.13,0.01,0.19,0.01
		c0.65,0,1.29-0.06,1.92-0.14c0.03,0,0.06,0,0.09,0c0.68,0,1.35-0.06,2.01-0.15c0.74,0,1.47-0.07,2.18-0.18
		c0.74-0.01,1.46-0.08,2.16-0.19c0.73-0.02,1.44-0.09,2.14-0.21c0.72-0.03,1.43-0.1,2.12-0.22c0.71-0.03,1.42-0.11,2.1-0.24
		c0.71-0.04,1.4-0.12,2.08-0.25c0.68-0.05,1.35-0.13,2.01-0.26c0.66-0.05,1.32-0.14,1.95-0.27c0.66-0.06,1.3-0.15,1.93-0.29
		c0.65-0.06,1.28-0.16,1.9-0.3c0.64-0.06,1.27-0.17,1.88-0.31c0.66-0.07,1.3-0.19,1.92-0.34c0.64-0.07,1.27-0.2,1.89-0.35
		c0.63-0.08,1.25-0.2,1.85-0.36c0.62-0.09,1.22-0.21,1.82-0.37c0.6-0.09,1.2-0.22,1.78-0.38c0.59-0.1,1.17-0.22,1.73-0.38
		c0.57-0.1,1.13-0.23,1.68-0.39c0.46-0.09,0.92-0.2,1.37-0.33c0.45-0.09,0.89-0.2,1.33-0.33c0.28-0.05,0.55-0.13,0.82-0.2
		C254.39,317.76,254.05,317.97,253.71,318.19z M259.91,285.38c-0.3,0.07-0.59,0.16-0.88,0.25c-0.58,0.11-1.16,0.25-1.72,0.43
		c-0.57,0.11-1.13,0.24-1.67,0.42c-0.55,0.11-1.1,0.24-1.62,0.4c-0.53,0.1-1.06,0.23-1.57,0.39c-0.51,0.1-1.01,0.22-1.49,0.37
		c-0.49,0.1-0.97,0.22-1.44,0.36c-0.47,0.09-0.93,0.21-1.38,0.34c-0.45,0.09-0.89,0.2-1.32,0.33c-0.43,0.08-0.84,0.19-1.25,0.31
		c-0.47,0.09-0.94,0.21-1.4,0.35c-0.47,0.09-0.94,0.2-1.39,0.33c-0.49,0.09-0.96,0.19-1.43,0.33c-0.5,0.08-0.99,0.19-1.47,0.32
		c-0.51,0.08-1.01,0.18-1.51,0.31c-0.52,0.07-1.03,0.17-1.54,0.3c-0.53,0.07-1.06,0.17-1.57,0.29c-0.54,0.06-1.08,0.16-1.6,0.28
		c-0.58,0.06-1.15,0.16-1.7,0.29c-0.59,0.06-1.17,0.15-1.74,0.28c-0.6,0.05-1.19,0.14-1.77,0.26c-0.61,0.05-1.21,0.13-1.79,0.25
		c-0.61,0.05-1.2,0.12-1.79,0.24c-0.6,0.04-1.19,0.11-1.76,0.22c-0.6,0.04-1.2,0.1-1.78,0.21c-0.61,0.03-1.2,0.09-1.79,0.19
		c-0.61,0.02-1.21,0.08-1.8,0.17c-0.62,0.01-1.22,0.07-1.81,0.16c-0.62,0.01-1.22,0.06-1.82,0.14c-0.65,0-1.29,0.06-1.92,0.14
		c-0.03,0-0.06,0-0.09,0c-0.62,0-1.23,0.05-1.84,0.12c-0.06,0-0.13-0.01-0.19-0.01c-0.59,0-1.17,0.04-1.75,0.11
		c-0.1,0-0.19-0.01-0.29-0.01c-0.18,0-0.35,0.02-0.53,0.03c-0.23-1.45-0.44-2.28-0.62-2.27c-0.03,0.17-0.03,0.17,0,0
		c-0.22-0.01-1.11,0.01-1.42,0.02c-0.08,0.59-0.15,1.39-0.22,2.34c-0.27,0.01-0.54,0.01-0.8,0.04c-0.16-0.01-0.32-0.02-0.49-0.02
		c-0.46,0-0.92,0.03-1.37,0.07c-0.22-0.01-0.45-0.03-0.67-0.03c-0.39,0-0.78,0.03-1.16,0.06c-0.29-0.02-0.58-0.04-0.88-0.04
		c-0.32,0-0.63,0.03-0.94,0.05c-0.36-0.03-0.73-0.06-1.1-0.06c-0.24,0-0.48,0.02-0.72,0.04c-0.43-0.04-0.87-0.07-1.31-0.07
		c-0.17,0-0.33,0.02-0.49,0.02c-0.51-0.05-1.02-0.08-1.54-0.08c-0.13,0-0.25,0.02-0.37,0.02c-0.54-0.06-1.09-0.1-1.65-0.1
		c-0.08,0-0.16,0.01-0.25,0.01c-0.58-0.07-1.17-0.11-1.77-0.11c-0.04,0-0.08,0.01-0.12,0.01c-0.61-0.08-1.23-0.13-1.85-0.13
		c-0.56-0.08-1.14-0.12-1.72-0.14c-0.56-0.09-1.12-0.14-1.69-0.16c-0.55-0.09-1.1-0.16-1.67-0.19c-0.55-0.11-1.11-0.17-1.69-0.22
		c-0.57-0.12-1.16-0.2-1.76-0.25c-0.57-0.12-1.14-0.22-1.73-0.28c-0.52-0.12-1.05-0.21-1.6-0.28c-0.52-0.13-1.05-0.23-1.59-0.3
		c-0.58-0.16-1.17-0.29-1.78-0.38c-0.64-0.21-1.31-0.37-1.99-0.49c-0.64-0.22-1.29-0.42-1.96-0.55c-0.54-0.2-1.1-0.37-1.67-0.51
		c-0.6-0.25-1.23-0.45-1.87-0.63c-0.6-0.27-1.21-0.5-1.85-0.69c-0.32-0.15-0.66-0.27-1-0.4c-0.45-0.89-1.32-1.88-1.32-1.88
		s-0.46-0.47-0.7-0.72c-1.77-1.59-3.97-2.15-6.29-1.75c-0.18-0.12-0.35-0.25-0.53-0.36c-0.35-0.3-0.72-0.57-1.1-0.84
		c-0.23-0.21-0.46-0.41-0.7-0.6c-0.23-0.23-0.48-0.45-0.73-0.67c-0.06-0.07-0.13-0.14-0.19-0.21c0.08-0.41,0.14-0.82,0.19-1.24
		c0.06-0.07,0.13-0.13,0.19-0.2c0.33-0.28,0.65-0.57,0.96-0.87c0.26-0.21,0.51-0.42,0.76-0.65c0.32-0.23,0.64-0.47,0.95-0.72
		c0.34-0.22,0.66-0.47,0.98-0.71c0.32-0.19,0.63-0.39,0.93-0.61c0.42-0.23,0.83-0.48,1.22-0.75c0.37-0.19,0.73-0.4,1.09-0.63
		c0.37-0.18,0.74-0.36,1.09-0.57c0.48-0.2,0.94-0.43,1.39-0.68c0.44-0.18,0.87-0.38,1.29-0.59c0.42-0.16,0.84-0.33,1.24-0.52
		c0.17-0.06,0.34-0.13,0.51-0.2c1.91,0.35,3.79,0.14,5.48-0.67c0.09-0.05,0.22-0.1,0.19-0.09c0,0,0,0,0,0s1.04-0.5,2.08-1.32
		c0.24-0.18,0.45-0.38,0.67-0.58c0.06-0.02,0.12-0.03,0.18-0.05c0.57-0.1,1.14-0.23,1.68-0.4c0.53-0.09,1.05-0.2,1.56-0.34
		c0.54-0.07,1.07-0.18,1.59-0.31c0.59-0.07,1.16-0.17,1.72-0.3c0.62-0.06,1.22-0.16,1.81-0.29c0.62-0.05,1.23-0.13,1.83-0.25
		c0.59-0.04,1.16-0.11,1.73-0.22c0.57-0.03,1.14-0.09,1.69-0.18c0.58-0.02,1.15-0.07,1.71-0.15c0.61-0.01,1.21-0.06,1.8-0.13
		c0.03,0,0.05,0,0.08,0c0.61,0,1.2-0.05,1.79-0.12c0.08,0,0.15,0.01,0.23,0.01c0.56,0,1.1-0.04,1.64-0.09
		c0.13,0,0.25,0.02,0.38,0.02c0.49,0,0.98-0.03,1.46-0.07c0.19,0.01,0.37,0.03,0.56,0.03c0.39,0,0.78-0.03,1.17-0.06
		c0.28,0.02,0.56,0.04,0.84,0.04c0.3,0,0.59-0.03,0.89-0.04c0.37,0.03,0.74,0.06,1.11,0.06c0.21,0,0.4-0.02,0.61-0.03
		c0.46,0.04,0.91,0.07,1.38,0.07c0.13,0,0.26-0.02,0.39-0.02c0.52,0.05,1.05,0.09,1.59,0.09c0.08,0,0.16-0.01,0.25-0.01
		c0.56,0.06,1.13,0.1,1.71,0.1c0.04,0,0.07-0.01,0.11-0.01c0.58,0.07,1.17,0.12,1.77,0.12c0.54,0.07,1.09,0.12,1.65,0.13
		c0.54,0.08,1.08,0.13,1.63,0.15c0.53,0.09,1.06,0.15,1.61,0.18c0.39,0.07,0.79,0.11,1.19,0.15c-0.01,0.93,0,1.75,0.03,2.42
		c0.19,0.03,1.21,0.13,1.34,0.15c0,0,0,0,0,0c0.18,0,0.43-0.84,0.72-2.27c0-0.01,0-0.01,0-0.01c0.08,0.01,0.17,0.02,0.25,0.02
		c0.71,0.16,1.44,0.27,2.18,0.33c0.71,0.17,1.43,0.29,2.18,0.36c0.7,0.17,1.41,0.31,2.14,0.38c0.65,0.17,1.32,0.3,2,0.38
		c0.62,0.17,1.26,0.3,1.91,0.39c0.62,0.18,1.26,0.32,1.91,0.42c0.64,0.2,1.3,0.34,1.97,0.46c0.63,0.2,1.28,0.36,1.94,0.48
		c0.62,0.21,1.25,0.38,1.9,0.51c0.6,0.21,1.21,0.39,1.84,0.52c0.54,0.19,1.09,0.36,1.65,0.49c0.52,0.2,1.06,0.37,1.61,0.51
		c0.53,0.22,1.08,0.4,1.63,0.55c0.55,0.23,1.11,0.43,1.69,0.6c0.53,0.24,1.08,0.45,1.65,0.62c0.48,0.22,0.98,0.42,1.49,0.59
		c0.45,0.22,0.91,0.41,1.39,0.58c0.44,0.22,0.89,0.42,1.35,0.6c0.46,0.25,0.94,0.47,1.44,0.67c0.46,0.26,0.93,0.49,1.42,0.7
		c0.39,0.22,0.79,0.43,1.2,0.62c0.38,0.23,0.76,0.44,1.16,0.64c0.37,0.24,0.75,0.46,1.14,0.67c0.09,0.06,0.19,0.11,0.29,0.18
		c0.19,0.51,0.39,1,0.65,1.46c0.97,1.61,2.44,2.34,3.46,2.71c-0.02-0.01,0.05,0.02,0.11,0.04c0.42,0.19,0.83,0.32,1.2,0.36
		C259.97,285.1,259.96,285.15,259.91,285.38z M485.92,312.63c0,0.03,0,0.05,0,0.08c0,0.02,0,0.03-0.01,0.05
		C485.91,312.71,485.91,312.67,485.92,312.63z M385.63,388.03c-0.15,0.68-0.3,1.45-0.45,2.27c-0.28-0.02-0.56-0.05-0.84-0.06
		c-0.82-0.19-1.67-0.3-2.53-0.35c-0.8-0.2-1.61-0.33-2.45-0.39c-0.78-0.2-1.57-0.36-2.39-0.44c-0.7-0.2-1.42-0.34-2.15-0.44
		c-0.73-0.23-1.48-0.38-2.25-0.49c-0.71-0.23-1.44-0.41-2.2-0.54c-0.69-0.24-1.41-0.44-2.14-0.58c-0.67-0.24-1.35-0.46-2.06-0.6
		c-0.58-0.22-1.17-0.41-1.78-0.56c-0.63-0.27-1.29-0.48-1.96-0.65c-0.62-0.27-1.26-0.5-1.91-0.69c-0.6-0.28-1.22-0.53-1.86-0.72
		c-0.53-0.26-1.08-0.48-1.65-0.67c-0.51-0.26-1.03-0.49-1.57-0.69c-0.55-0.3-1.12-0.55-1.71-0.78c-0.53-0.3-1.09-0.57-1.66-0.81
		c-0.5-0.29-1.01-0.56-1.54-0.79c-0.44-0.27-0.9-0.52-1.38-0.74c-0.45-0.29-0.91-0.55-1.38-0.79c-0.47-0.32-0.97-0.61-1.48-0.88
		c-0.31-0.22-0.64-0.41-0.97-0.61c-0.03-0.05-0.06-0.1-0.09-0.16c1.38-0.13,2.67-0.62,3.79-1.5c0.03-0.02,0.04-0.03,0.06-0.04
		c0,0,0,0,0,0s0.87-0.65,1.68-1.63c0.16-0.18,0.29-0.38,0.44-0.57c0.33-0.15,0.66-0.29,0.98-0.46c0.46-0.18,0.91-0.38,1.35-0.6
		c0.48-0.17,0.94-0.37,1.39-0.59c0.49-0.17,0.97-0.36,1.43-0.57c0.54-0.17,1.06-0.38,1.57-0.61c0.56-0.17,1.11-0.38,1.65-0.61
		c0.57-0.17,1.14-0.36,1.68-0.59c0.55-0.15,1.09-0.33,1.62-0.55c0.55-0.14,1.08-0.31,1.6-0.51c0.55-0.13,1.09-0.3,1.62-0.49
		c0.58-0.13,1.14-0.29,1.69-0.48c0.62-0.12,1.22-0.3,1.81-0.49c0.62-0.12,1.23-0.27,1.82-0.47c0.62-0.11,1.24-0.25,1.84-0.44
		c0.59-0.1,1.17-0.22,1.73-0.39c0.58-0.09,1.14-0.2,1.7-0.35c0.58-0.07,1.14-0.18,1.7-0.32c0.63-0.07,1.24-0.18,1.85-0.32
		c0.64-0.06,1.26-0.16,1.87-0.29c0.63-0.05,1.26-0.13,1.86-0.26c0.58-0.04,1.16-0.11,1.73-0.21c0.56-0.03,1.12-0.08,1.66-0.17
		c0.56-0.01,1.12-0.06,1.67-0.13c0.01,0,0.01,0,0.02,0c0.61,0,1.21-0.05,1.8-0.12c0.07,0,0.15,0.01,0.22,0.01
		c0.54,0,1.07-0.03,1.59-0.09c0.14,0,0.28,0.02,0.42,0.02c0.5,0,0.99-0.03,1.48-0.07c0.15,0.01,0.3,0.01,0.45,0.02
		c0.16,0.79,0.34,1.56,0.53,2.31c0.52,0,1.47,0,1.58,0c0,0,0,0,0,0c0.21-0.02,0.38-0.85,0.52-2.29c0-0.01,0-0.02,0.01-0.02
		c0.19,0.01,0.38,0.02,0.57,0.02c0.36,0,0.72-0.03,1.07-0.05c0.5,0.05,1.01,0.08,1.53,0.08c0.29,0,0.58-0.03,0.87-0.04
		c0.53,0.06,1.08,0.09,1.63,0.09c0.23,0,0.45-0.02,0.67-0.03c0.56,0.06,1.14,0.11,1.72,0.11c0.16,0,0.32-0.02,0.49-0.02
		c0.59,0.07,1.19,0.12,1.81,0.12c0.1,0,0.21-0.01,0.31-0.02c0.62,0.08,1.25,0.13,1.89,0.13c0.05,0,0.09-0.01,0.14-0.01
		c0.63,0.08,1.28,0.14,1.93,0.14c0.57,0.08,1.14,0.13,1.72,0.14c0.55,0.08,1.1,0.14,1.66,0.16c0.53,0.09,1.06,0.15,1.61,0.18
		c0.51,0.09,1.03,0.16,1.56,0.2c0.49,0.1,1,0.17,1.51,0.21c0.51,0.1,1.02,0.18,1.54,0.23c0.47,0.1,0.95,0.17,1.44,0.23
		c0.44,0.1,0.9,0.17,1.36,0.23c0.44,0.1,0.88,0.18,1.33,0.24c0.43,0.1,0.87,0.19,1.32,0.26c0.43,0.11,0.86,0.2,1.3,0.27
		c0.43,0.11,0.86,0.21,1.3,0.28c0.42,0.11,0.85,0.21,1.29,0.29c0.42,0.12,0.84,0.22,1.28,0.3c0.4,0.11,0.81,0.22,1.23,0.29
		c0.44,0.13,0.88,0.24,1.34,0.33c0.5,0.16,1,0.29,1.52,0.39c0.5,0.16,1.01,0.31,1.54,0.42c0.49,0.17,1,0.32,1.51,0.44
		c0.37,0.14,0.75,0.24,1.13,0.35c0.21,0.29,0.43,0.57,0.67,0.84c0.8,0.86,1.34,1.12,1.34,1.12s0.06,0.04,0.06,0.04
		c1.47,0.91,3.58,1.15,5.31,0.8c-0.01-0.01-0.03-0.02-0.05-0.03c0.32,0.15,0.64,0.31,0.97,0.44c0.48,0.27,0.97,0.53,1.48,0.75
		c0.37,0.23,0.75,0.44,1.15,0.64c0.42,0.29,0.86,0.56,1.31,0.81c0.28,0.21,0.57,0.41,0.87,0.6c0.27,0.23,0.55,0.44,0.84,0.65
		c0.13,0.12,0.26,0.24,0.39,0.35c-0.11,0.55-0.19,1.1-0.24,1.67c0,0-0.24,0.21-0.54,0.51c-0.29,0.22-0.57,0.45-0.85,0.69
		c-0.42,0.28-0.83,0.57-1.22,0.89c-0.4,0.24-0.78,0.49-1.15,0.76c-0.52,0.27-1.01,0.57-1.49,0.9c-0.46,0.23-0.91,0.47-1.34,0.75
		c-0.52,0.23-1.02,0.49-1.51,0.78c-0.57,0.23-1.11,0.49-1.64,0.79c-0.45,0.17-0.88,0.37-1.31,0.59c-1.32-0.48-2.63-0.57-3.85-0.17
		c-0.39,0.13-1.01,0.33-1.18,0.39c-0.01,0-0.02,0-0.03,0.01c-1.34,0.44-2.41,1.42-3.21,2.78c-0.36,0.09-0.72,0.19-1.06,0.3
		c-0.34,0.09-0.68,0.18-1.01,0.29c-0.35,0.09-0.69,0.18-1.03,0.29c-0.35,0.09-0.7,0.17-1.04,0.28c-0.36,0.08-0.71,0.17-1.06,0.28
		c-0.3,0.07-0.59,0.14-0.88,0.23c-0.39,0.08-0.77,0.18-1.14,0.29c-0.4,0.07-0.78,0.17-1.17,0.28c-0.41,0.07-0.8,0.16-1.2,0.26
		c-0.42,0.07-0.83,0.15-1.23,0.25c-0.43,0.06-0.85,0.14-1.26,0.23c-0.44,0.05-0.87,0.12-1.3,0.21c-0.5,0.05-1,0.13-1.49,0.23
		c-0.5,0.05-0.99,0.12-1.47,0.21c-0.5,0.04-1,0.1-1.49,0.18c-0.52,0.03-1.03,0.08-1.54,0.16c-0.54,0.02-1.07,0.06-1.59,0.13
		c-0.62,0-1.22,0.05-1.82,0.13c-0.06,0-0.12-0.01-0.17-0.01c-0.59,0-1.17,0.04-1.74,0.11c-0.13,0-0.26-0.02-0.39-0.02
		c-0.54,0-1.07,0.03-1.6,0.09c-0.21-0.01-0.41-0.03-0.62-0.03c-0.46,0-0.91,0.03-1.36,0.07c-0.32-0.02-0.63-0.05-0.95-0.05
		c-0.35,0-0.68,0.03-1.02,0.05c-0.45-0.04-0.91-0.07-1.38-0.07c-0.28,0-0.55,0.03-0.82,0.04c-0.55-0.06-1.11-0.1-1.68-0.1
		c-0.23,0-0.45,0.02-0.68,0.03c-0.63-0.08-1.26-0.14-1.91-0.14c-0.18,0-0.35,0.02-0.53,0.03c-0.71-0.1-1.43-0.17-2.16-0.17
		c-0.13,0-0.25,0.02-0.38,0.02c-0.79-0.13-1.59-0.21-2.42-0.21c-0.07,0-0.14,0.01-0.21,0.01c-0.87-0.16-1.77-0.25-2.69-0.25
		c-0.01,0-0.02,0-0.03,0c-0.87-0.17-1.77-0.26-2.68-0.28c0-1.47-0.08-2.34-0.26-2.36c0,0,0,0,0,0
		C386.87,388.2,385.75,388.05,385.63,388.03z M384.11,420.27c-0.04,0-0.08-0.01-0.11-0.01c0,0,0-0.01,0-0.01
		C384.03,420.26,384.07,420.26,384.11,420.27z M341.6,344.61c-0.58,0.21-1.14,0.46-1.69,0.73c-2.92-0.69-5.76,0.01-7.98,2.24
		c-0.24,0.28-0.7,0.81-0.7,0.81s0,0.01,0,0.02c-0.48,0.6-0.88,1.28-1.21,2c-0.2,0.12-0.4,0.24-0.6,0.38
		c-0.71,0.38-1.38,0.82-2.02,1.31c-0.76,0.44-1.48,0.93-2.15,1.49c-0.68,0.44-1.32,0.93-1.92,1.47c-0.31,0.22-0.62,0.45-0.92,0.68
		c-0.11-0.14-0.21-0.29-0.32-0.43c-0.2-0.32-0.42-0.64-0.65-0.94c-0.22-0.38-0.45-0.76-0.7-1.12c-0.21-0.4-0.45-0.79-0.69-1.17
		c-0.18-0.36-0.37-0.71-0.57-1.05c-0.19-0.43-0.4-0.85-0.62-1.26c-0.1-0.21-0.13-0.25-0.15-0.32c0.16-2.12-0.24-4.16-1.31-5.92
		c0,0,0,0,0,0s-0.6-1.06-1.53-2.08c-0.02-0.02-0.04-0.04-0.07-0.07c-0.08-0.34-0.16-0.68-0.26-1c-0.09-0.49-0.2-0.96-0.33-1.43
		c-0.07-0.47-0.16-0.92-0.27-1.38c-0.06-0.53-0.15-1.05-0.27-1.56c-0.05-0.57-0.13-1.13-0.24-1.68c-0.04-0.5-0.1-1-0.18-1.49
		c-0.02-0.5-0.06-0.99-0.13-1.48c0-0.57-0.05-1.13-0.11-1.68c0-0.06,0.01-0.12,0.01-0.19c0-0.53-0.03-1.06-0.08-1.58
		c0-0.15,0.02-0.29,0.02-0.44c0-0.39-0.03-0.77-0.06-1.15c0.02-0.29,0.04-0.58,0.04-0.88c0-0.23-0.02-0.45-0.03-0.68
		c0.02-0.22,0.02-0.45,0.03-0.68c0,0.01,0,0.01,0,0.02c1.01-1.35,1.46-2.89,1.21-4.52c0,0,0,0,0,0s-0.12-0.96-0.55-2.03
		c-0.05-0.13-0.12-0.26-0.17-0.38c0.04-0.28,0.09-0.55,0.11-0.84c0.05-0.33,0.1-0.66,0.13-1c0.05-0.3,0.09-0.6,0.12-0.91
		c0.05-0.33,0.1-0.65,0.13-0.99c0.06-0.35,0.11-0.7,0.15-1.06c0.06-0.37,0.12-0.75,0.16-1.13c0.07-0.4,0.13-0.8,0.17-1.2
		c0.08-0.42,0.14-0.84,0.18-1.27c0.08-0.44,0.15-0.88,0.19-1.34c0.09-0.46,0.16-0.93,0.21-1.4c0.1-0.48,0.17-0.97,0.22-1.46
		c0.1-0.51,0.18-1.02,0.23-1.55c0.08-0.36,0.12-0.74,0.17-1.11c0.12-0.04,0.23-0.08,0.35-0.12c0.7-0.13,1.38-0.3,2.04-0.52
		c0.69-0.13,1.37-0.3,2.02-0.52c0.68-0.13,1.35-0.3,2-0.51c0.68-0.12,1.33-0.29,1.97-0.5c0.67-0.12,1.31-0.29,1.95-0.5
		c0.65-0.12,1.29-0.28,1.92-0.49c0.64-0.12,1.27-0.28,1.88-0.48c0.63-0.12,1.25-0.28,1.85-0.47c0.62-0.12,1.22-0.27,1.81-0.46
		c0.6-0.12,1.2-0.27,1.77-0.45c0.59-0.11,1.17-0.26,1.73-0.44c0.57-0.11,1.14-0.25,1.69-0.43c0.48-0.09,0.95-0.22,1.41-0.36
		c0.85,0.79,1.67,1.17,2.38,1.01c0.02,0,0.04-0.02,0.06-0.02c0,0,0,0,0,0c0,0,0.01,0.01,0.01,0.01s0.51-0.15,0.78-0.21
		c0.74-0.16,1.28-0.89,1.63-2.03c0.18-0.05,0.35-0.1,0.53-0.16c0.71-0.13,1.4-0.3,2.07-0.52c0.69-0.12,1.37-0.28,2.03-0.5
		c0.68-0.12,1.35-0.27,1.99-0.48c0.67-0.11,1.32-0.26,1.96-0.46c0.65-0.11,1.3-0.25,1.92-0.44c0.62-0.1,1.24-0.24,1.83-0.42
		c0.61-0.1,1.22-0.23,1.8-0.4c0.61-0.09,1.2-0.22,1.78-0.38c0.6-0.09,1.18-0.21,1.75-0.37c0.59-0.08,1.17-0.2,1.73-0.35
		c0.58-0.08,1.15-0.19,1.71-0.33c0.58-0.07,1.14-0.18,1.7-0.32c0.57-0.07,1.13-0.17,1.68-0.3c0.57-0.06,1.13-0.16,1.67-0.29
		c0.59-0.06,1.16-0.16,1.72-0.29c0.58-0.06,1.16-0.15,1.72-0.27c0.58-0.05,1.15-0.14,1.71-0.26c0.58-0.05,1.15-0.13,1.71-0.24
		c0.57-0.05,1.13-0.12,1.68-0.23c0.56-0.04,1.11-0.11,1.65-0.22c0.56-0.04,1.11-0.1,1.66-0.2c0.56-0.03,1.12-0.1,1.67-0.19
		c0.57-0.03,1.13-0.09,1.68-0.18c0.57-0.02,1.14-0.08,1.69-0.17c0.58-0.02,1.15-0.07,1.71-0.15c0.58-0.01,1.16-0.06,1.72-0.14
		c0.59-0.01,1.17-0.06,1.75-0.13c0.61,0,1.21-0.05,1.8-0.13c0.01,0,0.02,0,0.03,0c0.04,0,0.08,0,0.13,0c0.19,0.76,0.39,1.5,0.6,2.21
		c0.55-0.01,1.55-0.03,1.68-0.03c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0.22-0.02,0.38-0.87,0.49-2.33
		c-0.01,0-0.02,0-0.04,0c0.29-0.02,0.57-0.05,0.86-0.08c0.06,0,0.12,0.01,0.18,0.01c0.59,0,1.17-0.04,1.74-0.11
		c0.08,0,0.16,0.01,0.25,0.01c0.58,0,1.14-0.04,1.7-0.1c0.11,0,0.21,0.02,0.32,0.02c0.56,0,1.12-0.04,1.67-0.1
		c0.13,0,0.26,0.02,0.39,0.02c0.52,0,1.03-0.03,1.54-0.08c0.12,0,0.25,0.02,0.37,0.02c0.45,0,0.89-0.03,1.34-0.07
		c0.19,0.01,0.37,0.03,0.55,0.03c0.39,0,0.78-0.03,1.16-0.06c0.25,0.01,0.5,0.04,0.75,0.04c0.33,0,0.66-0.03,0.99-0.05
		c0.32,0.02,0.63,0.05,0.95,0.05c0.28,0,0.55-0.03,0.82-0.04c0.38,0.03,0.76,0.06,1.15,0.06c0.22,0,0.43-0.02,0.65-0.03
		c0.44,0.04,0.89,0.07,1.34,0.07c0.16,0,0.31-0.02,0.47-0.02c0.5,0.05,1.02,0.08,1.53,0.08c0.13,0,0.26-0.02,0.39-0.02
		c0.54,0.06,1.08,0.09,1.63,0.09c0.11,0,0.21-0.01,0.31-0.02c0.57,0.07,1.14,0.11,1.73,0.11c0.08,0,0.15-0.01,0.23-0.01
		c0.6,0.07,1.2,0.12,1.82,0.12c0.05,0,0.1-0.01,0.15-0.01c0.63,0.08,1.26,0.14,1.91,0.14c0.02,0,0.04,0,0.06,0
		c0.64,0.09,1.29,0.14,1.95,0.15c0.62,0.09,1.25,0.15,1.89,0.16c0.62,0.1,1.25,0.16,1.89,0.17c0.62,0.1,1.25,0.17,1.89,0.19
		c0.61,0.11,1.24,0.18,1.88,0.21c0.61,0.12,1.24,0.19,1.88,0.23c0.64,0.13,1.29,0.2,1.96,0.25c0.63,0.13,1.28,0.22,1.94,0.27
		c0.63,0.14,1.27,0.23,1.93,0.29c0.41,0.09,0.82,0.16,1.24,0.22c0.64,1.29,1.47,2.11,2.47,2.28c0.42,0.07,1.26,0.17,1.26,0.17
		s0.01-0.01,0.01-0.01c0.94,0.09,1.89-0.36,2.85-1.28c0.4,0.09,0.8,0.19,1.21,0.25c0.54,0.15,1.1,0.27,1.67,0.36
		c0.54,0.16,1.1,0.29,1.66,0.39c0.56,0.17,1.13,0.31,1.71,0.42c0.55,0.18,1.1,0.32,1.67,0.43c0.52,0.17,1.05,0.32,1.6,0.44
		c0.47,0.16,0.95,0.3,1.45,0.41c0.46,0.17,0.92,0.31,1.4,0.43c0.44,0.17,0.89,0.32,1.35,0.45c0.44,0.18,0.88,0.34,1.34,0.47
		c0.44,0.19,0.89,0.35,1.35,0.5c0.37,0.17,0.76,0.31,1.15,0.44c0.36,0.17,0.72,0.32,1.09,0.46c0.34,0.17,0.67,0.33,1.02,0.47
		c0.44,0.23,0.89,0.44,1.36,0.63c0.47,0.29,0.96,0.55,1.47,0.78c0.18,0.12,0.36,0.23,0.54,0.34c0.71,1.85,1.98,3.4,3.81,4.47
		c0.33,0.17,0.96,0.48,0.96,0.48s0.02,0,0.04-0.01c0.71,0.32,1.47,0.53,2.26,0.66c0.01,0.01,0.01,0.02,0.02,0.02
		c0.19,0.25,0.37,0.5,0.57,0.74c0.14,0.22,0.3,0.43,0.45,0.65c0.15,0.28,0.32,0.55,0.49,0.81c0.11,0.23,0.22,0.46,0.34,0.68
		c0.09,0.22,0.2,0.44,0.3,0.65c0.06,0.19,0.14,0.38,0.21,0.57c-0.1,0.4-0.15,0.66-0.15,0.66s0,0,0,0c0.01-0.03,0.02-0.07,0.03-0.1
		c-0.43,1.96-0.13,3.95,0.78,5.8c-0.03,0.27-0.06,0.54-0.08,0.81c-0.06,0.38-0.1,0.76-0.12,1.15c-0.06,0.4-0.1,0.81-0.13,1.22
		c-0.07,0.44-0.12,0.88-0.14,1.34c-0.08,0.48-0.13,0.96-0.16,1.45c-0.08,0.51-0.14,1.03-0.17,1.56c-0.04,0.23-0.05,0.47-0.08,0.7
		c-0.41,0.57-0.76,1.18-1.03,1.83c-0.53,1.21-0.75,2.34-0.75,2.34s0,0,0,0c0.01-0.03-0.02,0.15-0.05,0.27
		c-0.32,1.77-0.05,3.57,0.71,5.26c-0.02,0.26-0.05,0.52-0.06,0.78c-0.13,0.69-0.2,1.39-0.24,2.11c-0.14,0.7-0.21,1.43-0.24,2.16
		c-0.14,0.72-0.22,1.46-0.25,2.2c-0.14,0.73-0.22,1.48-0.25,2.24c-0.08,0.38-0.13,0.77-0.17,1.16c-0.41,0.57-0.76,1.18-1.03,1.83
		c-0.53,1.21-0.75,2.34-0.75,2.34s0,0,0,0c0.01-0.03,0.02-0.07,0.03-0.1c-0.44,1.91-0.18,3.85,0.66,5.68
		c-0.02,0.21-0.04,0.43-0.05,0.64c-0.15,0.76-0.23,1.54-0.27,2.33c-0.15,0.75-0.23,1.53-0.26,2.32c-0.15,0.75-0.23,1.52-0.26,2.3
		c-0.07,0.36-0.12,0.72-0.17,1.09c-0.1-0.12-0.19-0.26-0.29-0.38c-0.6-0.93-1.28-1.8-2.06-2.57c-0.65-0.84-1.38-1.6-2.19-2.28
		c-0.66-0.72-1.4-1.38-2.19-1.96c-0.71-0.68-1.49-1.29-2.33-1.83c-0.77-0.65-1.61-1.24-2.5-1.73c-0.7-0.52-1.45-0.98-2.24-1.37
		c-0.8-0.55-1.65-1.02-2.55-1.41c-0.74-0.45-1.51-0.84-2.32-1.16c-0.73-0.42-1.5-0.77-2.31-1.06c-0.07-0.04-0.14-0.06-0.2-0.1
		c-0.39-0.68-0.82-1.24-1.34-1.76c-0.03-0.03-0.06-0.06-0.06-0.06s-0.48-0.45-0.74-0.68c-2.23-1.78-4.87-2.08-7.51-1.12
		c-0.52-0.18-1.04-0.34-1.59-0.47c-0.68-0.25-1.38-0.47-2.1-0.62c-0.62-0.22-1.26-0.4-1.92-0.54c-0.57-0.19-1.14-0.34-1.74-0.46
		c-0.55-0.17-1.12-0.31-1.69-0.42c-0.51-0.15-1.03-0.27-1.56-0.37c-0.47-0.13-0.95-0.24-1.44-0.33c-0.48-0.13-0.98-0.24-1.48-0.33
		c-0.5-0.13-1-0.24-1.52-0.32c-0.51-0.13-1.03-0.24-1.57-0.32c-0.53-0.13-1.07-0.24-1.62-0.32c-0.55-0.13-1.11-0.24-1.68-0.31
		c-0.57-0.13-1.15-0.24-1.74-0.3c-0.57-0.13-1.16-0.23-1.75-0.28c-0.57-0.12-1.16-0.2-1.75-0.26c-0.62-0.13-1.26-0.2-1.9-0.25
		c-0.65-0.12-1.31-0.2-1.98-0.23c-0.67-0.12-1.36-0.19-2.06-0.22c-0.7-0.12-1.42-0.19-2.15-0.21c-0.73-0.11-1.48-0.19-2.24-0.19
		c-0.67-0.09-1.36-0.16-2.06-0.16c-0.05,0-0.09,0.01-0.14,0.01c-0.65-0.08-1.3-0.14-1.97-0.14c-0.1,0-0.21,0.01-0.31,0.02
		c-0.62-0.08-1.25-0.13-1.89-0.13c-0.16,0-0.32,0.02-0.49,0.02c-0.59-0.07-1.19-0.12-1.81-0.12c-0.23,0-0.45,0.02-0.67,0.03
		c-0.56-0.06-1.14-0.11-1.72-0.11c-0.29,0-0.58,0.03-0.87,0.04c-0.53-0.06-1.08-0.09-1.63-0.09c-0.36,0-0.72,0.03-1.07,0.05
		c-0.5-0.05-1.01-0.08-1.53-0.08c-0.43,0-0.85,0.03-1.27,0.06c-0.21-1.47-0.42-2.32-0.63-2.32c0,0,0,0,0,0
		c-0.25-0.01-1.28-0.02-1.64-0.03c-0.11,0.59-0.23,1.39-0.35,2.34c-0.1,0.01-0.2,0.01-0.3,0.02c-0.31-0.02-0.62-0.05-0.93-0.05
		c-0.54,0-1.07,0.03-1.59,0.09c-0.14,0-0.28-0.02-0.42-0.02c-0.61,0-1.21,0.05-1.8,0.12c-0.07,0-0.15-0.01-0.22-0.01
		c-0.68,0-1.35,0.06-2.01,0.15c-0.01,0-0.01,0-0.02,0c-0.81,0-1.6,0.08-2.38,0.21c-0.82,0.02-1.63,0.1-2.42,0.25
		c-0.8,0.04-1.59,0.12-2.36,0.28c-0.76,0.05-1.5,0.15-2.22,0.31c-0.75,0.06-1.49,0.18-2.21,0.35c-0.76,0.07-1.5,0.21-2.22,0.38
		c-0.81,0.08-1.59,0.25-2.35,0.45c-0.8,0.1-1.58,0.26-2.33,0.48c-0.78,0.12-1.54,0.27-2.27,0.5c-0.73,0.12-1.45,0.29-2.14,0.51
		c-0.73,0.13-1.43,0.31-2.12,0.54c-0.72,0.14-1.42,0.33-2.09,0.57c-0.75,0.15-1.46,0.37-2.16,0.62c-0.75,0.16-1.48,0.39-2.18,0.66
		c-0.74,0.18-1.46,0.4-2.15,0.68c-0.71,0.19-1.41,0.41-2.07,0.69c-0.67,0.19-1.32,0.41-1.95,0.69c-0.66,0.19-1.3,0.43-1.92,0.7
		c-0.66,0.2-1.3,0.45-1.92,0.74c-0.68,0.22-1.34,0.49-1.98,0.8C342.87,344.02,342.22,344.3,341.6,344.61z M470.44,403.73
		c-0.35,0.35-0.69,0.72-1,1.11c-1.54,0.64-2.93,1.58-4.07,2.86c-0.1,0.12-0.19,0.24-0.29,0.36c-0.05,0.06-0.11,0.1-0.17,0.16
		c-0.51,0.56-0.93,1.18-1.3,1.82c-0.09,0.07-0.18,0.15-0.26,0.22c-0.57,0.36-1.11,0.76-1.63,1.2c-0.57,0.34-1.11,0.71-1.63,1.12
		c-0.64,0.35-1.24,0.76-1.82,1.2c-0.7,0.36-1.36,0.77-1.98,1.23c-0.68,0.33-1.33,0.69-1.95,1.11c-0.44,0.21-0.87,0.44-1.28,0.7
		c-0.38,0.18-0.75,0.37-1.11,0.57c-0.44,0.19-0.86,0.4-1.27,0.62c-0.44,0.18-0.86,0.38-1.28,0.6c-0.42,0.16-0.83,0.35-1.23,0.54
		c-0.43,0.16-0.85,0.33-1.26,0.52c-0.46,0.15-0.91,0.32-1.34,0.52c-0.19,0.06-0.36,0.14-0.55,0.2c-1.22-0.63-2.43-0.84-3.54-0.52
		c-0.34,0.1-0.88,0.26-1.03,0.31c-0.01,0-0.02,0-0.03,0c-1.17,0.34-2.11,1.24-2.81,2.54c-0.31,0.08-0.62,0.17-0.93,0.27
		c-0.57,0.11-1.12,0.25-1.66,0.42c-0.55,0.1-1.08,0.22-1.61,0.38c-0.53,0.09-1.05,0.2-1.57,0.34c-0.54,0.08-1.07,0.18-1.59,0.32
		c-0.55,0.07-1.08,0.17-1.61,0.29c-0.59,0.06-1.17,0.17-1.74,0.3c-0.61,0.06-1.2,0.15-1.79,0.28c-0.61,0.05-1.21,0.13-1.8,0.25
		c-0.59,0.04-1.17,0.11-1.74,0.22c-0.58,0.03-1.14,0.1-1.7,0.2c-0.58,0.02-1.15,0.08-1.71,0.17c-0.58,0.01-1.16,0.07-1.72,0.15
		c-0.61,0-1.21,0.05-1.81,0.13c-0.02,0-0.05,0-0.07,0c-0.61,0-1.21,0.05-1.8,0.12c-0.07,0-0.14-0.01-0.2-0.01
		c-0.57,0-1.13,0.04-1.68,0.1c-0.11,0-0.22-0.02-0.33-0.02c-0.52,0-1.04,0.03-1.55,0.08c-0.16,0-0.31-0.02-0.46-0.02
		c-0.45,0-0.89,0.03-1.32,0.07c-0.23-0.01-0.46-0.04-0.7-0.04c-0.36,0-0.72,0.03-1.07,0.05c-0.32-0.02-0.63-0.05-0.95-0.05
		c-0.28,0-0.55,0.03-0.82,0.04c-0.4-0.03-0.8-0.06-1.2-0.06c-0.19,0-0.38,0.02-0.57,0.03c-0.48-0.05-0.96-0.07-1.45-0.07
		c-0.14,0-0.27,0.02-0.41,0.02c-0.53-0.06-1.07-0.09-1.62-0.09c-0.1,0-0.19,0.01-0.28,0.01c-0.57-0.07-1.15-0.11-1.74-0.11
		c-0.05,0-0.1,0.01-0.16,0.01c-0.61-0.08-1.23-0.13-1.86-0.13c-0.01,0-0.02,0-0.03,0c-0.59-0.08-1.19-0.13-1.8-0.14
		c-0.58-0.09-1.16-0.14-1.76-0.16c-0.43-0.07-0.88-0.1-1.32-0.14c-0.06-0.81-0.13-1.6-0.22-2.37c-0.45-0.05-1.25-0.13-1.36-0.14
		c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c-0.18,0-0.42,0.82-0.68,2.24c-0.57-0.11-1.15-0.18-1.74-0.22
		c-0.6-0.13-1.22-0.21-1.85-0.26c-0.6-0.13-1.21-0.23-1.84-0.29c-0.6-0.14-1.21-0.25-1.83-0.31c-0.55-0.13-1.11-0.24-1.68-0.31
		c-0.54-0.14-1.1-0.25-1.67-0.33c-0.58-0.16-1.18-0.29-1.79-0.38c-0.75-0.23-1.52-0.39-2.31-0.51c-0.76-0.26-1.55-0.45-2.35-0.58
		c-0.74-0.26-1.5-0.47-2.28-0.61c-0.71-0.26-1.45-0.49-2.21-0.64c-0.62-0.24-1.27-0.44-1.93-0.6c-0.64-0.27-1.31-0.48-1.99-0.65
		c-0.63-0.28-1.29-0.5-1.97-0.69c-0.61-0.28-1.24-0.52-1.9-0.72c-0.56-0.26-1.13-0.5-1.72-0.7c-0.49-0.25-1-0.46-1.51-0.65
		c-0.54-0.29-1.1-0.54-1.67-0.76c-0.52-0.29-1.06-0.56-1.61-0.79c-0.45-0.26-0.92-0.51-1.39-0.72c-0.4-0.25-0.82-0.48-1.25-0.7
		c-0.45-0.3-0.92-0.57-1.4-0.82c-0.42-0.29-0.85-0.57-1.3-0.81c-0.13-0.09-0.26-0.17-0.39-0.26c-0.21-0.69-0.49-1.33-0.85-1.91
		c0-0.01-0.01-0.01-0.01-0.02c0.21,0.08,0.42,0.16,0.63,0.23c0.77,0.39,1.57,0.73,2.41,0.99c0.74,0.35,1.51,0.65,2.31,0.88
		c0.76,0.35,1.56,0.64,2.38,0.86c0.78,0.35,1.6,0.62,2.45,0.83c0.88,0.37,1.8,0.66,2.75,0.86c0.83,0.32,1.7,0.57,2.6,0.74
		c0.85,0.31,1.73,0.55,2.64,0.7c0.87,0.3,1.78,0.52,2.72,0.66c0.9,0.3,1.83,0.5,2.79,0.63c0.97,0.3,1.98,0.5,3.02,0.6
		c0.94,0.26,1.91,0.44,2.92,0.51c0.96,0.25,1.96,0.41,2.99,0.47c1,0.25,2.03,0.39,3.1,0.43c0.57,0.13,1.15,0.22,1.73,0.29
		c-0.01,0.88,0,1.65,0.03,2.29c0.19,0.03,1.2,0.13,1.33,0.15c0,0,0,0,0,0c0.18,0,0.43-0.83,0.72-2.25c0.87,0.16,1.76,0.27,2.68,0.27
		c0.01,0,0.02,0,0.03,0c0.96,0.19,1.96,0.3,2.98,0.3c0.07,0,0.14-0.01,0.21-0.01c0.87,0.16,1.77,0.25,2.69,0.25
		c0.13,0,0.25-0.02,0.38-0.02c0.79,0.13,1.59,0.21,2.42,0.21c0.18,0,0.35-0.02,0.53-0.03c0.71,0.1,1.43,0.17,2.16,0.17
		c0.23,0,0.45-0.02,0.68-0.03c0.63,0.08,1.26,0.14,1.91,0.14c0.28,0,0.55-0.03,0.82-0.04c0.55,0.06,1.11,0.1,1.68,0.1
		c0.35,0,0.68-0.03,1.02-0.05c0.45,0.04,0.91,0.07,1.38,0.07c0.46,0,0.91-0.03,1.36-0.07c0.32,0.02,0.63,0.05,0.95,0.05
		c0.54,0,1.07-0.03,1.6-0.09c0.21,0.01,0.41,0.03,0.62,0.03c0.59,0,1.17-0.04,1.74-0.11c0.13,0,0.26,0.02,0.39,0.02
		c0.64,0,1.26-0.05,1.88-0.13c0.06,0,0.12,0.01,0.17,0.01c0.69,0,1.36-0.06,2.02-0.15c0.77,0,1.53-0.08,2.27-0.2
		c0.74-0.02,1.46-0.09,2.16-0.22c0.7-0.04,1.39-0.11,2.06-0.24c0.66-0.05,1.31-0.12,1.94-0.26c0.61-0.06,1.2-0.15,1.78-0.27
		c0.63-0.06,1.24-0.18,1.84-0.32c0.59-0.07,1.18-0.19,1.75-0.33c0.56-0.08,1.12-0.19,1.66-0.33c0.53-0.09,1.06-0.2,1.57-0.34
		c0.51-0.09,1-0.2,1.49-0.34c0.48-0.09,0.95-0.2,1.41-0.34c0.53-0.11,1.05-0.24,1.56-0.4c0.44-0.1,0.87-0.21,1.3-0.35
		c0.41-0.1,0.82-0.21,1.22-0.34c0.39-0.1,0.77-0.2,1.15-0.32c0.37-0.09,0.73-0.19,1.08-0.31c0.38-0.1,0.76-0.2,1.12-0.33
		c0.45-0.11,0.88-0.25,1.31-0.4c-0.16,0.06-0.33,0.11-0.49,0.17c1.44,0.62,2.85,0.74,4.18,0.33c0,0,0.01,0,0.01,0
		s0.03-0.01,0.06-0.02c0,0,0,0,0.01,0c0,0,0,0,0.01,0c0.21-0.07,0.85-0.28,1.21-0.4c1.44-0.47,2.58-1.57,3.4-3.1
		c0.63-0.23,1.25-0.49,1.84-0.8c0.77-0.28,1.52-0.61,2.23-1c0.76-0.29,1.48-0.64,2.17-1.04c0.81-0.33,1.57-0.73,2.3-1.19
		c0.86-0.38,1.67-0.83,2.44-1.35c0.78-0.38,1.51-0.83,2.21-1.33c0.86-0.46,1.68-0.99,2.43-1.6c0.62-0.37,1.22-0.78,1.78-1.23
		C470.84,403.24,470.63,403.48,470.44,403.73z"
      />
    </g>
    <g id="Tube__x28_Farb-Sektionen_x29_">
      <g id="Abschnitt_5">
        <path
          :style="{
            fill:
              typeof internalColorArray[4] !== 'undefined'
                ? internalColorArray[4]
                : internalColor,
          }"
          :class="{ inactive: index !== 4 && !overview, click: overview }"
          d="M158.19,321.3c0,0-0.48-0.45-0.73-0.69c-1.84-1.52-4.07-1.99-6.37-1.49c-0.16-0.09-0.31-0.18-0.47-0.26
			c-0.44-0.29-0.9-0.56-1.37-0.8c-0.45-0.31-0.92-0.61-1.4-0.87c-0.37-0.27-0.76-0.52-1.16-0.75c-0.37-0.29-0.76-0.56-1.16-0.82
			c-0.42-0.35-0.85-0.67-1.3-0.97c-0.34-0.3-0.7-0.58-1.07-0.85c-0.33-0.32-0.68-0.62-1.05-0.9c-0.37-0.38-0.76-0.74-1.17-1.08
			c-0.27-0.29-0.55-0.56-0.84-0.83c-0.07-0.08-0.14-0.15-0.21-0.23c-0.63-0.34-1.24-0.72-1.81-1.14c-0.84-0.46-1.62-1-2.35-1.61
			c-0.71-0.45-1.37-0.95-1.99-1.51c-0.78-0.54-1.51-1.15-2.18-1.82c-0.69-0.55-1.33-1.16-1.92-1.82c-0.66-0.59-1.28-1.23-1.83-1.93
			c-0.68-0.69-1.3-1.44-1.84-2.25c-0.62-0.73-1.16-1.52-1.63-2.37c-0.56-0.79-1.04-1.63-1.44-2.52c-0.5-0.86-0.92-1.78-1.24-2.74
			c-0.42-0.93-0.75-1.91-0.98-2.94c-0.33-1.01-0.56-2.06-0.67-3.16c-0.02-0.08-0.03-0.17-0.05-0.25c-0.01-0.06-0.02-0.08-0.04-0.11
			c-0.01-0.01-0.03-0.04-0.05-0.11c-0.24-0.52-0.45-1.06-0.64-1.6c-0.01-0.01-0.02-0.02-0.02-0.02c0-0.01-0.01-0.01-0.01-0.03
			c-0.06-0.19-0.11-0.35-0.16-0.53c-0.02-0.06-0.04-0.13-0.06-0.19c-0.11-0.39-0.2-0.75-0.27-1.07c-0.02-0.08-0.03-0.16-0.05-0.24
			c-0.06-0.31-0.11-0.59-0.15-0.86c-0.01-0.05-0.02-0.11-0.03-0.16c-1.8-1.63-4.14-2.71-6.72-3.12c-0.1-0.07-0.19-0.15-0.29-0.22
			c-0.53-0.44-1.1-0.84-1.69-1.21c-0.54-0.43-1.12-0.83-1.72-1.18c-0.54-0.41-1.1-0.78-1.69-1.11c-0.52-0.37-1.06-0.73-1.62-1.03
			c-0.48-0.33-0.98-0.64-1.51-0.92c-0.5-0.34-1.02-0.64-1.56-0.92c-0.78-0.52-1.62-0.97-2.49-1.34c-0.91-0.63-1.9-1.17-2.94-1.59
			c-0.92-0.61-1.91-1.11-2.95-1.51c-0.89-0.56-1.85-1.03-2.86-1.4c-0.87-0.52-1.78-0.95-2.75-1.29c-0.15-0.09-0.32-0.16-0.47-0.24
			c-0.37-0.71-0.79-1.29-1.31-1.84c-0.03-0.04-0.06-0.06-0.06-0.06s-0.47-0.46-0.71-0.71c-2.37-2.03-5.31-2.31-8.23-1.08l0,0
			c-1.02,0.43-2.04,1.05-3.04,1.84c-0.02,0.02-0.04,0.04-0.06,0.05c-0.31,0.25-0.61,0.51-0.92,0.8c-0.05,0.05-0.1,0.1-0.15,0.15
			c-0.27,0.26-0.54,0.53-0.8,0.81c-0.09,0.1-0.18,0.21-0.27,0.32c-0.22,0.25-0.44,0.5-0.66,0.77c-0.15,0.19-0.3,0.4-0.45,0.6
			c-0.15,0.2-0.31,0.4-0.46,0.61c-0.3,0.43-0.59,0.87-0.87,1.33c-0.28,0.45-0.53,0.91-0.78,1.38c-0.08,0.16-0.16,0.32-0.24,0.48
			c-0.15,0.31-0.31,0.61-0.45,0.92c-0.09,0.2-0.17,0.4-0.26,0.6c-0.12,0.27-0.23,0.54-0.34,0.82c-0.09,0.22-0.16,0.44-0.24,0.67
			c-0.09,0.25-0.18,0.5-0.26,0.75c-0.08,0.24-0.15,0.48-0.22,0.72c-0.07,0.23-0.13,0.46-0.19,0.69c-0.07,0.26-0.13,0.52-0.18,0.78
			c-0.05,0.21-0.09,0.42-0.13,0.62c-0.05,0.28-0.1,0.55-0.15,0.83c-0.03,0.18-0.05,0.36-0.08,0.54c-0.04,0.3-0.08,0.6-0.1,0.89
			c-0.01,0.14-0.02,0.28-0.03,0.43c-0.02,0.33-0.04,0.66-0.05,0.98c0,0.09,0,0.17,0,0.26c-0.05,3.61,0.86,6.88,2.76,9.14
			c0.77,0.89,1.3,1.17,1.3,1.17s0.06,0.04,0.06,0.04c1.44,0.96,3.54,1.27,5.28,0.98c0.01,0,0.01-0.01,0.03-0.01
			c0.1,0.04,0.21,0.09,0.31,0.12c0.74,0.42,1.51,0.78,2.32,1.07c0.75,0.45,1.54,0.83,2.36,1.15c0.75,0.48,1.55,0.89,2.39,1.23
			c0.78,0.52,1.61,0.97,2.49,1.34c0.54,0.37,1.1,0.71,1.68,1.01c0.41,0.27,0.84,0.53,1.28,0.76c0.42,0.28,0.85,0.55,1.29,0.79
			c0.38,0.27,0.78,0.51,1.19,0.74c0.37,0.26,0.75,0.51,1.14,0.74c0.36,0.27,0.72,0.52,1.1,0.76c0.33,0.27,0.68,0.51,1.04,0.75
			c0.2,0.41,0.43,0.8,0.67,1.18c0.26,0.39,0.78,1.12,0.78,1.12s0.02,0.01,0.05,0.02c1.58,2.18,3.74,3.7,6.16,4.54
			c0.31,0.38,0.62,0.76,0.97,1.11c0.27,0.37,0.56,0.73,0.87,1.07c0.32,0.48,0.68,0.94,1.05,1.38c0.29,0.46,0.61,0.91,0.95,1.34
			c0.27,0.46,0.57,0.91,0.88,1.34c0.29,0.56,0.62,1.09,0.98,1.6c0.26,0.53,0.54,1.05,0.86,1.54c0.17,0.39,0.36,0.76,0.56,1.13
			c0.13,2.02,0.66,3.93,1.58,5.59c0.23,0.4,0.7,1.17,0.7,1.17s0.02,0.01,0.04,0.02c1.43,2.3,3.48,3.97,5.85,4.98
			c0.01,0,0.01,0.01,0.02,0.01c0.08,0.09,0.15,0.17,0.24,0.26c0.51,0.65,1.07,1.25,1.67,1.8c0.6,0.71,1.25,1.37,1.97,1.96
			c0.53,0.57,1.11,1.11,1.73,1.59c0.59,0.6,1.24,1.15,1.93,1.65c0.61,0.58,1.27,1.12,1.98,1.59c0.57,0.5,1.17,0.95,1.81,1.35
			c0.63,0.52,1.3,0.99,2.01,1.4c0.65,0.5,1.33,0.97,2.06,1.36c0.59,0.42,1.2,0.81,1.85,1.14c0.6,0.42,1.24,0.79,1.91,1.11
			c0.65,0.43,1.34,0.8,2.05,1.13c0.65,0.4,1.32,0.77,2.02,1.07c0.17,0.1,0.34,0.18,0.51,0.27c0.38,0.63,0.81,1.23,1.31,1.75
			c1.33,1.32,2.92,1.7,3.99,1.82c0.44,0.04,1.02,0.09,1.57,0.03c0.29-0.02,0.59-0.06,0.9-0.12c-1.06-0.36-2.41-0.94-2.83-1.2
			c-0.46-0.24-0.86-0.49-1.28-0.85c-4.22-3.66-4.58-12.57-0.75-19.67c3.32-6.14,8.67-9.07,12.78-7.38c0.18,0.07,0.67,0.28,1.29,0.53
			c0.71,0.3,1.58,0.66,2.34,0.99C159.23,322.46,158.74,321.85,158.19,321.3C158.2,321.31,158.19,321.3,158.19,321.3z M99.91,305.87
			c0.06,0.06,0.12,0.13,0.19,0.19c0.15,0.19,0.33,0.35,0.49,0.53C100.36,306.34,100.13,306.1,99.91,305.87z"
        />
      </g>
      <g id="Abschnitt_4">
        <path
          :style="{
            fill:
              typeof internalColorArray[3] !== 'undefined'
                ? internalColorArray[3]
                : internalColor,
          }"
          :class="{ inactive: index !== 3 && !overview, click: overview }"
          d="M274.19,308.21c0-0.08,0-0.16,0-0.24c0-0.54-0.02-1.09-0.05-1.66c0-0.05,0-0.09-0.01-0.14
			c-0.04-0.62-0.09-1.26-0.16-1.92c-0.01-0.07-0.02-0.15-0.03-0.23c-0.06-0.55-0.14-1.11-0.23-1.68c-0.03-0.19-0.06-0.39-0.09-0.58
			c-0.08-0.48-0.17-0.97-0.27-1.47c-0.04-0.2-0.08-0.4-0.12-0.6c-0.14-0.68-0.3-1.36-0.48-2.06c-0.13-0.53-0.28-1.04-0.42-1.55
			c-0.04-0.12-0.07-0.24-0.11-0.36c-0.15-0.49-0.3-0.98-0.45-1.45c-0.02-0.07-0.05-0.14-0.07-0.22c-0.14-0.41-0.28-0.81-0.42-1.2
			c-0.05-0.14-0.1-0.28-0.15-0.41c-0.16-0.42-0.32-0.83-0.48-1.23c-0.06-0.15-0.12-0.29-0.18-0.43c-0.11-0.27-0.23-0.53-0.35-0.79
			c-0.08-0.17-0.16-0.35-0.24-0.52c-0.15-0.32-0.3-0.64-0.46-0.95c-0.1-0.21-0.21-0.4-0.31-0.6c-0.07-0.14-0.14-0.27-0.22-0.4
			c-0.39-0.7-0.78-1.35-1.17-1.94c-0.03-0.04-0.05-0.08-0.08-0.12c-0.43-0.63-0.86-1.19-1.28-1.66c0,0,0,0,0,0l0,0
			c-1.28-1.43-2.51-2.15-3.52-1.9c-0.32,0.08-0.7,0.17-0.86,0.2c0,0,0,0,0,0c-0.01,0-0.02,0-0.02,0c-0.99,0.25-1.67,1.44-2.04,3.27
			c-0.3,0.07-0.59,0.16-0.88,0.25c-0.58,0.11-1.16,0.25-1.72,0.43c-0.57,0.11-1.13,0.24-1.67,0.42c-0.55,0.11-1.1,0.24-1.62,0.4
			c-0.53,0.1-1.06,0.23-1.57,0.39c-0.51,0.1-1.01,0.22-1.49,0.37c-0.49,0.1-0.97,0.22-1.44,0.36c-0.47,0.09-0.93,0.21-1.38,0.34
			c-0.45,0.09-0.89,0.2-1.32,0.33c-0.43,0.08-0.84,0.19-1.25,0.31c-0.47,0.09-0.94,0.21-1.4,0.35c-0.47,0.09-0.94,0.2-1.39,0.33
			c-0.49,0.09-0.96,0.19-1.43,0.33c-0.5,0.08-0.99,0.19-1.47,0.32c-0.51,0.08-1.01,0.18-1.51,0.31c-0.52,0.07-1.03,0.17-1.54,0.3
			c-0.53,0.07-1.06,0.17-1.57,0.29c-0.54,0.06-1.08,0.16-1.6,0.28c-0.58,0.06-1.15,0.16-1.7,0.29c-0.59,0.06-1.17,0.15-1.74,0.28
			c-0.6,0.05-1.19,0.14-1.77,0.26c-0.61,0.05-1.21,0.13-1.79,0.25c-0.61,0.05-1.2,0.12-1.79,0.24c-0.6,0.04-1.19,0.11-1.76,0.22
			c-0.6,0.04-1.2,0.1-1.78,0.21c-0.61,0.03-1.2,0.09-1.79,0.19c-0.61,0.02-1.21,0.08-1.8,0.17c-0.62,0.01-1.22,0.07-1.81,0.16
			c-0.62,0.01-1.22,0.06-1.82,0.14c-0.65,0-1.29,0.06-1.92,0.14c-0.03,0-0.06,0-0.09,0c-0.62,0-1.23,0.05-1.84,0.12
			c-0.06,0-0.13-0.01-0.19-0.01c-0.59,0-1.17,0.04-1.75,0.11c-0.1,0-0.19-0.01-0.29-0.01c-0.18,0-0.35,0.02-0.53,0.03
			c-0.23-1.45-0.44-2.28-0.62-2.27l0,0c0,0-1.11,0.01-1.42,0.02c-0.08,0.59-0.15,1.39-0.22,2.34c-0.27,0.01-0.54,0.01-0.8,0.04
			c-0.16-0.01-0.32-0.02-0.49-0.02c-0.46,0-0.92,0.03-1.37,0.07c-0.22-0.01-0.45-0.03-0.67-0.03c-0.39,0-0.78,0.03-1.16,0.06
			c-0.29-0.02-0.58-0.04-0.88-0.04c-0.32,0-0.63,0.03-0.94,0.05c-0.36-0.03-0.73-0.06-1.1-0.06c-0.24,0-0.48,0.02-0.72,0.04
			c-0.43-0.04-0.87-0.07-1.31-0.07c-0.17,0-0.33,0.02-0.49,0.02c-0.51-0.05-1.02-0.08-1.54-0.08c-0.13,0-0.25,0.02-0.37,0.02
			c-0.54-0.06-1.09-0.1-1.65-0.1c-0.08,0-0.16,0.01-0.25,0.01c-0.58-0.07-1.17-0.11-1.77-0.11c-0.04,0-0.08,0.01-0.12,0.01
			c-0.61-0.08-1.23-0.13-1.85-0.13c-0.56-0.08-1.14-0.12-1.72-0.14c-0.56-0.09-1.12-0.14-1.69-0.16c-0.55-0.09-1.1-0.16-1.67-0.19
			c-0.55-0.11-1.11-0.17-1.69-0.22c-0.57-0.12-1.16-0.2-1.76-0.25c-0.57-0.12-1.14-0.22-1.73-0.28c-0.52-0.12-1.05-0.21-1.6-0.28
			c-0.52-0.13-1.05-0.23-1.59-0.3c-0.58-0.16-1.17-0.29-1.78-0.38c-0.64-0.21-1.31-0.37-1.99-0.49c-0.64-0.22-1.29-0.42-1.96-0.55
			c-0.54-0.2-1.1-0.37-1.67-0.51c-0.6-0.25-1.23-0.45-1.87-0.63c-0.6-0.27-1.21-0.5-1.85-0.69c-0.32-0.15-0.66-0.27-1-0.4
			c-0.45-0.89-1.04-1.65-1.72-2.29c0.15,0.14,0.27,0.3,0.41,0.45c-0.01-0.03-0.01-0.04-0.01-0.04s-0.46-0.47-0.7-0.72
			c-1.77-1.59-3.97-2.15-6.29-1.75c-0.18-0.12-0.35-0.25-0.53-0.36c-0.35-0.3-0.72-0.57-1.1-0.84c-0.23-0.21-0.46-0.41-0.7-0.6
			c-0.23-0.23-0.48-0.45-0.73-0.67c-0.06-0.07-0.13-0.14-0.19-0.21c0.08-0.41,0.14-0.82,0.19-1.24c0.06-0.07,0.13-0.13,0.19-0.2
			c0.33-0.28,0.65-0.57,0.96-0.87c0.26-0.21,0.51-0.42,0.76-0.65c0.32-0.23,0.64-0.47,0.95-0.72c0.34-0.22,0.66-0.47,0.98-0.71
			c0.32-0.19,0.63-0.39,0.93-0.61c0.42-0.23,0.83-0.48,1.22-0.75c0.37-0.19,0.73-0.4,1.09-0.63c0.37-0.18,0.74-0.36,1.09-0.57
			c0.48-0.2,0.94-0.43,1.39-0.68c0.44-0.18,0.87-0.38,1.29-0.59c0.42-0.16,0.84-0.33,1.24-0.52c0.17-0.06,0.34-0.13,0.51-0.2
			c2.01,0.37,3.99,0.12,5.76-0.81c-0.03,0.02-0.06,0.04-0.09,0.05c0,0,0,0,0,0s1.04-0.5,2.08-1.32c1.14-0.86,2.04-2,2.73-3.32
			c0.02-0.04,0.04-0.08,0.06-0.12c0.15-0.29,0.28-0.58,0.4-0.89c0.01-0.04,0.03-0.07,0.04-0.11c0.5-1.27,0.82-2.66,0.96-4.14
			c0.01-0.1,0.02-0.2,0.03-0.3c0.02-0.29,0.03-0.58,0.04-0.88c0-0.16,0.01-0.31,0.01-0.47c0-0.27,0-0.55-0.02-0.83
			c-0.01-0.19-0.02-0.38-0.04-0.58c-0.02-0.26-0.04-0.51-0.06-0.77c-0.03-0.25-0.07-0.5-0.1-0.76c-0.04-0.3-0.09-0.6-0.15-0.9
			c-0.07-0.35-0.14-0.71-0.23-1.06c-0.05-0.19-0.1-0.37-0.15-0.56c-0.08-0.29-0.16-0.59-0.25-0.88c-0.06-0.19-0.13-0.38-0.19-0.57
			c-0.1-0.29-0.21-0.59-0.32-0.88c-0.07-0.18-0.14-0.36-0.22-0.54c-0.13-0.32-0.28-0.63-0.43-0.94c-0.07-0.15-0.14-0.3-0.21-0.45
			c-0.23-0.46-0.47-0.91-0.74-1.36c-0.28-0.47-0.57-0.92-0.87-1.35c-0.14-0.2-0.28-0.38-0.42-0.57c-0.16-0.22-0.32-0.45-0.49-0.66
			c-0.2-0.25-0.41-0.48-0.61-0.72c-0.11-0.13-0.23-0.27-0.34-0.39c-0.25-0.27-0.5-0.52-0.76-0.77c-0.08-0.07-0.15-0.15-0.23-0.22
			c-0.29-0.27-0.59-0.52-0.88-0.76c-0.04-0.04-0.09-0.08-0.13-0.11c-0.32-0.26-0.65-0.5-0.99-0.72c-0.02-0.01-0.04-0.03-0.06-0.04
			c-0.35-0.23-0.7-0.45-1.06-0.65c0,0-0.01,0-0.01-0.01c-0.36-0.2-0.73-0.38-1.1-0.54c0,0,0,0,0,0l0,0
			c-3.31-1.45-6.81-1.33-9.8,0.64c-0.31,0.23-0.89,0.67-0.89,0.67s0,0.01-0.01,0.02c-0.66,0.54-1.23,1.18-1.73,1.88
			c-0.01,0.02-0.01,0.03-0.02,0.04c-0.03,0.01-0.05,0.02-0.08,0.04c-0.76,0.25-1.5,0.56-2.2,0.93c-0.72,0.26-1.42,0.57-2.08,0.94
			c-0.66,0.26-1.3,0.58-1.91,0.93c-0.74,0.32-1.45,0.7-2.13,1.13c-0.71,0.34-1.4,0.71-2.05,1.15c-0.63,0.33-1.24,0.7-1.82,1.12
			c-0.71,0.39-1.38,0.85-2.02,1.34c-0.65,0.4-1.28,0.84-1.87,1.33c-0.64,0.42-1.23,0.9-1.8,1.41c-0.67,0.48-1.3,1-1.88,1.58
			c-0.61,0.48-1.17,1.01-1.69,1.57c-0.79,0.67-1.51,1.42-2.15,2.23c-0.81,0.77-1.53,1.63-2.15,2.57c-0.46,0.54-0.88,1.11-1.26,1.71
			c-3.09,2.31-5.37,5.72-6.15,9.8c-0.67,3.46-0.16,6.86,1.23,9.83c0.03,0.07,0.04,0.1,0.05,0.11c0.02,0.03,0.02,0.05,0.04,0.11
			c0.01,0.08,0.03,0.17,0.05,0.25c0.11,1.09,0.34,2.15,0.67,3.16c0.22,1.02,0.56,2,0.98,2.94c0.32,0.96,0.74,1.87,1.24,2.74
			c0.4,0.89,0.88,1.73,1.44,2.52c0.47,0.84,1.02,1.63,1.63,2.37c0.54,0.81,1.16,1.56,1.84,2.25c0.55,0.7,1.16,1.34,1.83,1.93
			c0.59,0.66,1.23,1.27,1.92,1.82c0.66,0.67,1.39,1.28,2.18,1.82c0.62,0.56,1.28,1.06,1.99,1.51c0.73,0.61,1.52,1.15,2.35,1.61
			c0.68,0.51,1.4,0.96,2.16,1.35c0.55,0.38,1.14,0.72,1.74,1.03c0.34,0.6,0.72,1.18,1.17,1.69c1.27,1.37,2.85,1.82,3.91,1.98
			c0.38,0.05,0.5,0.07,0.97,0.09c0.48,0.02,0.98,0,1.5-0.08c-0.03-0.01-0.07-0.03-0.1-0.04c0.16,0.06,0.32,0.13,0.48,0.18
			c0.82,0.42,1.68,0.77,2.58,1.04c0.79,0.38,1.62,0.68,2.48,0.92c0.81,0.36,1.67,0.65,2.55,0.87c0.9,0.38,1.84,0.67,2.82,0.86
			c0.83,0.31,1.69,0.55,2.59,0.71c0.84,0.29,1.71,0.51,2.61,0.65c0.84,0.27,1.72,0.46,2.61,0.59c0.76,0.22,1.54,0.38,2.35,0.47
			c0.7,0.17,1.41,0.31,2.14,0.38c0.67,0.15,1.35,0.26,2.05,0.32c0.67,0.15,1.36,0.24,2.07,0.29c0.71,0.15,1.44,0.23,2.18,0.27
			c0.73,0.14,1.47,0.22,2.23,0.24c0.73,0.13,1.48,0.2,2.25,0.22c0.74,0.11,1.48,0.19,2.25,0.19c0.66,0.09,1.34,0.15,2.02,0.15
			c0.04,0,0.08-0.01,0.12-0.01c0.62,0.08,1.25,0.13,1.89,0.13c0.08,0,0.16-0.01,0.25-0.01c0.58,0.07,1.17,0.11,1.77,0.11
			c0.13,0,0.25-0.02,0.37-0.02c0.54,0.06,1.09,0.1,1.65,0.1c0.17,0,0.33-0.02,0.49-0.02c0.51,0.05,1.02,0.08,1.54,0.08
			c0.24,0,0.48-0.02,0.72-0.04c0.43,0.04,0.87,0.07,1.31,0.07c0.32,0,0.63-0.03,0.94-0.05c0.36,0.03,0.73,0.06,1.1,0.06
			c0.39,0,0.78-0.03,1.16-0.06c0.29,0.02,0.58,0.04,0.88,0.04c0.46,0,0.92-0.03,1.37-0.07c0.22,0.01,0.45,0.03,0.67,0.03
			c0.52,0,1.04-0.03,1.55-0.08c0.16,0.01,0.32,0.02,0.49,0.02c0.29,0,0.57-0.03,0.85-0.05c0.17,0.79,0.34,1.55,0.54,2.3
			c0.45-0.01,1.27-0.04,1.37-0.04c0,0,0,0,0,0c0.18-0.02,0.3-0.87,0.37-2.33c0.22-0.02,0.44-0.04,0.66-0.06
			c0.1,0,0.19,0.01,0.29,0.01c0.62,0,1.23-0.05,1.84-0.12c0.06,0,0.13,0.01,0.19,0.01c0.65,0,1.29-0.06,1.92-0.14
			c0.03,0,0.06,0,0.09,0c0.68,0,1.35-0.06,2.01-0.15c0.74,0,1.47-0.07,2.18-0.18c0.74-0.01,1.46-0.08,2.16-0.19
			c0.73-0.02,1.44-0.09,2.14-0.21c0.72-0.03,1.43-0.1,2.12-0.22c0.71-0.03,1.42-0.11,2.1-0.24c0.71-0.04,1.4-0.12,2.08-0.25
			c0.68-0.05,1.35-0.13,2.01-0.26c0.66-0.05,1.32-0.14,1.95-0.27c0.66-0.06,1.3-0.15,1.93-0.29c0.65-0.06,1.28-0.16,1.9-0.3
			c0.64-0.06,1.27-0.17,1.88-0.31c0.66-0.07,1.3-0.19,1.92-0.34c0.64-0.07,1.27-0.2,1.89-0.35c0.63-0.08,1.25-0.2,1.85-0.36
			c0.62-0.09,1.22-0.21,1.82-0.37c0.6-0.09,1.2-0.22,1.78-0.38c0.59-0.1,1.17-0.22,1.73-0.38c0.57-0.1,1.13-0.23,1.68-0.39
			c0.46-0.09,0.92-0.2,1.37-0.33c0.45-0.09,0.89-0.2,1.33-0.33c0.47-0.09,0.93-0.21,1.39-0.34c0.49-0.1,0.97-0.22,1.45-0.36
			c0.51-0.1,1.01-0.22,1.5-0.37c0.53-0.1,1.05-0.23,1.55-0.39c0.54-0.11,1.06-0.24,1.58-0.4c0.55-0.11,1.1-0.24,1.63-0.41
			c0.57-0.11,1.13-0.25,1.67-0.42c0.59-0.11,1.16-0.26,1.72-0.43c0.31-0.06,0.61-0.13,0.91-0.2c0.01,0,0.01,0.01,0.01,0.01
			c1.16,1.38,2.29,2.08,3.26,1.88c0,0,0.01,0.01,0.01,0.01s0.59-0.13,0.95-0.22c1.48-0.38,2.39-2.77,2.6-6.29c0-0.01,0-0.01,0-0.02
			C274.18,309.3,274.19,308.76,274.19,308.21z"
        />
      </g>
      <g id="Abschnitt_3_1_">
        <path
          :style="{
            fill:
              typeof internalColorArray[2] !== 'undefined'
                ? internalColorArray[2]
                : internalColor,
          }"
          :class="{ inactive: index !== 2 && !overview, click: overview }"
          d="M515.3,303.52c-0.07-0.39-0.15-0.78-0.25-1.16c-0.12-0.87-0.3-1.71-0.56-2.52c-0.18-0.9-0.45-1.76-0.78-2.59
			c-0.23-0.84-0.52-1.64-0.88-2.41c-0.29-0.87-0.66-1.71-1.1-2.51c-0.35-0.85-0.78-1.67-1.28-2.43c-0.39-0.79-0.84-1.54-1.35-2.24
			c-0.47-0.84-1.01-1.62-1.63-2.35c-0.51-0.79-1.1-1.52-1.75-2.2c-0.53-0.72-1.13-1.39-1.78-2c-0.15-0.19-0.32-0.36-0.49-0.53
			c0,0-0.01,0-0.01,0c-0.46-1.88-1.43-3.48-2.93-4.6c0,0,0,0,0,0s-0.87-0.69-2.02-1.22c-2.3-1.15-5.15-1.2-8.08-0.37
			c-0.03,0.01-0.07,0.02-0.1,0.03c-0.32,0.09-0.64,0.2-0.96,0.31c-0.05,0.02-0.1,0.04-0.16,0.06c-0.92,0.33-1.83,0.75-2.73,1.25
			c-0.14,0.07-0.27,0.15-0.4,0.22c-0.22,0.13-0.44,0.27-0.67,0.4c-0.18,0.11-0.36,0.23-0.54,0.35c-0.2,0.13-0.39,0.26-0.59,0.4
			c-0.23,0.16-0.45,0.33-0.67,0.5c-0.15,0.11-0.3,0.22-0.44,0.34c-0.36,0.29-0.71,0.59-1.05,0.9c-0.12,0.11-0.23,0.22-0.35,0.33
			c-0.25,0.23-0.49,0.47-0.72,0.72c-0.12,0.13-0.25,0.26-0.37,0.39c-0.23,0.25-0.46,0.51-0.69,0.78c-0.1,0.12-0.21,0.24-0.31,0.37
			c-0.32,0.39-0.63,0.79-0.92,1.21c-0.31,0.44-0.6,0.88-0.87,1.31c-0.11,0.18-0.21,0.36-0.31,0.54c-0.15,0.25-0.3,0.51-0.43,0.76
			c-0.13,0.24-0.24,0.48-0.35,0.72c-0.09,0.19-0.18,0.38-0.27,0.57c-0.12,0.28-0.23,0.56-0.34,0.83c-0.05,0.14-0.11,0.28-0.16,0.43
			c-0.11,0.31-0.21,0.62-0.3,0.93c-0.03,0.1-0.06,0.2-0.09,0.3c-0.09,0.34-0.17,0.68-0.24,1.01c-0.01,0.06-0.02,0.12-0.04,0.18
			c-0.07,0.36-0.12,0.72-0.16,1.07c0,0.03-0.01,0.06-0.01,0.09c-0.44,4.08,1.04,7.62,4.4,9.58c0.33,0.17,0.96,0.48,0.96,0.48
			s0.02,0,0.04-0.01c0.71,0.32,1.47,0.53,2.26,0.66c0.02,0.02,0.03,0.03,0.03,0.03s0.02,0.02,0.03,0.03
			c0.17,0.24,0.35,0.47,0.54,0.7c0.14,0.22,0.3,0.43,0.45,0.65c0.15,0.28,0.32,0.55,0.49,0.81c0.11,0.23,0.22,0.46,0.34,0.68
			c0.09,0.22,0.2,0.44,0.3,0.65c0.06,0.19,0.14,0.38,0.21,0.57c-0.1,0.4-0.15,0.66-0.15,0.66s0,0,0,0c0.01-0.03,0.02-0.07,0.03-0.1
			c-0.43,1.96-0.13,3.95,0.78,5.8c-0.03,0.27-0.06,0.54-0.08,0.81c-0.06,0.38-0.1,0.76-0.12,1.15c-0.06,0.4-0.1,0.81-0.13,1.22
			c-0.07,0.44-0.12,0.88-0.14,1.34c-0.08,0.48-0.13,0.96-0.16,1.45c-0.08,0.51-0.14,1.03-0.17,1.56c-0.04,0.23-0.05,0.47-0.08,0.7
			c-0.41,0.57-0.76,1.18-1.03,1.83c-0.53,1.21-0.75,2.34-0.75,2.34s0,0,0,0c0.01-0.03,0.02-0.07,0.03-0.1
			c-0.44,1.89-0.18,3.82,0.64,5.63c-0.02,0.26-0.05,0.52-0.06,0.78c-0.13,0.69-0.2,1.39-0.24,2.11c-0.14,0.7-0.21,1.43-0.24,2.16
			c-0.14,0.72-0.22,1.46-0.25,2.2c-0.14,0.73-0.22,1.48-0.25,2.24c-0.08,0.38-0.13,0.77-0.17,1.16c-0.41,0.57-0.76,1.18-1.03,1.83
			c-0.53,1.21-0.75,2.34-0.75,2.34s0,0,0,0c0.01-0.03,0.02-0.07,0.03-0.1c-0.44,1.91-0.18,3.85,0.66,5.68
			c-0.02,0.21-0.04,0.43-0.05,0.64c-0.15,0.76-0.23,1.54-0.27,2.33c-0.15,0.75-0.23,1.53-0.26,2.32c-0.15,0.75-0.23,1.52-0.26,2.3
			c-0.07,0.36-0.13,0.73-0.17,1.1c0.6,0.77,1.13,1.6,1.58,2.48c0.67,1,1.21,2.1,1.62,3.25c0.56,1.12,1,2.31,1.26,3.56
			c0.39,1.11,0.65,2.28,0.76,3.49c0.6,1.58,0.97,3.28,1.03,5.06c0.12,3.46-0.89,6.7-2.69,9.37c-0.07,0.11-0.08,0.12-0.07,0.06
			c-0.15,0.35-0.29,0.71-0.48,1.05c-0.42,1.09-0.96,2.12-1.61,3.07c-0.52,0.99-1.14,1.92-1.86,2.77c-0.6,0.91-1.28,1.76-2.06,2.52
			c-0.64,0.82-1.36,1.57-2.16,2.24c-0.63,0.69-1.32,1.32-2.07,1.89c-0.73,0.72-1.53,1.36-2.39,1.93c-0.1,0.09-0.21,0.17-0.32,0.25
			c-0.25,0.27-0.49,0.56-0.72,0.85c-0.35,0.35-0.69,0.72-1,1.11c-1.54,0.64-2.93,1.58-4.07,2.86c-0.1,0.12-0.19,0.24-0.29,0.36
			c-0.05,0.06-0.11,0.1-0.17,0.16c-0.53,0.59-0.96,1.22-1.34,1.89c0.65-0.62,1.37-1.16,2.14-1.64l0,0c1.26-0.79,2.65-1.39,4.12-1.77
			c0,0,0.01,0,0.01,0c0.25-0.07,0.51-0.12,0.77-0.17c0.07-0.01,0.14-0.03,0.21-0.04c0.23-0.04,0.47-0.08,0.7-0.12
			c0.1-0.01,0.2-0.03,0.29-0.04c0.22-0.03,0.45-0.05,0.67-0.07c0.11-0.01,0.23-0.01,0.34-0.02c0.22-0.01,0.43-0.03,0.65-0.03
			c0.13,0,0.26,0,0.38,0.01c0.34,0,0.68,0.02,1.02,0.04c0.19,0.01,0.39,0.03,0.58,0.05c0.15,0.02,0.31,0.04,0.46,0.06
			c0.2,0.03,0.4,0.06,0.6,0.09c0.15,0.03,0.3,0.06,0.45,0.09c0.21,0.04,0.42,0.09,0.63,0.15c0.14,0.04,0.28,0.07,0.42,0.11
			c0.23,0.07,0.46,0.14,0.69,0.21c0.12,0.04,0.23,0.07,0.35,0.11c0.35,0.12,0.69,0.25,1.03,0.4c7.69,3.32,11.72,11.89,8.61,18.99
			c-0.74,1.68-2.17,3.16-2.95,3.95c-0.78,0.79-1.16,1.06-1.54,1.36c-0.14,0.11-0.38,0.31-0.61,0.5c1.85-0.61,3.52-1.64,4.86-3.12
			c0.1-0.12,0.19-0.24,0.29-0.36c0,0,0,0,0,0c0.05-0.06,0.11-0.11,0.17-0.16c0.75-0.84,1.34-1.77,1.8-2.76
			c0.2-0.22,0.41-0.44,0.6-0.67c0.56-0.53,1.08-1.1,1.56-1.71c0.62-0.61,1.17-1.29,1.67-2c0.53-0.58,1.02-1.2,1.45-1.86
			c0.51-0.6,0.96-1.26,1.37-1.94c0.5-0.64,0.96-1.32,1.35-2.04c0.42-0.59,0.78-1.22,1.11-1.87c0.43-0.66,0.81-1.36,1.13-2.08
			c0.36-0.61,0.68-1.25,0.95-1.91c0.36-0.67,0.66-1.37,0.92-2.09c0.32-0.67,0.61-1.35,0.84-2.07c0.27-0.63,0.49-1.28,0.68-1.95
			c0.26-0.66,0.48-1.35,0.64-2.06c0.07-0.19,0.13-0.38,0.19-0.57c0.01,0,0.02-0.01,0.02-0.01c0.65-0.58,1.21-1.22,1.67-1.93
			c0.01,0,0.02-0.01,0.02-0.01s0.37-0.63,0.57-0.96c1.49-2.94,1.37-6.12-0.08-9.05c0.01-0.08,0.02-0.16,0.03-0.24
			c0.07-0.44,0.12-0.88,0.15-1.33c0.08-0.48,0.13-0.96,0.17-1.45c0.09-0.51,0.14-1.03,0.18-1.55c0.09-0.54,0.16-1.09,0.19-1.65
			c0.1-0.57,0.17-1.15,0.2-1.75c0.11-0.6,0.17-1.21,0.21-1.83c0.11-0.62,0.18-1.26,0.22-1.91c0.06-0.31,0.1-0.63,0.14-0.95
			c0,0,0-0.01,0-0.01c0.55-0.66,1.02-1.38,1.37-2.15c0.01,0,0.02-0.01,0.02-0.01s0.28-0.68,0.42-1.03c0.87-2.61,0.6-5.22-0.58-7.57
			c0.04-0.34,0.06-0.69,0.08-1.04c0.15-0.74,0.23-1.5,0.26-2.28c0.15-0.75,0.23-1.52,0.26-2.3c0.15-0.75,0.23-1.53,0.26-2.32
			c0.15-0.76,0.23-1.54,0.27-2.33c0.01-0.07,0.02-0.14,0.03-0.21c0.55-0.66,1.02-1.38,1.37-2.14c0.01,0,0.02-0.01,0.02-0.01
			s0.28-0.68,0.42-1.03c0.87-2.6,0.6-5.2-0.57-7.55c0.02-0.21,0.04-0.43,0.05-0.64c0.15-0.73,0.22-1.49,0.26-2.26
			c0.14-0.72,0.22-1.46,0.25-2.22c0.14-0.71,0.21-1.44,0.25-2.18c0.13-0.69,0.21-1.4,0.24-2.13c0.01-0.06,0.02-0.12,0.03-0.19
			c0,0,0.01-0.01,0.01-0.01c0.55-0.66,1.02-1.38,1.37-2.15c0.01,0,0.02-0.01,0.02-0.01s0.28-0.68,0.42-1.03
			c0.88-2.62,0.6-5.25-0.6-7.62c0.01-0.11,0.03-0.21,0.04-0.32c0.09-0.52,0.15-1.05,0.18-1.58c0.08-0.49,0.14-0.98,0.17-1.48
			c0.07-0.45,0.12-0.91,0.15-1.37c0.06-0.41,0.11-0.83,0.14-1.25c0.06-0.39,0.1-0.79,0.13-1.19c0.02-0.14,0.03-0.28,0.05-0.42
			c0.55-0.67,1-1.39,1.35-2.17c0.01,0,0.02-0.01,0.02-0.01s0.27-0.68,0.41-1.04C518.52,309.8,517.66,306.35,515.3,303.52z
			 M485.91,312.7c0,0.02,0,0.03-0.01,0.05c0-0.04,0.01-0.09,0.01-0.13C485.92,312.65,485.91,312.68,485.91,312.7z"
        />
      </g>
      <g
        id="Abschnitt_2"
        :style="{
          fill:
            typeof internalColorArray[1] !== 'undefined'
              ? internalColorArray[1]
              : internalColor,
        }"
        :class="{ inactive: index !== 1 && !overview, click: overview }"
      >
        <path
          d="M485.81,372.66c-0.12-1.21-0.38-2.38-0.76-3.49c-0.27-1.25-0.7-2.45-1.26-3.56
			c-0.41-1.15-0.95-2.25-1.62-3.25c-0.52-1.03-1.13-2-1.86-2.87c-0.6-0.93-1.28-1.8-2.06-2.57c-0.65-0.84-1.38-1.6-2.19-2.28
			c-0.66-0.72-1.4-1.38-2.19-1.96c-0.71-0.68-1.49-1.29-2.33-1.83c-0.77-0.65-1.61-1.24-2.5-1.73c-0.7-0.52-1.45-0.98-2.24-1.37
			c-0.8-0.55-1.65-1.02-2.55-1.41c-0.74-0.45-1.51-0.84-2.32-1.16c-0.73-0.42-1.5-0.77-2.31-1.06c-0.07-0.04-0.14-0.06-0.2-0.1
			c-0.39-0.68-0.82-1.24-1.34-1.76c-0.03-0.03-0.06-0.06-0.06-0.06s-0.48-0.45-0.74-0.68c-2.23-1.78-4.87-2.08-7.51-1.12
			c-0.52-0.18-1.04-0.34-1.59-0.47c-0.68-0.25-1.38-0.47-2.1-0.62c-0.62-0.22-1.26-0.4-1.92-0.54c-0.57-0.19-1.14-0.34-1.74-0.46
			c-0.55-0.17-1.12-0.31-1.69-0.42c-0.51-0.15-1.03-0.27-1.56-0.37c-0.47-0.13-0.95-0.24-1.44-0.33c-0.48-0.13-0.98-0.24-1.48-0.33
			c-0.5-0.13-1-0.24-1.52-0.32c-0.51-0.13-1.03-0.24-1.57-0.32c-0.53-0.13-1.07-0.24-1.62-0.32c-0.55-0.13-1.11-0.24-1.68-0.31
			c-0.57-0.13-1.15-0.24-1.74-0.3c-0.57-0.13-1.16-0.23-1.75-0.28c-0.57-0.12-1.16-0.2-1.75-0.26c-0.62-0.13-1.26-0.2-1.9-0.25
			c-0.65-0.12-1.31-0.2-1.98-0.23c-0.67-0.12-1.36-0.19-2.06-0.22c-0.7-0.12-1.42-0.19-2.15-0.21c-0.73-0.11-1.48-0.19-2.24-0.19
			c-0.67-0.09-1.36-0.16-2.06-0.16c-0.05,0-0.09,0.01-0.14,0.01c-0.65-0.08-1.3-0.14-1.97-0.14c-0.1,0-0.21,0.01-0.31,0.02
			c-0.62-0.08-1.25-0.13-1.89-0.13c-0.16,0-0.32,0.02-0.49,0.02c-0.59-0.07-1.19-0.12-1.81-0.12c-0.23,0-0.45,0.02-0.67,0.03
			c-0.56-0.06-1.14-0.11-1.72-0.11c-0.29,0-0.58,0.03-0.87,0.04c-0.53-0.06-1.08-0.09-1.63-0.09c-0.36,0-0.72,0.03-1.07,0.05
			c-0.5-0.05-1.01-0.08-1.53-0.08c-0.43,0-0.85,0.03-1.27,0.06c-0.21-1.47-0.42-2.32-0.63-2.32c-0.01,0.04-0.02,0.07-0.02,0.09
			c0-0.02,0.01-0.05,0.02-0.09c-0.25-0.01-1.28-0.02-1.64-0.03c-0.11,0.59-0.23,1.39-0.35,2.34c-0.1,0.01-0.2,0.01-0.3,0.02
			c-0.31-0.02-0.62-0.05-0.93-0.05c-0.54,0-1.07,0.03-1.59,0.09c-0.14,0-0.28-0.02-0.42-0.02c-0.61,0-1.21,0.05-1.8,0.12
			c-0.07,0-0.15-0.01-0.22-0.01c-0.68,0-1.35,0.06-2.01,0.15c-0.01,0-0.01,0-0.02,0c-0.81,0-1.6,0.08-2.38,0.21
			c-0.82,0.02-1.63,0.1-2.42,0.25c-0.8,0.04-1.59,0.12-2.36,0.28c-0.76,0.05-1.5,0.15-2.22,0.31c-0.75,0.06-1.49,0.18-2.21,0.35
			c-0.76,0.07-1.5,0.21-2.22,0.38c-0.81,0.08-1.59,0.25-2.35,0.45c-0.8,0.1-1.58,0.26-2.33,0.48c-0.78,0.12-1.54,0.27-2.27,0.5
			c-0.73,0.12-1.45,0.29-2.14,0.51c-0.73,0.13-1.43,0.31-2.12,0.54c-0.72,0.14-1.42,0.33-2.09,0.57c-0.75,0.15-1.46,0.37-2.16,0.62
			c-0.75,0.16-1.48,0.39-2.18,0.66c-0.74,0.18-1.46,0.4-2.15,0.68c-0.71,0.19-1.41,0.41-2.07,0.69c-0.67,0.19-1.32,0.41-1.95,0.69
			c-0.66,0.19-1.3,0.43-1.92,0.7c-0.66,0.2-1.3,0.45-1.92,0.74c-0.68,0.22-1.34,0.49-1.98,0.8c-0.67,0.23-1.31,0.5-1.93,0.82
			c-0.58,0.21-1.14,0.46-1.69,0.73c-2.92-0.69-5.76,0.01-7.98,2.24c-0.24,0.28-0.7,0.81-0.7,0.81s0,0.01,0,0.02
			c-0.48,0.6-0.88,1.28-1.22,2.02c-0.2,0.12-0.4,0.23-0.59,0.36c-0.71,0.38-1.38,0.82-2.02,1.31c-0.76,0.44-1.48,0.93-2.15,1.49
			c-0.68,0.44-1.32,0.93-1.92,1.47c-0.31,0.22-0.62,0.45-0.91,0.69c0.17,0.22,0.34,0.44,0.5,0.67c0.25,0.29,0.48,0.59,0.7,0.9
			c0.27,0.3,0.53,0.6,0.77,0.92c0.26,0.28,0.5,0.57,0.73,0.87c0.26,0.28,0.51,0.57,0.75,0.87c0.27,0.28,0.53,0.57,0.77,0.88
			c0.27,0.28,0.54,0.57,0.79,0.88c0.26,0.27,0.52,0.55,0.76,0.83c0.29,0.29,0.57,0.6,0.83,0.91c0.3,0.29,0.58,0.59,0.85,0.91
			c0.3,0.29,0.59,0.59,0.87,0.9c0.31,0.29,0.61,0.58,0.9,0.89c0.32,0.28,0.63,0.58,0.92,0.89c0.33,0.28,0.64,0.57,0.94,0.88
			c0.37,0.3,0.72,0.62,1.05,0.96c0.35,0.29,0.69,0.59,1.02,0.91c0.32,0.25,0.62,0.52,0.92,0.79c0.74,0.15,1.47,0.36,2.18,0.67
			c0.19,0.08,0.77,0.31,0.77,0.31s0.01,0.01,0.02,0.03c0.18,0.07,0.37,0.13,0.55,0.22c2.26,1.07,3.99,2.84,5.18,5.02
			c1.43-0.14,2.77-0.66,3.93-1.6c-0.02,0.02-0.05,0.05-0.07,0.07c0,0,0,0,0,0s0.87-0.65,1.68-1.63c0.16-0.18,0.29-0.38,0.44-0.57
			c0.33-0.15,0.66-0.29,0.98-0.46c0.46-0.18,0.91-0.38,1.35-0.6c0.48-0.17,0.94-0.37,1.39-0.59c0.49-0.17,0.97-0.36,1.43-0.57
			c0.54-0.17,1.06-0.38,1.57-0.61c0.56-0.17,1.11-0.38,1.65-0.61c0.57-0.17,1.14-0.36,1.68-0.59c0.55-0.15,1.09-0.33,1.62-0.55
			c0.55-0.14,1.08-0.31,1.6-0.51c0.55-0.13,1.09-0.3,1.62-0.49c0.58-0.13,1.14-0.29,1.69-0.48c0.62-0.12,1.22-0.3,1.81-0.49
			c0.62-0.12,1.23-0.27,1.82-0.47c0.62-0.11,1.24-0.25,1.84-0.44c0.59-0.1,1.17-0.22,1.73-0.39c0.58-0.09,1.14-0.2,1.7-0.35
			c0.58-0.07,1.14-0.18,1.7-0.32c0.63-0.07,1.24-0.18,1.85-0.32c0.64-0.06,1.26-0.16,1.87-0.29c0.63-0.05,1.26-0.13,1.86-0.26
			c0.58-0.04,1.16-0.11,1.73-0.21c0.56-0.03,1.12-0.08,1.66-0.17c0.56-0.01,1.12-0.06,1.67-0.13c0.01,0,0.01,0,0.02,0
			c0.61,0,1.21-0.05,1.8-0.12c0.07,0,0.15,0.01,0.22,0.01c0.54,0,1.07-0.03,1.59-0.09c0.14,0,0.28,0.02,0.42,0.02
			c0.5,0,0.99-0.03,1.48-0.07c0.15,0.01,0.3,0.01,0.45,0.02c0.16,0.79,0.34,1.56,0.53,2.31c0.52,0,1.47,0,1.58,0c0,0,0,0,0,0
			c0.21-0.02,0.38-0.86,0.52-2.31c0,0,0,0,0,0c0,0,0.25,0.02,0.57,0.02c0.36,0,0.72-0.03,1.07-0.05c0.5,0.05,1.01,0.08,1.53,0.08
			c0.29,0,0.58-0.03,0.87-0.04c0.53,0.06,1.08,0.09,1.63,0.09c0.23,0,0.45-0.02,0.67-0.03c0.56,0.06,1.14,0.11,1.72,0.11
			c0.16,0,0.32-0.02,0.49-0.02c0.59,0.07,1.19,0.12,1.81,0.12c0.1,0,0.21-0.01,0.31-0.02c0.62,0.08,1.25,0.13,1.89,0.13
			c0.05,0,0.09-0.01,0.14-0.01c0.63,0.08,1.28,0.14,1.93,0.14c0.57,0.08,1.14,0.13,1.72,0.14c0.55,0.08,1.1,0.14,1.66,0.16
			c0.53,0.09,1.06,0.15,1.61,0.18c0.51,0.09,1.03,0.16,1.56,0.2c0.49,0.1,1,0.17,1.51,0.21c0.51,0.1,1.02,0.18,1.54,0.23
			c0.47,0.1,0.95,0.17,1.44,0.23c0.44,0.1,0.9,0.17,1.36,0.23c0.44,0.1,0.88,0.18,1.33,0.24c0.43,0.1,0.87,0.19,1.32,0.26
			c0.43,0.11,0.86,0.2,1.3,0.27c0.43,0.11,0.86,0.21,1.3,0.28c0.42,0.11,0.85,0.21,1.29,0.29c0.42,0.12,0.84,0.22,1.28,0.3
			c0.4,0.11,0.81,0.22,1.23,0.29c0.44,0.13,0.88,0.24,1.34,0.33c0.5,0.16,1,0.29,1.52,0.39c0.5,0.16,1.01,0.31,1.54,0.42
			c0.49,0.17,1,0.32,1.51,0.44c0.37,0.14,0.75,0.24,1.13,0.35c0.21,0.29,0.43,0.57,0.67,0.84c0.8,0.86,1.34,1.12,1.34,1.12
			s0.06,0.04,0.06,0.04c1.47,0.91,3.58,1.15,5.31,0.8c0,0,0,0,0.01,0c0.3,0.14,0.6,0.29,0.91,0.42c0.48,0.27,0.97,0.53,1.48,0.75
			c0.37,0.23,0.75,0.44,1.15,0.64c0.42,0.29,0.86,0.56,1.31,0.81c0.28,0.21,0.57,0.41,0.87,0.6c0.27,0.23,0.55,0.44,0.84,0.65
			c0.13,0.12,0.26,0.24,0.39,0.35c-0.11,0.55-0.19,1.1-0.24,1.67c0.26-0.24,0.96-0.95,0.96-0.95c0.02-0.02,0.03-0.03,0.04-0.05
			c0.05-0.06,0.09-0.11,0.14-0.16c0.09-0.11,0.17-0.21,0.23-0.31c0.07-0.33,0.16-0.67,0.25-0.91c1.45-4.74,5.24-8.65,10.39-9.98
			c1.48-0.38,2.96-0.53,4.41-0.46c0.48,0.02,0.96,0.07,1.43,0.14c1.42,0.21,2.79,0.63,4.07,1.22c0.43,0.2,0.85,0.42,1.25,0.66
			c0.81,0.48,1.58,1.03,2.29,1.66c2.13,1.88,3.74,4.39,4.5,7.35c0.12,0.45,0.21,0.89,0.27,1.32c0.2,1.29,0.19,2.53,0.09,4.08
			c-0.02,0.26-0.03,0.5-0.05,0.73c-0.14,1.58-0.34,2.42-0.44,2.96c-0.06,0.31-0.11,0.56-0.15,0.73c-0.04,0.17-0.06,0.26-0.06,0.26
			s-0.01,0.02-0.01,0.06c-0.01,0.04-0.02,0.09-0.04,0.15c-0.03,0.12-0.07,0.29-0.11,0.46c0,0,0,0,0,0c-0.09,0.34-0.3,0.86-0.1,0.54
			c1.8-2.67,2.81-5.91,2.69-9.37C486.79,375.94,486.42,374.24,485.81,372.66z"
        />
        <path
          d="M301.69,388.16c0.17,0.86,0.41,1.69,0.72,2.48c0,0,0.28-4.5,2.07-9.56c-0.32-0.49-1.06-1.22-1.58-1.82
			C301.46,382.03,301.06,384.9,301.69,388.16z"
        />
      </g>
      <g id="Abschnitt_1">
        <path
          :style="{
            fill:
              typeof internalColorArray[0] !== 'undefined'
                ? internalColorArray[0]
                : internalColor,
          }"
          :class="{ inactive: index !== 0 && !overview, click: overview }"
          d="M336.97,165.13C336.97,165.13,336.97,165.13,336.97,165.13c-0.18-0.22-0.39-0.42-0.6-0.63
			c-0.08-0.08-0.17-0.16-0.26-0.24c-0.17-0.16-0.35-0.31-0.54-0.46c-0.09-0.07-0.17-0.14-0.26-0.21c-0.26-0.2-0.53-0.4-0.82-0.59
			c-0.1-0.07-0.21-0.13-0.31-0.2c-0.23-0.14-0.46-0.29-0.7-0.42c-0.1-0.06-0.21-0.12-0.31-0.18c-0.33-0.18-0.67-0.36-1.02-0.52
			c-0.1-0.05-0.2-0.09-0.31-0.14c-0.29-0.13-0.59-0.26-0.89-0.39c-0.12-0.05-0.23-0.1-0.35-0.14c-0.39-0.15-0.79-0.3-1.21-0.44
			c-0.08-0.03-0.17-0.05-0.25-0.08c-0.36-0.12-0.72-0.23-1.09-0.33c-0.12-0.03-0.24-0.07-0.37-0.1c-0.45-0.12-0.9-0.23-1.37-0.33
			c-0.05-0.01-0.1-0.02-0.16-0.03c-0.43-0.09-0.86-0.17-1.3-0.24c-0.13-0.02-0.26-0.04-0.39-0.06c-0.49-0.08-0.99-0.14-1.5-0.2
			c-0.51-0.05-1.02-0.09-1.53-0.12c-0.15-0.01-0.3-0.01-0.45-0.02c-0.37-0.02-0.74-0.03-1.1-0.03c-0.15,0-0.29,0-0.44,0
			c-0.48,0-0.96,0.01-1.43,0.04c-0.04,0-0.07,0.01-0.11,0.01c-0.43,0.02-0.86,0.06-1.28,0.1c-0.15,0.02-0.3,0.03-0.45,0.05
			c-0.31,0.04-0.62,0.08-0.92,0.13c-0.15,0.02-0.3,0.05-0.44,0.07c-0.41,0.07-0.8,0.15-1.19,0.24c-0.09,0.02-0.18,0.05-0.27,0.07
			c-0.32,0.08-0.63,0.16-0.93,0.25c-0.15,0.04-0.3,0.09-0.45,0.14c-0.23,0.08-0.46,0.15-0.69,0.24c-0.14,0.05-0.29,0.1-0.43,0.16
			c-0.29,0.11-0.56,0.24-0.83,0.36c-0.14,0.07-0.28,0.14-0.41,0.21c-0.21,0.11-0.41,0.21-0.6,0.33c-0.13,0.08-0.25,0.15-0.38,0.23
			c-0.16,0.1-0.31,0.21-0.46,0.31c-0.11,0.08-0.23,0.16-0.34,0.25c-0.2,0.16-0.38,0.32-0.56,0.48c-1.01,0.96-1.64,2.06-1.77,3.28
			c-0.04,0.38-0.1,1-0.12,1.17c0,0.01-0.01,0.02-0.01,0.03c-0.14,1.33,0.34,2.66,1.28,3.89c-0.01,0.12-0.03,0.24-0.04,0.37
			c-0.12,0.56-0.2,1.13-0.25,1.71c-0.09,0.47-0.16,0.95-0.21,1.44c-0.07,0.39-0.14,0.78-0.17,1.18c-0.08,0.41-0.14,0.83-0.19,1.25
			c-0.08,0.43-0.15,0.87-0.2,1.32c-0.09,0.45-0.16,0.91-0.21,1.38c-0.1,0.48-0.17,0.96-0.22,1.46c-0.1,0.5-0.18,1.02-0.23,1.54
			c-0.11,0.52-0.19,1.06-0.24,1.6c-0.11,0.54-0.2,1.09-0.25,1.65c-0.12,0.56-0.21,1.13-0.26,1.71c-0.12,0.57-0.21,1.16-0.27,1.76
			c-0.11,0.51-0.18,1.03-0.24,1.56c-1.21,0.94-2,2.08-2.21,3.39c-0.06,0.38-0.16,0.99-0.18,1.16c0,0.01-0.01,0.02-0.01,0.03
			c-0.21,1.32,0.19,2.67,1.06,3.95c-0.09,0.47-0.16,0.94-0.2,1.42c-0.15,0.67-0.26,1.36-0.32,2.06c-0.16,0.68-0.27,1.38-0.33,2.09
			c-0.16,0.69-0.27,1.4-0.33,2.13c-0.16,0.7-0.28,1.42-0.34,2.16c-0.17,0.71-0.28,1.44-0.34,2.18c-0.17,0.72-0.29,1.46-0.35,2.21
			c-0.17,0.73-0.29,1.47-0.35,2.24c-0.17,0.73-0.29,1.49-0.36,2.26c-0.16,0.69-0.27,1.39-0.34,2.11c-1.23,0.95-2.03,2.1-2.24,3.42
			c-0.06,0.38-0.16,0.99-0.18,1.16c0,0.01-0.01,0.02-0.01,0.03c-0.21,1.32,0.19,2.66,1.05,3.94c-0.04,0.3-0.08,0.59-0.11,0.89
			c-0.18,0.76-0.31,1.54-0.37,2.35c-0.18,0.76-0.31,1.55-0.37,2.36c-0.18,0.77-0.31,1.55-0.37,2.36c-0.19,0.77-0.31,1.56-0.37,2.36
			c-0.19,0.77-0.31,1.56-0.37,2.37c-0.19,0.77-0.31,1.56-0.37,2.37c-0.18,0.77-0.31,1.55-0.37,2.36c-0.18,0.77-0.31,1.55-0.37,2.36
			c-0.05,0.2-0.08,0.41-0.12,0.61c-1.21,0.94-2.01,2.08-2.22,3.4c-0.06,0.38-0.16,0.99-0.18,1.16c0,0.01-0.01,0.02-0.01,0.03
			c-0.21,1.33,0.19,2.68,1.07,3.97c0,0.01,0,0.01,0,0.01c-0.01,0.06-0.02,0.11-0.02,0.17c-0.18,0.75-0.3,1.52-0.36,2.3
			c-0.18,0.74-0.3,1.51-0.36,2.29c-0.17,0.74-0.3,1.49-0.36,2.27c-0.17,0.73-0.29,1.48-0.35,2.25c-0.17,0.72-0.29,1.46-0.35,2.22
			c-0.17,0.72-0.28,1.45-0.35,2.2c-0.16,0.71-0.28,1.43-0.34,2.17c-0.16,0.7-0.28,1.41-0.34,2.14c-0.16,0.69-0.27,1.39-0.33,2.11
			c-0.15,0.68-0.26,1.37-0.32,2.08c-0.03,0.12-0.05,0.24-0.07,0.37c-1.18,0.93-1.95,2.06-2.15,3.35c-0.06,0.38-0.16,0.99-0.18,1.16
			c0,0.01-0.01,0.02-0.01,0.03c-0.21,1.3,0.18,2.62,1.02,3.89c-0.05,0.33-0.1,0.67-0.13,1.01c-0.13,0.6-0.23,1.21-0.28,1.83
			c-0.13,0.58-0.22,1.18-0.27,1.78c-0.12,0.57-0.21,1.15-0.27,1.73c-0.12,0.55-0.2,1.11-0.26,1.68c-0.11,0.53-0.19,1.08-0.25,1.63
			c-0.11,0.52-0.19,1.04-0.24,1.58c-0.1,0.51-0.18,1.02-0.23,1.55c-0.1,0.49-0.17,0.99-0.22,1.49c-0.09,0.47-0.16,0.95-0.21,1.43
			c-0.08,0.45-0.15,0.9-0.2,1.37c-0.08,0.43-0.14,0.86-0.18,1.3c-0.07,0.41-0.13,0.82-0.17,1.23c-0.07,0.38-0.12,0.77-0.16,1.16
			c-0.06,0.36-0.11,0.72-0.15,1.09c-0.05,0.34-0.1,0.67-0.13,1.02c-0.05,0.31-0.09,0.63-0.12,0.94c-2.13,1.92-3,4.42-2.21,7.17
			c0.11,0.31,0.34,0.91,0.34,0.91s0.01,0.01,0.03,0.03c0.28,0.68,0.68,1.32,1.17,1.94c0-1.46,0.01-3.34,0.02-3.73
			c0.01-0.29,0.04-0.57,0.09-0.84c0.12-0.66,0.36-1.29,0.7-1.89c0.03-0.05,0.06-0.11,0.09-0.16c0.09-0.14,0.19-0.28,0.29-0.42
			c0.05-0.08,0.1-0.15,0.16-0.23c0.1-0.13,0.21-0.25,0.32-0.37c0.07-0.08,0.14-0.16,0.22-0.24c0.11-0.11,0.23-0.23,0.35-0.34
			c0.09-0.08,0.18-0.17,0.27-0.25c0.12-0.1,0.25-0.2,0.38-0.3c0.11-0.08,0.22-0.16,0.33-0.24c0.13-0.09,0.26-0.18,0.4-0.27
			c0.12-0.08,0.25-0.16,0.38-0.24c0.14-0.08,0.28-0.16,0.43-0.24c0.14-0.08,0.28-0.15,0.43-0.22c0.15-0.07,0.29-0.14,0.45-0.21
			c0.16-0.07,0.32-0.14,0.48-0.2c0.15-0.06,0.3-0.12,0.46-0.18c0.18-0.06,0.36-0.12,0.54-0.18c0.16-0.05,0.31-0.1,0.47-0.15
			c0.19-0.06,0.39-0.11,0.6-0.16c0.16-0.04,0.32-0.08,0.48-0.12c0.22-0.05,0.44-0.09,0.67-0.13c0.16-0.03,0.31-0.06,0.47-0.09
			c0.26-0.04,0.52-0.07,0.78-0.11c0.13-0.02,0.27-0.04,0.4-0.05c0.4-0.04,0.82-0.08,1.24-0.1c8.05-0.41,15.92,3.4,17.58,8.5
			c0.17,0.51,0.26,1.01,0.3,1.5c0.03,0.44,0.04,1.72,0.04,3.05c1.01-1.35,1.46-2.89,1.21-4.52c0,0,0,0,0,0s-0.12-0.96-0.55-2.03
			c-0.05-0.13-0.12-0.26-0.17-0.38c0.04-0.28,0.09-0.55,0.11-0.84c0.05-0.33,0.1-0.66,0.13-1c0.05-0.3,0.09-0.6,0.12-0.91
			c0.05-0.33,0.1-0.65,0.13-0.99c0.06-0.35,0.11-0.7,0.15-1.06c0.06-0.37,0.12-0.75,0.16-1.13c0.07-0.4,0.13-0.8,0.17-1.2
			c0.08-0.42,0.14-0.84,0.18-1.27c0.08-0.44,0.15-0.88,0.19-1.34c0.09-0.46,0.16-0.93,0.21-1.4c0.1-0.48,0.17-0.97,0.22-1.46
			c0.1-0.51,0.18-1.02,0.23-1.55c0.11-0.53,0.19-1.07,0.24-1.62c0.11-0.55,0.2-1.1,0.25-1.67c0.12-0.56,0.2-1.14,0.26-1.72
			c0.12-0.58,0.21-1.17,0.27-1.77c0.13-0.6,0.22-1.2,0.28-1.82c0.06-0.26,0.1-0.52,0.14-0.78c1.19-0.92,1.98-2.04,2.2-3.32
			c0,0,0.01,0,0.01,0s0-0.03,0.01-0.06c0,0,0,0,0-0.01c0,0,0,0,0-0.01c0.03-0.21,0.13-0.83,0.19-1.18c0.22-1.35-0.21-2.72-1.11-4.02
			c0.01-0.12,0.03-0.25,0.04-0.37c0.15-0.67,0.26-1.36,0.32-2.07c0.16-0.68,0.27-1.39,0.33-2.1c0.16-0.7,0.27-1.41,0.33-2.13
			c0.16-0.7,0.28-1.43,0.34-2.16c0.17-0.71,0.28-1.44,0.34-2.19c0.17-0.72,0.29-1.46,0.35-2.22c0.17-0.73,0.29-1.48,0.35-2.24
			c0.17-0.74,0.29-1.49,0.35-2.26c0.18-0.74,0.3-1.5,0.36-2.28c0.18-0.75,0.3-1.51,0.36-2.3c0.01-0.04,0.02-0.07,0.02-0.11
			c0,0,0.01,0,0.01-0.01c1.2-0.93,1.99-2.05,2.22-3.34c0,0,0.01,0,0.01,0s0-0.03,0.01-0.06c0,0,0,0,0-0.01c0,0,0,0,0-0.01
			c0.03-0.21,0.13-0.83,0.19-1.18c0.21-1.33-0.19-2.68-1.07-3.96c0.03-0.22,0.06-0.43,0.08-0.66c0.18-0.76,0.31-1.55,0.37-2.36
			c0.18-0.77,0.31-1.55,0.37-2.36c0.19-0.77,0.31-1.56,0.37-2.36c0.19-0.77,0.31-1.56,0.37-2.36c0.19-0.77,0.31-1.56,0.37-2.36
			c0.18-0.77,0.31-1.55,0.37-2.36c0.18-0.76,0.31-1.55,0.37-2.36c0.18-0.76,0.31-1.55,0.37-2.35c0.07-0.28,0.12-0.56,0.17-0.84
			c1.18-0.92,1.97-2.04,2.2-3.32c0,0,0.01,0,0.01,0s0-0.03,0.01-0.06c0,0,0,0,0-0.01c0,0,0,0,0-0.01c0.03-0.21,0.13-0.83,0.19-1.18
			c0.21-1.33-0.2-2.69-1.08-3.98c0.16-0.7,0.28-1.42,0.34-2.16c0.17-0.73,0.3-1.49,0.36-2.26c0.17-0.73,0.29-1.47,0.36-2.24
			c0.17-0.72,0.29-1.46,0.35-2.21c0.17-0.71,0.29-1.44,0.35-2.19c0.16-0.7,0.28-1.42,0.34-2.16c0.16-0.69,0.28-1.4,0.34-2.13
			c0.16-0.68,0.27-1.38,0.33-2.1c0.15-0.67,0.27-1.36,0.33-2.06c0.1-0.44,0.18-0.89,0.24-1.35c1.17-0.92,1.95-2.03,2.18-3.3
			c0,0,0.01,0,0.01,0s0-0.03,0.01-0.06c0,0,0,0,0-0.01c0,0,0,0,0-0.01c0.03-0.21,0.13-0.83,0.19-1.18c0.21-1.33-0.19-2.67-1.07-3.96
			c0.12-0.55,0.21-1.11,0.26-1.68c0.13-0.58,0.22-1.17,0.28-1.77c0.12-0.56,0.21-1.13,0.27-1.72c0.12-0.54,0.2-1.1,0.26-1.66
			c0.11-0.53,0.2-1.06,0.25-1.61c0.11-0.51,0.19-1.03,0.24-1.55c0.1-0.5,0.18-1,0.23-1.52c0.1-0.48,0.17-0.97,0.22-1.47
			c0.09-0.46,0.16-0.93,0.21-1.41c0.08-0.44,0.15-0.89,0.2-1.34c0.08-0.42,0.15-0.85,0.19-1.28c0.07-0.42,0.14-0.84,0.18-1.27
			c0.14-0.72,0.22-1.45,0.25-2.2c0.07-0.34,0.12-0.69,0.17-1.05c1.14-0.99,1.86-2.14,2.02-3.43c0,0,0.01-0.01,0.01-0.01
			s0-0.03,0.01-0.06c0,0,0,0,0-0.01c0,0,0,0,0-0.01c0.02-0.21,0.09-0.84,0.13-1.19C338.76,167.97,338.16,166.49,336.97,165.13z"
        />
      </g>
    </g>
    <g id="Schatten__x26__Lichter_1_">
      <g id="Ebene_18">
        <path
          class="st4"
          d="M240.28,67.63c-2.94-4.02-5.64-7.63-8.12-10.33c-5.46-5.95-19.33-17.75-25.2-22.67
			c-2.38,4.74-2.8,9.85-0.69,13.13c0.3,0.47,0.64,0.88,1.02,1.24c0.72,0.74,1.97,1.58,2.34,2.09c-0.02,0-0.04-0.01-0.05-0.01
			c0,0,0,0,0,0c0.38,0.36,0.78,0.69,1.2,1.01c0.51,0.52,1.07,0.99,1.65,1.43c0.55,0.56,1.14,1.07,1.77,1.54
			c0.57,0.59,1.18,1.13,1.84,1.62c0.58,0.61,1.2,1.16,1.87,1.67c0.57,0.61,1.19,1.17,1.86,1.68c0.56,0.6,1.16,1.16,1.8,1.66
			c0.53,0.58,1.1,1.12,1.71,1.6c0.49,0.54,1.01,1.05,1.57,1.52c0.38,0.42,0.79,0.83,1.22,1.21c0.3,0.35,0.62,0.69,0.95,1.01
			c0.21,0.26,0.45,0.5,0.68,0.74c0.18,0.23,0.37,0.46,0.57,0.68c0.22,0.29,0.43,0.58,0.67,0.85c0.24,0.34,0.48,0.67,0.74,0.98
			c0.28,0.41,0.58,0.81,0.9,1.2c0.3,0.45,0.61,0.88,0.96,1.29c0.31,0.48,0.65,0.94,1.01,1.38c0.33,0.51,0.68,1,1.07,1.46
			c0.34,0.53,0.71,1.05,1.12,1.54c0.17,0.27,0.36,0.54,0.54,0.8C235.44,74.74,237.23,71,240.28,67.63z"
        />
        <path
          class="st4"
          d="M305.99,155.7c0.07,0.41,0.17,0.82,0.27,1.22c0.06,0.46,0.14,0.92,0.24,1.37c0.05,0.53,0.12,1.05,0.22,1.56
			c0.03,0.44,0.07,0.87,0.13,1.29c0.01,0.56,0.04,1.1,0.11,1.64c0,0.08-0.01,0.16-0.01,0.24c0.17-0.18,0.35-0.35,0.54-0.52
			c0.36-6.67,0.13-18.92-4.9-29.39c-2.72,3.78-3.35,8.02-1.54,11.17c0.22,0.39,1.33,2.26,2.2,3.71c-0.04-0.02-0.07-0.04-0.11-0.06
			c0,0,0,0,0,0c0.06,0.12,0.12,0.25,0.19,0.37c0.18,0.43,0.38,0.85,0.59,1.25c0.14,0.36,0.29,0.7,0.45,1.05
			c0.14,0.43,0.3,0.85,0.48,1.26c0.12,0.42,0.27,0.83,0.43,1.23c0.1,0.38,0.2,0.75,0.33,1.12
			C305.71,154.72,305.84,155.22,305.99,155.7z"
        />
        <path
          class="st4"
          d="M274.55,104.92c-5.84-4.94-11.49-9.8-15.51-13.88c-6.53-6.63-12.24-14.46-17.26-21.34
			c-4.05,4.68-5.39,10.09-2.89,13.2c0.52,0.66,1.43,1.8,2.62,3.25c-0.05-0.01-0.09-0.03-0.14-0.04h0c0.34,0.47,0.69,0.92,1.08,1.35
			c0.43,0.65,0.92,1.26,1.45,1.83c0.47,0.7,1.01,1.34,1.59,1.95c0.49,0.7,1.04,1.36,1.64,1.97c0.48,0.65,1.01,1.27,1.59,1.84
			c0.45,0.59,0.92,1.15,1.45,1.66c0.4,0.49,0.83,0.96,1.29,1.4c0.41,0.49,0.85,0.94,1.32,1.37c0.42,0.48,0.86,0.93,1.34,1.35
			c0.42,0.47,0.87,0.92,1.36,1.34c0.43,0.47,0.89,0.91,1.37,1.32c0.43,0.45,0.87,0.88,1.35,1.27c0.42,0.43,0.87,0.84,1.34,1.22
			c0.43,0.43,0.88,0.84,1.36,1.22c0.43,0.44,0.9,0.84,1.39,1.22c0.45,0.45,0.94,0.86,1.45,1.25c0.46,0.45,0.95,0.86,1.46,1.25
			c0.46,0.45,0.96,0.86,1.48,1.25c0.47,0.45,0.97,0.87,1.49,1.26c0.47,0.45,0.98,0.87,1.51,1.26c0.48,0.46,0.99,0.88,1.52,1.27
			c0.44,0.42,0.92,0.8,1.41,1.17C271.57,113.59,272.34,109.13,274.55,104.92z"
        />
        <path
          class="st4"
          d="M301.37,130.75c-0.54-0.96-1.13-1.89-1.77-2.8c-3.51-5-13.52-13.31-23.35-21.59
			c-2.24,4.54-2.66,9.38-0.7,12.58c0.29,0.47,0.62,0.89,0.99,1.26c0.71,0.76,1.93,1.62,2.3,2.14c-0.01-0.01-0.03-0.03-0.04-0.04
			c0.08,0.06,0.15,0.12,0.23,0.18c0.5,0.49,1.04,0.93,1.61,1.35c0.51,0.5,1.05,0.95,1.62,1.37c0.52,0.51,1.08,0.98,1.66,1.41
			c0.53,0.53,1.11,1.01,1.71,1.46c0.53,0.54,1.12,1.03,1.73,1.49c0.46,0.47,0.95,0.9,1.46,1.31c0.4,0.41,0.83,0.78,1.28,1.14
			c0.39,0.4,0.8,0.79,1.24,1.14c0.36,0.38,0.74,0.74,1.14,1.08c0.33,0.36,0.68,0.7,1.05,1.03c0.32,0.36,0.65,0.7,1.01,1.03
			c0.33,0.39,0.67,0.75,1.04,1.1c0.33,0.41,0.68,0.8,1.06,1.17c0.28,0.36,0.59,0.7,0.9,1.04c0.03,0.04,0.07,0.08,0.1,0.13
			C297.63,136.81,298.91,133.66,301.37,130.75z"
        />
      </g>
      <g>
        <path
          class="st4"
          d="M163.36,272.56c1.53-0.54,3-1.07,3.48-1.28c0.55-0.23,1.08-0.52,1.58-0.88c3.62-2.55,5.12-7.69,4.26-13.02
			c-14.26,3.1-21.46,7.72-25.17,10.97c0.74,1.04,1.37,2.16,1.85,3.35c1.22,2.6,1.76,5.55,1.42,8.57c0.06-0.07,0.13-0.13,0.19-0.2
			c0.33-0.28,0.65-0.57,0.96-0.87c0.26-0.21,0.51-0.42,0.76-0.65c0.32-0.23,0.64-0.47,0.95-0.72c0.34-0.22,0.66-0.47,0.98-0.71
			c0.32-0.19,0.63-0.39,0.93-0.61c0.42-0.23,0.83-0.48,1.22-0.75c0.37-0.19,0.73-0.4,1.09-0.63c0.37-0.18,0.74-0.36,1.09-0.57
			c0.48-0.2,0.94-0.43,1.39-0.68c0.44-0.18,0.87-0.38,1.29-0.59c0.42-0.16,0.84-0.33,1.24-0.52c0.17-0.06,0.34-0.13,0.51-0.2
			C163.39,272.56,163.38,272.56,163.36,272.56z"
        />
        <path
          class="st4"
          d="M149.66,280.18c0.04-0.62,0.08-1.01,0.08-1.01s0.03-1.49-0.14-2.22c-0.39-2.73-1.53-5.32-3.29-7.46
			c-0.29,0.37-0.44,1.4-0.46,1.72c-0.02,0.32-0.13,1.53,0.57,3.39c0.7,1.86,1.45,2.92,3.1,5.46c0,0,0.09,0.16,0.2,0.33
			c0.11,0.17,0.14,0.2,0.21,0.31c0.1,0.12,0.2,0.26,0.29,0.38c0.01,0.01,0.02,0.03,0.04,0.04
			C150.02,280.82,149.79,280.51,149.66,280.18z"
        />
        <path
          class="st4"
          d="M257.83,268.56c-2.29,4.93-2.56,10.2-0.27,13.45c0.32,0.46,0.68,0.86,1.07,1.2c0.23,0.19,1.07,0.84,1.52,1.19
			c-0.03,0.1-0.06,0.2-0.09,0.3c0.39-1.45,1.02-2.38,1.88-2.6c0.01,0,0.02,0,0.02,0c0,0,0,0,0,0c0.16-0.04,0.54-0.12,0.86-0.2
			c1.01-0.26,2.24,0.46,3.51,1.89c0.6-0.19,1.23-0.35,1.86-0.47c0.63-0.21,1.27-0.37,1.94-0.49c0.64-0.21,1.29-0.37,1.96-0.5
			c0.6-0.2,1.23-0.35,1.86-0.47l0.13-0.12C274.09,281.75,270.89,275.34,257.83,268.56z"
        />
        <path
          class="st4"
          d="M255.88,267.58c-2.78-1.35-5.96-2.7-9.6-4.01c-9.81-3.53-20.17-6.03-30.5-7.42c-0.67,7-0.81,10.48-0.83,12.1
			c0.1,0.01,0.2,0.01,0.29,0.02c0-0.01,0-0.01,0-0.01c0.08,0.01,0.17,0.02,0.25,0.02c0.71,0.16,1.44,0.27,2.18,0.33
			c0.71,0.17,1.43,0.29,2.18,0.36c0.7,0.17,1.41,0.31,2.14,0.38c0.65,0.17,1.32,0.3,2,0.38c0.62,0.17,1.26,0.3,1.91,0.39
			c0.62,0.18,1.26,0.32,1.91,0.42c0.64,0.2,1.3,0.34,1.97,0.46c0.63,0.2,1.28,0.36,1.94,0.48c0.62,0.21,1.25,0.38,1.9,0.51
			c0.6,0.21,1.21,0.39,1.84,0.52c0.54,0.19,1.09,0.36,1.65,0.49c0.52,0.2,1.06,0.37,1.61,0.51c0.53,0.22,1.08,0.4,1.63,0.55
			c0.55,0.23,1.11,0.43,1.69,0.6c0.53,0.24,1.08,0.45,1.65,0.62c0.48,0.22,0.98,0.42,1.49,0.59c0.45,0.22,0.91,0.41,1.39,0.58
			c0.44,0.22,0.89,0.42,1.35,0.6c0.46,0.25,0.94,0.47,1.44,0.67c0.46,0.26,0.93,0.49,1.42,0.7c0.39,0.22,0.79,0.43,1.2,0.62
			c0.38,0.23,0.76,0.44,1.16,0.64c0.37,0.24,0.75,0.46,1.14,0.67c0.09,0.06,0.19,0.11,0.29,0.18
			C253.19,276.8,253.76,272.06,255.88,267.58z"
        />
        <path
          class="st4"
          d="M213.16,267.98c0.03-3.07,0.29-7.43,0.7-12.08c-13.06-1.58-26.03-1.39-37.73,0.78
			c-0.34,0.06-0.66,0.13-0.98,0.19c0.95,5.58-0.42,10.92-3.99,13.61c0.24-0.18,0.45-0.38,0.67-0.58c0.06-0.02,0.12-0.03,0.18-0.05
			c0.57-0.1,1.14-0.23,1.68-0.4c0.53-0.09,1.05-0.2,1.56-0.34c0.54-0.07,1.07-0.18,1.59-0.31c0.59-0.07,1.16-0.17,1.72-0.3
			c0.62-0.06,1.22-0.16,1.81-0.29c0.62-0.05,1.23-0.13,1.83-0.25c0.59-0.04,1.16-0.11,1.73-0.22c0.57-0.03,1.14-0.09,1.69-0.18
			c0.58-0.02,1.15-0.07,1.71-0.15c0.61-0.01,1.21-0.06,1.8-0.13c0.03,0,0.05,0,0.08,0c0.61,0,1.2-0.05,1.79-0.12
			c0.08,0,0.15,0.01,0.23,0.01c0.56,0,1.1-0.04,1.64-0.09c0.13,0,0.25,0.02,0.38,0.02c0.49,0,0.98-0.03,1.46-0.07
			c0.19,0.01,0.37,0.03,0.56,0.03c0.39,0,0.78-0.03,1.17-0.06c0.28,0.02,0.56,0.04,0.84,0.04c0.3,0,0.59-0.03,0.89-0.04
			c0.37,0.03,0.74,0.06,1.11,0.06c0.21,0,0.4-0.02,0.61-0.03c0.46,0.04,0.91,0.07,1.38,0.07c0.13,0,0.26-0.02,0.39-0.02
			c0.52,0.05,1.05,0.09,1.59,0.09c0.08,0,0.16-0.01,0.25-0.01c0.56,0.06,1.13,0.1,1.71,0.1c0.04,0,0.07-0.01,0.11-0.01
			c0.58,0.07,1.17,0.12,1.77,0.12c0.54,0.07,1.09,0.12,1.65,0.13c0.54,0.08,1.08,0.13,1.63,0.15c0.53,0.09,1.06,0.15,1.61,0.18
			C212.36,267.9,212.76,267.94,213.16,267.98C213.16,267.98,213.16,267.98,213.16,267.98z"
        />
      </g>
      <g>
        <path
          class="st4"
          d="M93.03,288.74c-2.55-1.5-5.44-3.05-8.77-4.69c-4.33-2.14-10.1-4.54-16.43-6.98
			c-0.42,4.34,0.59,8.33,3.04,10.56c0.41,0.37,0.84,0.69,1.3,0.94c0.85,0.51,2.17,0.98,2.72,1.36c0.14,0.05,0.28,0.12,0.43,0.17
			c0.74,0.42,1.51,0.78,2.32,1.07c0.75,0.45,1.54,0.83,2.36,1.15c0.75,0.48,1.55,0.89,2.39,1.23c0.78,0.52,1.61,0.97,2.49,1.34
			c0.54,0.37,1.1,0.71,1.68,1.01c0.41,0.27,0.84,0.53,1.28,0.76c0.42,0.28,0.85,0.55,1.29,0.79c0.38,0.27,0.78,0.51,1.19,0.74
			c0.37,0.26,0.75,0.51,1.14,0.74c0.36,0.27,0.72,0.52,1.1,0.76c0.33,0.27,0.68,0.51,1.04,0.75
			C91.93,297.12,91.66,292.85,93.03,288.74z"
        />
        <path
          class="st4"
          d="M65.73,276.27c-10.14-3.84-21.43-7.71-30.56-10.73c-0.2,4.57,1.13,8.71,3.86,10.83
			c0.44,0.34,0.9,0.62,1.37,0.83c0.93,0.46,2.38,0.84,2.9,1.19c-0.01,0-0.01,0-0.02,0c0.54,0.23,1.09,0.42,1.66,0.58
			c0.58,0.25,1.19,0.46,1.81,0.64c0.58,0.25,1.19,0.46,1.81,0.64c0.58,0.25,1.19,0.46,1.81,0.64c0.58,0.25,1.19,0.46,1.81,0.64
			c0.58,0.25,1.19,0.46,1.81,0.64c0.56,0.24,1.15,0.45,1.75,0.63c0.51,0.22,1.03,0.41,1.57,0.57c0.11,0.03,0.22,0.06,0.33,0.09
			c0.18,0.06,0.36,0.1,0.54,0.15c0.24,0.08,0.49,0.15,0.73,0.22c0.3,0.1,0.6,0.2,0.91,0.28c0.35,0.13,0.71,0.25,1.08,0.35
			c0.4,0.15,0.81,0.29,1.23,0.41c0.47,0.19,0.96,0.36,1.46,0.51c0.55,0.24,1.11,0.43,1.69,0.6c0.59,0.26,1.19,0.49,1.82,0.68
			c0.19,0.09,0.39,0.17,0.58,0.25c0.2,0.31,0.42,0.61,0.66,0.88C66.02,285.06,65.16,280.82,65.73,276.27z"
        />
        <path
          class="st4"
          d="M112.05,306.34c-3.22-5.37-7.3-10.34-16.74-16.22c-1.18,4.09-0.77,8.59,1.47,12.2c0.98,1.29,2.32,2.73,4.5,5
			c-0.01,0-0.03-0.01-0.04-0.02c0,0,0.01,0,0.01,0c0.31,0.38,0.62,0.76,0.97,1.11c0.27,0.37,0.56,0.73,0.87,1.07
			c0.32,0.48,0.68,0.94,1.05,1.38c0.29,0.46,0.61,0.91,0.95,1.34c0.27,0.46,0.57,0.91,0.88,1.34c0.29,0.56,0.62,1.09,0.98,1.6
			c0.26,0.53,0.54,1.05,0.86,1.54c0.17,0.39,0.36,0.76,0.56,1.13c0,0,0,0,0,0C108.13,314.02,109.3,309.87,112.05,306.34z"
        />
        <path
          class="st4"
          d="M33.04,264.84c-4.26-1.4-7.95-2.59-10.66-3.45c-0.1,4.44,1.24,8.42,3.9,10.48c0.44,0.34,0.9,0.61,1.37,0.83
			c0.93,0.46,2.38,0.83,2.91,1.18c-0.04,0.01-0.08,0.02-0.12,0.02c0.04-0.01,0.08-0.01,0.12-0.02c0.56,0.24,1.13,0.44,1.72,0.61
			c0.58,0.25,1.19,0.46,1.81,0.64c0.49,0.21,1,0.39,1.52,0.55c0,0,0,0,0,0C33.61,272.97,32.74,269.06,33.04,264.84z"
        />
        <path
          class="st4"
          d="M260.27,348.43c0.28-0.12,0.56-0.25,0.73-0.32c0.44-0.19,0.88-0.34,1.85-0.9c0.96-0.55,2.74-1.59,3.9-3.01
			c2.56-3.14,3.33-7.17,2.58-11.06c-12.72,6.94-28.45,10.21-44.55,12.76c-6.45,1.02-13.42,1.57-20.52,1.71
			c0.21,4.33,0.59,8.58,1.2,12.03c0.11,0,0.22,0,0.33,0c0,0.02,0,0.03,0,0.05c0-0.01,0-0.02,0-0.03c0.08,0.01,0.17,0.01,0.26,0.01
			c0.56,0,1.12-0.04,1.66-0.1c0.14,0,0.27,0.02,0.41,0.02c0.61,0,1.2-0.05,1.79-0.12c0.09,0,0.18,0.01,0.26,0.01
			c0.62,0,1.22-0.05,1.82-0.12c0.02,0,0.04,0,0.06,0c0.66,0,1.31-0.06,1.96-0.14c0.71,0,1.4-0.07,2.09-0.17
			c0.72-0.01,1.42-0.08,2.11-0.19c0.72-0.02,1.43-0.1,2.12-0.22c0.73-0.03,1.44-0.11,2.14-0.24c0.72-0.04,1.43-0.12,2.13-0.27
			c0.69-0.05,1.38-0.14,2.04-0.29c0.7-0.06,1.38-0.16,2.05-0.31c0.7-0.06,1.38-0.18,2.05-0.34c0.74-0.07,1.46-0.22,2.17-0.4
			c0.75-0.09,1.48-0.24,2.2-0.43c0.75-0.1,1.49-0.25,2.2-0.46c0.74-0.12,1.46-0.27,2.16-0.49c0.7-0.12,1.39-0.29,2.05-0.5
			c0.7-0.13,1.38-0.31,2.05-0.54c0.73-0.14,1.43-0.35,2.11-0.6c0.76-0.16,1.49-0.39,2.2-0.67c0.76-0.18,1.49-0.41,2.2-0.7
			c0.71-0.19,1.41-0.42,2.07-0.71c0.69-0.2,1.36-0.44,2-0.73c0.71-0.21,1.39-0.49,2.05-0.8c0.75-0.24,1.47-0.55,2.17-0.9
			c0.68-0.24,1.33-0.52,1.96-0.85c0,0,0,0,0,0C260.31,348.43,260.29,348.43,260.27,348.43z"
        />
        <path
          class="st4"
          d="M284.01,329.49c0-0.15,0.02-0.29,0.02-0.44c-0.05-0.52-0.08-1.04-0.08-1.58c0-0.3,0.03-0.59,0.04-0.88
			c-0.03-0.38-0.06-0.76-0.06-1.15c0-0.46,0.03-0.92,0.07-1.37c-0.01-0.23-0.03-0.45-0.03-0.68c0-0.29,0.01-0.57,0.03-0.85
			c-0.11-0.15-0.21-0.3-0.31-0.45c-3.57,3.91-7.71,7.15-12.28,9.87c0.99,4.43,0.14,8.84-2.36,11.96c0,0,0,0,0,0
			c0.47-0.26,0.92-0.53,1.36-0.84c0.68-0.36,1.32-0.78,1.93-1.24c0.71-0.41,1.39-0.86,2.02-1.38c0.75-0.46,1.45-0.99,2.1-1.57
			c0.84-0.58,1.62-1.26,2.33-2c0.81-0.66,1.55-1.4,2.2-2.21c0.72-0.69,1.37-1.44,1.94-2.25c0.42-0.46,0.81-0.94,1.17-1.44
			c0.01,0.11,0.03,0.21,0.04,0.32C284.06,330.7,284.01,330.1,284.01,329.49z"
        />
        <path
          class="st4"
          d="M138.75,335.29c-13.04-7.9-21.3-19.58-25.3-26.54c-3,4.63-3.57,10.69-1.03,15.53
			c0.88,1.34,2.1,2.86,4.08,5.23c0.11,0.11,0.2,0.23,0.31,0.33c0.51,0.65,1.07,1.25,1.67,1.8c0.6,0.71,1.25,1.37,1.97,1.96
			c0.53,0.57,1.11,1.11,1.73,1.59c0.59,0.6,1.24,1.15,1.93,1.65c0.61,0.58,1.27,1.12,1.98,1.59c0.57,0.5,1.17,0.95,1.81,1.35
			c0.63,0.52,1.3,0.99,2.01,1.4c0.65,0.5,1.33,0.97,2.06,1.36c0.59,0.42,1.2,0.81,1.85,1.14c0.6,0.42,1.24,0.79,1.91,1.11
			c0.65,0.43,1.34,0.8,2.05,1.13c0.65,0.4,1.32,0.77,2.02,1.07c0.17,0.1,0.34,0.18,0.51,0.27
			C138.41,344.13,137.91,339.78,138.75,335.29z"
        />
        <path
          class="st4"
          d="M202.06,347.64c-21.91,0.18-44.72-3.44-57.22-9.13c-1.41-0.64-2.75-1.34-4.06-2.07
			c-0.73,5.03,0.36,9.83,3.18,12.27c0.42,0.36,0.82,0.61,1.28,0.85c0.42,0.26,1.78,0.84,2.83,1.2c-0.03,0.01-0.06,0.01-0.09,0.01
			c0.38,0.17,0.77,0.32,1.17,0.46c0.59,0.28,1.19,0.53,1.81,0.72c0.55,0.25,1.11,0.47,1.69,0.65c0.57,0.24,1.16,0.43,1.76,0.6
			c0.59,0.23,1.2,0.43,1.82,0.58c0.61,0.23,1.23,0.42,1.88,0.56c0.62,0.21,1.25,0.4,1.9,0.54c0.59,0.19,1.19,0.34,1.8,0.46
			c0.63,0.2,1.29,0.34,1.95,0.45c0.66,0.19,1.34,0.34,2.03,0.44c0.67,0.19,1.36,0.33,2.07,0.42c0.69,0.18,1.39,0.32,2.11,0.4
			c0.67,0.16,1.35,0.28,2.05,0.35c0.66,0.15,1.34,0.26,2.03,0.32c0.67,0.15,1.36,0.24,2.07,0.3c0.69,0.15,1.41,0.23,2.14,0.28
			c0.73,0.14,1.48,0.22,2.24,0.26c0.74,0.13,1.49,0.21,2.26,0.23c0.74,0.12,1.5,0.2,2.28,0.21c0.73,0.11,1.47,0.18,2.23,0.18
			c0.01,0,0.02,0,0.03,0c0.66,0.09,1.34,0.15,2.03,0.15c0.05,0,0.11-0.01,0.16-0.01c0.63,0.08,1.26,0.14,1.91,0.14
			c0.1,0,0.19-0.01,0.29-0.01c0.59,0.07,1.19,0.12,1.8,0.12c0.14,0,0.28-0.02,0.41-0.02c0.55,0.06,1.11,0.1,1.68,0.1
			c0.18,0,0.36-0.02,0.54-0.03c0.51,0.05,1.03,0.08,1.55,0.08c0.26,0,0.51-0.03,0.77-0.04c0.44,0.04,0.88,0.07,1.33,0.07
			c0.35,0,0.68-0.03,1.02-0.05c0.36,0.03,0.71,0.05,1.07,0.05c0.43,0,0.85-0.03,1.28-0.06c0.12,0.01,0.24,0.01,0.36,0.02
			c0,0,0,0,0,0C202.75,355.95,202.3,351.76,202.06,347.64z"
        />
      </g>
      <g>
        <path
          class="st4"
          d="M446.03,451.48c1.4-0.44,2.62-0.82,3.16-0.98c3.11-0.91,4.44-6.1,3.47-12.37c-0.06,0.02-0.11,0.04-0.17,0.05
			c-23.36,6.42-45.1,7.39-63.63,5.58c-0.53,4.86-1.25,9.2-1.85,12.05c0-0.01,0-0.01,0-0.02c0.29,0.02,0.58,0.05,0.87,0.06
			c0.74,0.12,1.49,0.2,2.26,0.21c0.72,0.11,1.45,0.18,2.21,0.18c0.01,0,0.02,0,0.03,0c0.65,0.09,1.31,0.15,1.99,0.15
			c0.05,0,0.1-0.01,0.16-0.01c0.61,0.08,1.23,0.13,1.86,0.13c0.1,0,0.19-0.01,0.28-0.01c0.57,0.07,1.15,0.11,1.74,0.11
			c0.14,0,0.27-0.02,0.41-0.02c0.53,0.06,1.07,0.09,1.62,0.09c0.19,0,0.38-0.02,0.57-0.03c0.48,0.05,0.96,0.07,1.45,0.07
			c0.28,0,0.55-0.03,0.82-0.04c0.4,0.03,0.8,0.06,1.2,0.06c0.36,0,0.72-0.03,1.07-0.05c0.32,0.02,0.63,0.05,0.95,0.05
			c0.45,0,0.89-0.03,1.32-0.07c0.23,0.01,0.46,0.04,0.7,0.04c0.52,0,1.04-0.03,1.55-0.08c0.16,0,0.31,0.02,0.46,0.02
			c0.57,0,1.13-0.04,1.68-0.1c0.11,0,0.22,0.02,0.33,0.02c0.61,0,1.21-0.05,1.8-0.12c0.07,0,0.14,0.01,0.2,0.01
			c0.65,0,1.29-0.06,1.92-0.14c0.02,0,0.05,0,0.07,0c0.72,0,1.42-0.07,2.1-0.16c0.76-0.01,1.51-0.08,2.24-0.2
			c0.76-0.02,1.51-0.09,2.23-0.22c0.76-0.03,1.5-0.11,2.22-0.25c0.73-0.04,1.46-0.13,2.16-0.27c0.7-0.05,1.4-0.15,2.07-0.29
			c0.7-0.06,1.39-0.17,2.06-0.32c0.71-0.07,1.39-0.19,2.07-0.35c0.74-0.08,1.46-0.23,2.17-0.41c0.74-0.09,1.45-0.24,2.15-0.43
			c0.73-0.11,1.45-0.25,2.14-0.46c0.7-0.12,1.39-0.27,2.06-0.48c0.67-0.12,1.32-0.28,1.96-0.49c0.63-0.12,1.25-0.29,1.85-0.49
			c0,0,0,0,0.01,0C446.04,451.49,446.03,451.49,446.03,451.48z"
        />
        <path
          class="st4"
          d="M322.62,419.57c-10.23-7.69-18.2-16.33-20.46-23.18c0.03,0.41,0.06,0.81,0.12,1.21
			c0.01,1.07,0.14,2.11,0.36,3.11c0.1,1.09,0.32,2.15,0.65,3.16c0.2,1.08,0.51,2.13,0.93,3.12c0.27,0.96,0.63,1.89,1.08,2.76
			c0.26,0.7,0.55,1.38,0.91,2.03c0.26,0.6,0.57,1.18,0.9,1.74c0.28,0.6,0.6,1.18,0.95,1.74c0.29,0.58,0.61,1.15,0.98,1.68
			c0.32,0.59,0.7,1.15,1.09,1.69c0.35,0.59,0.73,1.15,1.15,1.69c0.35,0.56,0.73,1.09,1.15,1.59c0.39,0.58,0.83,1.11,1.3,1.63
			c0.42,0.57,0.87,1.11,1.36,1.62c0.41,0.52,0.85,1.02,1.32,1.48c0.46,0.56,0.97,1.07,1.5,1.55c0.49,0.55,1,1.07,1.57,1.54
			c0.46,0.48,0.95,0.94,1.48,1.36c0.15,0.16,0.32,0.3,0.48,0.44C320.29,428.05,320.79,423.72,322.62,419.57z"
        />
        <path
          class="st4"
          d="M386.66,443.54c-15.72-1.74-29-5.45-38.81-9.45c-8.03-3.27-16.21-7.97-23.43-13.19
			c-1.93,4.77-2,9.76,0.2,12.81c0.32,0.45,0.65,0.78,1.04,1.12c0.35,0.35,1.53,1.22,2.47,1.81c-0.03,0-0.05-0.01-0.08-0.01
			c0,0,0,0,0,0c0.58,0.45,1.19,0.86,1.83,1.22c0.6,0.44,1.22,0.83,1.88,1.18c0.6,0.42,1.24,0.79,1.91,1.12
			c0.69,0.46,1.42,0.86,2.19,1.2c0.69,0.43,1.41,0.82,2.17,1.13c0.67,0.39,1.36,0.73,2.09,1.01c0.69,0.39,1.41,0.72,2.16,0.99
			c0.78,0.42,1.61,0.77,2.46,1.05c0.77,0.38,1.56,0.71,2.4,0.96c0.76,0.36,1.55,0.66,2.37,0.88c0.78,0.36,1.6,0.64,2.44,0.86
			c0.82,0.36,1.68,0.64,2.57,0.85c0.89,0.37,1.81,0.66,2.77,0.85c0.85,0.33,1.74,0.58,2.65,0.75c0.88,0.32,1.79,0.57,2.73,0.72
			c0.9,0.32,1.84,0.55,2.81,0.69c0.84,0.28,1.71,0.49,2.6,0.62c0.78,0.24,1.59,0.41,2.42,0.53c0.71,0.2,1.45,0.35,2.2,0.44
			c0.72,0.18,1.45,0.33,2.21,0.41c0.68,0.16,1.37,0.29,2.09,0.35c0.68,0.16,1.38,0.27,2.1,0.33c0.69,0.15,1.39,0.25,2.11,0.3
			c0.7,0.15,1.42,0.23,2.15,0.28c0.45,0.09,0.91,0.15,1.38,0.19c0,0,0,0,0,0.01c0.09,0.01,0.17,0.02,0.26,0.03
			C385.54,452.54,386.16,448.2,386.66,443.54z"
        />
        <path
          class="st4"
          d="M506.21,396.68c0.04-0.16,0.05-0.33,0.08-0.5c-1.77,3.99-6.16,12.26-15,20.75c0.84,3.12,0.67,6.29-0.58,9
			c0,0,0,0,0,0c0.2-0.22,0.41-0.44,0.6-0.67c0.56-0.53,1.08-1.1,1.56-1.71c0.62-0.61,1.17-1.29,1.67-2c0.53-0.58,1.02-1.2,1.45-1.86
			c0.51-0.6,0.96-1.26,1.37-1.94c0.5-0.64,0.96-1.32,1.35-2.04c0.42-0.59,0.78-1.22,1.11-1.87c0.43-0.66,0.81-1.36,1.13-2.08
			c0.36-0.61,0.68-1.25,0.95-1.91c0.36-0.67,0.66-1.37,0.92-2.09c0.32-0.67,0.61-1.35,0.84-2.07c0.27-0.63,0.49-1.28,0.68-1.95
			c0.26-0.66,0.48-1.35,0.64-2.06c0.1-0.27,0.18-0.55,0.26-0.82c-0.02,0.08-0.04,0.16-0.06,0.24
			C505.6,399.37,506.11,397.15,506.21,396.68z"
        />
        <path
          class="st4"
          d="M483.59,432.34c0.24-0.2,0.47-0.39,0.61-0.5c0.38-0.3,0.76-0.57,1.54-1.36c0.78-0.79,2.22-2.27,2.95-3.95
			c1.12-2.54,1.3-5.27,0.74-7.88c-7.98,7.17-19.23,14.28-34.83,18.91c0.8,4.73,0.43,8.94-0.93,11.56c0.17-0.07,0.35-0.13,0.52-0.2
			c0.63-0.18,1.23-0.41,1.82-0.67c0.66-0.2,1.3-0.46,1.92-0.75c0.67-0.22,1.31-0.49,1.94-0.8c0.66-0.24,1.3-0.51,1.91-0.83
			c0.62-0.24,1.22-0.51,1.8-0.83c0.6-0.25,1.18-0.54,1.74-0.86c0.64-0.28,1.24-0.6,1.83-0.96c0.74-0.35,1.45-0.74,2.12-1.19
			c0.82-0.4,1.61-0.87,2.34-1.4c0.91-0.44,1.77-0.97,2.57-1.58c0.88-0.46,1.72-0.99,2.49-1.61c0.87-0.48,1.69-1.05,2.44-1.69
			c0.79-0.48,1.53-1.02,2.22-1.63c0.76-0.48,1.46-1.03,2.12-1.64c0.07-0.05,0.14-0.11,0.21-0.16c0,0,0,0,0,0
			C483.65,432.32,483.62,432.33,483.59,432.34z"
        />
      </g>
      <g>
        <path
          class="st4"
          d="M438.65,356.39c-3.82-1.12-8.1-2.16-12.88-3.04c-9.07-1.68-19.36-2.3-29.59-1.97
			c0.13,4.17,0.44,8.26,1.02,11.6c0.13,0,0.26,0,0.38,0.01c-0.01,0.1-0.02,0.18-0.03,0.27c0.01-0.08,0.02-0.16,0.03-0.25
			c0-0.01,0-0.02,0.01-0.02c0.19,0.01,0.38,0.02,0.57,0.02c0.36,0,0.72-0.03,1.07-0.05c0.5,0.05,1.01,0.08,1.53,0.08
			c0.29,0,0.58-0.03,0.87-0.04c0.53,0.06,1.08,0.09,1.63,0.09c0.23,0,0.45-0.02,0.67-0.03c0.56,0.06,1.14,0.11,1.72,0.11
			c0.16,0,0.32-0.02,0.49-0.02c0.59,0.07,1.19,0.12,1.81,0.12c0.1,0,0.21-0.01,0.31-0.02c0.62,0.08,1.25,0.13,1.89,0.13
			c0.05,0,0.09-0.01,0.14-0.01c0.63,0.08,1.28,0.14,1.93,0.14c0.57,0.08,1.14,0.13,1.72,0.14c0.55,0.08,1.1,0.14,1.66,0.16
			c0.53,0.09,1.06,0.15,1.61,0.18c0.51,0.09,1.03,0.16,1.56,0.2c0.49,0.1,1,0.17,1.51,0.21c0.51,0.1,1.02,0.18,1.54,0.23
			c0.47,0.1,0.95,0.17,1.44,0.23c0.44,0.1,0.9,0.17,1.36,0.23c0.44,0.1,0.88,0.18,1.33,0.24c0.43,0.1,0.87,0.19,1.32,0.26
			c0.43,0.11,0.86,0.2,1.3,0.27c0.43,0.11,0.86,0.21,1.3,0.28c0.42,0.11,0.85,0.21,1.29,0.29c0.42,0.12,0.84,0.22,1.28,0.3
			c0.4,0.11,0.81,0.22,1.23,0.29c0.44,0.13,0.88,0.24,1.34,0.33c0.5,0.16,1,0.29,1.52,0.39c0.5,0.16,1.01,0.31,1.54,0.42
			c0.49,0.17,1,0.32,1.51,0.44c0.37,0.14,0.75,0.24,1.13,0.35c0.21,0.29,0.43,0.57,0.67,0.84
			C438.63,366.72,437.71,361.68,438.65,356.39z"
        />
        <path
          class="st4"
          d="M393.66,351.47c-13.2,0.62-26.1,2.8-35.91,6.33c-1.89,0.68-3.62,1.34-5.24,1.99
			c1.4,5.07,1.01,10.14-1.34,13.34c0.33-0.15,0.66-0.29,0.98-0.46c0.46-0.18,0.91-0.38,1.35-0.6c0.48-0.17,0.94-0.37,1.39-0.59
			c0.49-0.17,0.97-0.36,1.43-0.57c0.54-0.17,1.06-0.38,1.57-0.61c0.56-0.17,1.11-0.38,1.65-0.61c0.57-0.17,1.14-0.36,1.68-0.59
			c0.55-0.15,1.09-0.33,1.62-0.55c0.55-0.14,1.08-0.31,1.6-0.51c0.55-0.13,1.09-0.3,1.62-0.49c0.58-0.13,1.14-0.29,1.69-0.48
			c0.62-0.12,1.22-0.3,1.81-0.49c0.62-0.12,1.23-0.27,1.82-0.47c0.62-0.11,1.24-0.25,1.84-0.44c0.59-0.1,1.17-0.22,1.73-0.39
			c0.58-0.09,1.14-0.2,1.7-0.35c0.58-0.07,1.14-0.18,1.7-0.32c0.63-0.07,1.24-0.18,1.85-0.32c0.64-0.06,1.26-0.16,1.87-0.29
			c0.63-0.05,1.26-0.13,1.86-0.26c0.58-0.04,1.16-0.11,1.73-0.21c0.56-0.03,1.12-0.08,1.66-0.17c0.56-0.01,1.12-0.06,1.67-0.13
			c0.01,0,0.01,0,0.02,0c0.61,0,1.21-0.05,1.8-0.12c0.07,0,0.15,0.01,0.22,0.01c0.54,0,1.07-0.03,1.59-0.09
			c0.14,0,0.28,0.02,0.42,0.02c0.5,0,0.99-0.03,1.48-0.07c0.15,0.01,0.3,0.01,0.45,0.02C394.23,359.4,393.83,355.41,393.66,351.47z"
        />
        <path
          class="st4"
          d="M335.58,369.82c0.32,0.25,0.62,0.52,0.92,0.79c0.74,0.15,1.47,0.36,2.18,0.67c0.19,0.08,0.77,0.31,0.77,0.31
			s0.01,0.01,0.02,0.03c0.18,0.07,0.37,0.13,0.55,0.22c2.09,0.99,3.73,2.57,4.91,4.53c0.94-0.56,1.75-1.05,2.06-1.27
			c0.46-0.31,0.89-0.68,1.3-1.11c2.82-3.01,3.49-8.22,2.12-13.35c-8.46,3.54-12.99,6.49-15.54,8.54
			C335.1,369.39,335.35,369.6,335.58,369.82z"
        />
        <path
          class="st4"
          d="M455.04,375.94c0.41-2.1,1.24-4.06,2.4-5.78c0.88-1.47,2-2.78,3.29-3.89c-3.28-2.38-9.8-6.05-19.99-9.25
			c-0.82,5.12,0.26,10,3.17,12.49c0.42,0.36,0.87,0.66,1.33,0.89c0.88,0.49,2.26,0.92,2.8,1.29c0.32,0.15,0.64,0.31,0.97,0.44
			c0.48,0.27,0.97,0.53,1.48,0.75c0.37,0.23,0.75,0.44,1.15,0.64c0.42,0.29,0.86,0.56,1.31,0.81c0.28,0.21,0.57,0.41,0.87,0.6
			c0.27,0.23,0.55,0.44,0.84,0.65C454.77,375.71,454.91,375.82,455.04,375.94z"
        />
      </g>
      <g>
        <path
          class="st4"
          d="M288.25,349.84c-1.12-2.07-1.98-4.04-2.58-5.88c0.09,0.46,0.19,0.91,0.32,1.35c0.12,0.78,0.28,1.55,0.52,2.29
			c0.13,0.72,0.31,1.42,0.54,2.1c0.14,0.71,0.35,1.4,0.6,2.08C287.79,351.13,288,350.49,288.25,349.84z"
        />
        <path
          class="st4"
          d="M318.86,382.26c-13.75-10.42-23.39-20.7-28.87-29.44c-0.54,2.24-0.43,4.5,0.41,6.5
			c0.19,0.46,1.17,2.66,1.92,4.37c-0.01-0.01-0.02-0.02-0.03-0.02c0.18,0.36,0.37,0.72,0.58,1.06c0.33,0.74,0.71,1.45,1.15,2.13
			c0.33,0.67,0.7,1.32,1.13,1.93c0.35,0.67,0.77,1.3,1.22,1.91c0.4,0.71,0.86,1.38,1.37,2.01c0.39,0.62,0.82,1.21,1.29,1.76
			c0.41,0.62,0.88,1.19,1.38,1.74c0.31,0.43,0.65,0.84,1.01,1.23c0.27,0.35,0.56,0.69,0.86,1.01c0.28,0.36,0.58,0.71,0.9,1.05
			c0.3,0.37,0.61,0.73,0.94,1.08c0.31,0.39,0.64,0.76,0.98,1.11c0.34,0.41,0.69,0.81,1.07,1.18c0.33,0.4,0.69,0.77,1.06,1.13
			c0.35,0.41,0.72,0.79,1.11,1.16c0.36,0.41,0.75,0.81,1.16,1.18c0.38,0.42,0.78,0.82,1.2,1.2c0.4,0.43,0.81,0.84,1.25,1.22
			c0.41,0.44,0.84,0.85,1.31,1.24c0.4,0.41,0.83,0.8,1.27,1.16c0.43,0.44,0.9,0.84,1.39,1.22c0.46,0.45,0.95,0.86,1.46,1.24
			c0.44,0.41,0.91,0.79,1.4,1.15C317.32,391.11,317.25,386.62,318.86,382.26z"
        />
        <path
          class="st4"
          d="M484.26,386.55c0.08-0.34,0.17-0.66,0.17-0.66s0.1-0.37,0.21-0.99c0.1-0.54,0.31-1.39,0.44-2.99
			c-7.75,10.49-18.47,16.63-30.16,20.49c0.52,4.04,0.05,7.66-1.28,10.14c0.63-0.23,1.25-0.49,1.84-0.8c0.77-0.28,1.52-0.61,2.23-1
			c0.76-0.29,1.48-0.64,2.17-1.04c0.81-0.33,1.57-0.73,2.3-1.19c0.86-0.38,1.67-0.83,2.44-1.35c0.78-0.38,1.51-0.83,2.21-1.33
			c0.86-0.46,1.68-0.99,2.43-1.6c0.79-0.47,1.52-1,2.21-1.6c0.86-0.56,1.66-1.21,2.39-1.93c0.75-0.56,1.44-1.19,2.07-1.89
			c0.8-0.67,1.51-1.42,2.16-2.24c0.77-0.76,1.46-1.61,2.06-2.52c0.72-0.85,1.34-1.78,1.86-2.77c0.65-0.95,1.19-1.98,1.61-3.07
			c0.18-0.34,0.32-0.7,0.48-1.05C484.1,387.06,484.21,386.77,484.26,386.55z"
        />
        <path
          class="st4"
          d="M382.92,408.17c-18.28-2.45-37.73-8.01-53.18-18.22c-2.92-1.93-5.7-3.87-8.34-5.81
			c-1.76,5.58-0.47,11.37,3.16,14.85c0.13,0.17,0.29,0.33,0.5,0.47c0.05,0.04,0.1,0.07,0.14,0.11c0.14,0.11,0.29,0.21,0.43,0.32
			c0.09,0.07,0.19,0.14,0.29,0.2c0.22,0.15,0.44,0.3,0.68,0.44c0.14,0.11,0.29,0.21,0.43,0.31c0.03,0.02,0.05,0.03,0.08,0.05
			c0.11,0.09,0.23,0.16,0.35,0.25c0.22,0.14,0.44,0.29,0.67,0.42c0.5,0.36,1.01,0.69,1.55,0.99c0.23,0.16,0.47,0.29,0.71,0.43
			c-0.01,0-0.03,0-0.04,0c0.14,0.08,0.27,0.16,0.4,0.23c0.58,0.41,1.19,0.77,1.83,1.09c0.64,0.43,1.32,0.81,2.03,1.14
			c0.68,0.44,1.39,0.83,2.14,1.15c0.66,0.4,1.35,0.76,2.08,1.06c0.66,0.38,1.35,0.72,2.07,1c0.68,0.38,1.39,0.71,2.13,0.98
			c0.75,0.41,1.55,0.75,2.37,1.03c0.77,0.39,1.57,0.73,2.41,0.99c0.74,0.35,1.51,0.65,2.31,0.88c0.76,0.35,1.56,0.64,2.38,0.86
			c0.78,0.35,1.6,0.62,2.45,0.83c0.88,0.37,1.8,0.66,2.75,0.86c0.83,0.32,1.7,0.57,2.6,0.74c0.85,0.31,1.73,0.55,2.64,0.7
			c0.87,0.3,1.78,0.52,2.72,0.66c0.9,0.3,1.83,0.5,2.79,0.63c0.97,0.3,1.98,0.5,3.02,0.6c0.94,0.26,1.91,0.44,2.92,0.51
			c0.96,0.25,1.96,0.41,2.99,0.47c1,0.25,2.03,0.39,3.1,0.43c0.57,0.13,1.15,0.22,1.73,0.29
			C382.24,417.09,382.51,412.77,382.92,408.17z"
        />
        <path
          class="st4"
          d="M444.78,415.73c0.21-0.07,0.42-0.15,0.63-0.22c0.33-0.12,0.66-0.23,0.98-0.37c0.14-0.03,0.27-0.07,0.41-0.11
			c0.7-0.24,1.27-0.44,1.6-0.55c3.28-1.08,4.86-5.73,4.27-11.37c-9.88,2.99-20.33,4.49-30.18,5.7c-10.08,1.24-23.46,1.34-37.65-0.4
			c-0.67,6.82-0.81,10.23-0.84,11.83c0.04,0.01,0.08,0.01,0.11,0.02c0.06,0,0.12,0.01,0.18,0.02c0,0,0,0.01,0,0.01
			c0.87,0.16,1.76,0.27,2.68,0.27c0.01,0,0.02,0,0.03,0c0.96,0.19,1.96,0.3,2.98,0.3c0.07,0,0.14-0.01,0.21-0.01
			c0.87,0.16,1.77,0.25,2.69,0.25c0.13,0,0.25-0.02,0.38-0.02c0.79,0.13,1.59,0.21,2.42,0.21c0.18,0,0.35-0.02,0.53-0.03
			c0.71,0.1,1.43,0.17,2.16,0.17c0.23,0,0.45-0.02,0.68-0.03c0.63,0.08,1.26,0.14,1.91,0.14c0.28,0,0.55-0.03,0.82-0.04
			c0.55,0.06,1.11,0.1,1.68,0.1c0.35,0,0.68-0.03,1.02-0.05c0.45,0.04,0.91,0.07,1.38,0.07c0.46,0,0.91-0.03,1.36-0.07
			c0.32,0.02,0.63,0.05,0.95,0.05c0.54,0,1.07-0.03,1.6-0.09c0.21,0.01,0.41,0.03,0.62,0.03c0.59,0,1.17-0.04,1.74-0.11
			c0.13,0,0.26,0.02,0.39,0.02c0.64,0,1.26-0.05,1.88-0.13c0.06,0,0.12,0.01,0.17,0.01c0.69,0,1.36-0.06,2.02-0.15
			c0.77,0,1.53-0.08,2.27-0.2c0.74-0.02,1.46-0.09,2.16-0.22c0.7-0.04,1.39-0.11,2.06-0.24c0.66-0.05,1.31-0.12,1.94-0.26
			c0.61-0.06,1.2-0.15,1.78-0.27c0.63-0.06,1.24-0.18,1.84-0.32c0.59-0.07,1.18-0.19,1.75-0.33c0.56-0.08,1.12-0.19,1.66-0.33
			c0.53-0.09,1.06-0.2,1.57-0.34c0.51-0.09,1-0.2,1.49-0.34c0.48-0.09,0.95-0.2,1.41-0.34c0.53-0.11,1.05-0.24,1.56-0.4
			c0.44-0.1,0.87-0.21,1.3-0.35c0.41-0.1,0.82-0.21,1.22-0.34c0.39-0.1,0.77-0.2,1.15-0.32c0.52-0.13,1.02-0.29,1.52-0.47
			c0.52-0.1,1.03-0.24,1.52-0.4C444.79,415.73,444.79,415.73,444.78,415.73z"
        />
      </g>
      <g>
        <path
          class="st4"
          d="M205.24,311.53c-15.27,0.61-29.46-0.41-41.22-3.08c-7.63-1.73-14.83-4.42-21.13-7.67
			c-1.02,5.1-0.14,10.06,2.63,12.67c0.4,0.38,0.79,0.65,1.24,0.9c0.11,0.08,0.31,0.18,0.54,0.3c0.03,0.01,0.05,0.02,0.08,0.03
			c0.22,0.12,0.44,0.22,0.66,0.33c0.45,0.21,0.95,0.43,1.4,0.61c0.16,0.06,0.32,0.13,0.48,0.18c0.82,0.42,1.68,0.77,2.58,1.04
			c0.79,0.38,1.62,0.68,2.48,0.92c0.81,0.36,1.67,0.65,2.55,0.87c0.9,0.38,1.84,0.67,2.82,0.86c0.83,0.31,1.69,0.55,2.59,0.71
			c0.84,0.29,1.71,0.51,2.61,0.65c0.84,0.27,1.72,0.46,2.61,0.59c0.76,0.22,1.54,0.38,2.35,0.47c0.7,0.17,1.41,0.31,2.14,0.38
			c0.67,0.15,1.35,0.26,2.05,0.32c0.67,0.15,1.36,0.24,2.07,0.29c0.71,0.15,1.44,0.23,2.18,0.27c0.73,0.14,1.47,0.22,2.23,0.24
			c0.73,0.13,1.48,0.2,2.25,0.22c0.74,0.11,1.48,0.19,2.25,0.19c0.66,0.09,1.34,0.15,2.02,0.15c0.04,0,0.08-0.01,0.12-0.01
			c0.62,0.08,1.25,0.13,1.89,0.13c0.08,0,0.16-0.01,0.25-0.01c0.58,0.07,1.17,0.11,1.77,0.11c0.13,0,0.25-0.02,0.37-0.02
			c0.54,0.06,1.09,0.1,1.65,0.1c0.17,0,0.33-0.02,0.49-0.02c0.51,0.05,1.02,0.08,1.54,0.08c0.24,0,0.48-0.02,0.72-0.04
			c0.43,0.04,0.87,0.07,1.31,0.07c0.32,0,0.63-0.03,0.94-0.05c0.36,0.03,0.73,0.06,1.1,0.06c0.39,0,0.78-0.03,1.16-0.06
			c0.29,0.02,0.58,0.04,0.88,0.04c0.46,0,0.92-0.03,1.37-0.07c0.22,0.01,0.45,0.03,0.67,0.03c0.52,0,1.04-0.03,1.55-0.08
			c0.16,0.01,0.32,0.02,0.49,0.02c0.29,0,0.57-0.03,0.85-0.05C206,320.3,205.51,315.86,205.24,311.53z"
        />
        <path
          class="st4"
          d="M140.89,299.72c-11.05-6.1-18.99-13.91-21.05-21.06c-0.03,0.2-0.05,0.41-0.07,0.61
			c-0.04,0.66-0.06,1.2-0.06,1.64c0.01,0.26,0.02,0.51,0.04,0.77c0,0.08-0.01,0.17-0.01,0.25c0,0.11,0.01,0.21,0.01,0.3
			c0.02,0.64,0.06,1.03,0.06,1.03s0.03,0.32,0.06,0.66c0.05,0.35,0.09,0.7,0.16,1.05c0.11,1.09,0.34,2.15,0.67,3.16
			c0.22,1.02,0.56,2,0.98,2.94c0.32,0.96,0.74,1.87,1.24,2.74c0.4,0.89,0.88,1.73,1.44,2.52c0.47,0.84,1.02,1.63,1.63,2.37
			c0.54,0.81,1.16,1.56,1.84,2.25c0.55,0.7,1.16,1.34,1.83,1.93c0.59,0.66,1.23,1.27,1.92,1.82c0.66,0.67,1.39,1.28,2.18,1.82
			c0.62,0.56,1.28,1.06,1.99,1.51c0.73,0.61,1.52,1.15,2.35,1.61c0.68,0.51,1.4,0.96,2.16,1.35c0.55,0.38,1.14,0.72,1.74,1.03
			C140.15,308.73,139.82,304.26,140.89,299.72z"
        />
        <path
          class="st4"
          d="M268.99,314.01c0.07-0.02,0.14-0.04,0.21-0.06c0.26-0.07,0.51-0.14,0.77-0.22c0.04-0.01,0.09-0.02,0.13-0.03
			c2.1-0.7,2.5-6.46,1.04-13.45c-6.15,1.61-12.31,3.18-18.48,4.64c-15.22,3.62-30.68,5.78-45.24,6.51
			c0.25,4.57,0.67,9.11,1.34,12.74c0.11,0,0.22-0.01,0.33-0.01c0,0,0,0,0,0.01c0.22-0.02,0.44-0.04,0.66-0.06
			c0.1,0,0.19,0.01,0.29,0.01c0.62,0,1.23-0.05,1.84-0.12c0.06,0,0.13,0.01,0.19,0.01c0.65,0,1.29-0.06,1.92-0.14
			c0.03,0,0.06,0,0.09,0c0.68,0,1.35-0.06,2.01-0.15c0.74,0,1.47-0.07,2.18-0.18c0.74-0.01,1.46-0.08,2.16-0.19
			c0.73-0.02,1.44-0.09,2.14-0.21c0.72-0.03,1.43-0.1,2.12-0.22c0.71-0.03,1.42-0.11,2.1-0.24c0.71-0.04,1.4-0.12,2.08-0.25
			c0.68-0.05,1.35-0.13,2.01-0.26c0.66-0.05,1.32-0.14,1.95-0.27c0.66-0.06,1.3-0.15,1.93-0.29c0.65-0.06,1.28-0.16,1.9-0.3
			c0.64-0.06,1.27-0.17,1.88-0.31c0.66-0.07,1.3-0.19,1.92-0.34c0.64-0.07,1.27-0.2,1.89-0.35c0.63-0.08,1.25-0.2,1.85-0.36
			c0.62-0.09,1.22-0.21,1.82-0.37c0.6-0.09,1.2-0.22,1.78-0.38c0.59-0.1,1.17-0.22,1.73-0.38c0.57-0.1,1.13-0.23,1.68-0.39
			c0.46-0.09,0.92-0.2,1.37-0.33c0.45-0.09,0.89-0.2,1.33-0.33c0.47-0.09,0.93-0.21,1.39-0.34c0.49-0.1,0.97-0.22,1.45-0.36
			c0.51-0.1,1.01-0.22,1.5-0.37c0.53-0.1,1.05-0.23,1.55-0.39c0.54-0.11,1.06-0.24,1.58-0.4c0.55-0.11,1.1-0.24,1.63-0.41
			c0.57-0.11,1.13-0.25,1.67-0.42c0.59-0.11,1.16-0.26,1.72-0.43c0.6-0.11,1.19-0.26,1.76-0.45
			C268.45,314.14,268.72,314.08,268.99,314.01z"
        />
        <path
          class="st4"
          d="M273.23,299.71c1.12,5.3,1.22,10.05,0.51,13.07c0.63-0.12,1.25-0.28,1.86-0.47c0.66-0.12,1.31-0.29,1.94-0.49
			c0.67-0.12,1.33-0.29,1.97-0.5c0.68-0.12,1.35-0.29,1.99-0.51c0.69-0.13,1.36-0.3,2.02-0.51c0.57-0.1,1.12-0.24,1.66-0.41
			c0.01-0.09,0.02-0.18,0.04-0.27c0.04-0.39,0.1-0.78,0.16-1.16c0.04-0.42,0.1-0.83,0.17-1.23c0.04-0.44,0.11-0.87,0.18-1.3
			c0.04-0.46,0.11-0.92,0.2-1.37c0.05-0.48,0.12-0.96,0.21-1.43c0.05-0.5,0.12-1,0.22-1.49c0.05-0.52,0.13-1.04,0.23-1.55
			c0.05-0.54,0.13-1.06,0.24-1.58c0.05-0.55,0.14-1.09,0.25-1.63c0.03-0.31,0.09-0.6,0.14-0.9
			C282.54,297.24,277.88,298.49,273.23,299.71z"
        />
      </g>
      <g>
        <path
          class="st4"
          d="M340.99,295.65c0.12-0.03,0.26-0.06,0.39-0.09c0.36-0.07,0.7-0.17,1.05-0.27c2.25-0.82,2.53-6.56,0.99-13.48
			c-7.78,1.65-15.52,3.49-23.22,5.43c0.14,0.6,0.17,1.21,0.07,1.81c-0.06,0.35-0.16,0.98-0.19,1.18c0,0,0,0,0,0.01c0,0,0,0,0,0.01
			c-0.01,0.04-0.01,0.06-0.01,0.06s-0.01,0-0.01,0c-0.23,1.28-1.02,2.4-2.2,3.32c-0.04,0.26-0.09,0.53-0.14,0.78
			c-0.06,0.62-0.15,1.23-0.28,1.82c-0.05,0.6-0.14,1.19-0.27,1.77c-0.05,0.58-0.14,1.16-0.26,1.72c-0.05,0.57-0.13,1.12-0.25,1.67
			c-0.02,0.16-0.05,0.32-0.07,0.49c0.12-0.04,0.24-0.07,0.36-0.1c0.7-0.13,1.38-0.3,2.04-0.52c0.69-0.13,1.37-0.3,2.02-0.52
			c0.68-0.13,1.35-0.3,2-0.51c0.68-0.12,1.33-0.29,1.97-0.5c0.67-0.12,1.31-0.29,1.95-0.5c0.65-0.12,1.29-0.28,1.92-0.49
			c0.64-0.12,1.27-0.28,1.88-0.48c0.63-0.12,1.25-0.28,1.85-0.47c0.62-0.12,1.22-0.27,1.81-0.46c0.6-0.12,1.2-0.27,1.77-0.45
			c0.59-0.11,1.17-0.26,1.73-0.44c0.57-0.11,1.14-0.25,1.69-0.43c0.48-0.09,0.95-0.22,1.41-0.36
			C340.99,295.65,340.99,295.65,340.99,295.65z"
        />
        <path
          class="st4"
          d="M394.25,273.23c-15.19,1.29-29.37,4.25-45.16,7.4c-1.28,0.26-2.55,0.53-3.83,0.8
			c1.24,5.54,1.42,10.37,0.6,12.98c0.18-0.05,0.35-0.1,0.53-0.16c0.71-0.13,1.4-0.3,2.07-0.52c0.69-0.12,1.37-0.28,2.03-0.5
			c0.68-0.12,1.35-0.27,1.99-0.48c0.67-0.11,1.32-0.26,1.96-0.46c0.65-0.11,1.3-0.25,1.92-0.44c0.62-0.1,1.24-0.24,1.83-0.42
			c0.61-0.1,1.22-0.23,1.8-0.4c0.61-0.09,1.2-0.22,1.78-0.38c0.6-0.09,1.18-0.21,1.75-0.37c0.59-0.08,1.17-0.2,1.73-0.35
			c0.58-0.08,1.15-0.19,1.71-0.33c0.58-0.07,1.14-0.18,1.7-0.32c0.57-0.07,1.13-0.17,1.68-0.3c0.57-0.06,1.13-0.16,1.67-0.29
			c0.59-0.06,1.16-0.16,1.72-0.29c0.58-0.06,1.16-0.15,1.72-0.27c0.58-0.05,1.15-0.14,1.71-0.26c0.58-0.05,1.15-0.13,1.71-0.24
			c0.57-0.05,1.13-0.12,1.68-0.23c0.56-0.04,1.11-0.11,1.65-0.22c0.56-0.04,1.11-0.1,1.66-0.2c0.56-0.03,1.12-0.1,1.67-0.19
			c0.57-0.03,1.13-0.09,1.68-0.18c0.57-0.02,1.14-0.08,1.69-0.17c0.58-0.02,1.15-0.07,1.71-0.15c0.58-0.01,1.16-0.06,1.72-0.14
			c0.59-0.01,1.17-0.06,1.75-0.13c0.61,0,1.21-0.05,1.8-0.13c0.01,0,0.02,0,0.03,0c0.04,0,0.08,0,0.13,0
			C395.08,281.99,394.52,277.55,394.25,273.23z"
        />
        <path
          class="st4"
          d="M485.24,306.5c0.11-0.44,0.3-1.06,0.57-1.7c0.11-0.27,0.24-0.53,0.38-0.79c-0.19-3.59-1.61-9.47-7.84-15.1
			c-1.36,4.07-0.83,7.99,1.56,10.45c0.17,0.17,0.7,0.7,1.33,1.33c0.06,0.05,0.12,0.11,0.18,0.16c0.22,0.23,0.44,0.46,0.67,0.67
			c0.03,0.04,0.07,0.08,0.1,0.11c0.26,0.26,0.52,0.52,0.76,0.76c-0.03-0.01-0.07-0.02-0.1-0.02c0.01,0.01,0.01,0.02,0.02,0.02
			c0.19,0.25,0.37,0.5,0.57,0.74c0.14,0.22,0.3,0.43,0.45,0.65c0.15,0.28,0.32,0.55,0.49,0.81c0.11,0.23,0.22,0.46,0.34,0.68
			c0.09,0.22,0.2,0.44,0.3,0.65C485.09,306.13,485.17,306.31,485.24,306.5z"
        />
        <path
          class="st4"
          d="M476.35,287.26c-5.48-4.22-13.94-8.15-26.95-10.68c-0.83-0.16-1.64-0.31-2.46-0.46
			c-0.5,6.47,0.97,11.69,3.68,12.57c0.52,0.13,1.05,0.23,1.59,0.3c0.32,0.05,0.57,0.08,0.57,0.08c-0.01,0.01-0.02,0.02-0.03,0.03
			c0.4,0.09,0.8,0.19,1.21,0.25c0.54,0.15,1.1,0.27,1.67,0.36c0.54,0.16,1.1,0.29,1.66,0.39c0.56,0.17,1.13,0.31,1.71,0.42
			c0.55,0.18,1.1,0.32,1.67,0.43c0.52,0.17,1.05,0.32,1.6,0.44c0.47,0.16,0.95,0.3,1.45,0.41c0.46,0.17,0.92,0.31,1.4,0.43
			c0.44,0.17,0.89,0.32,1.35,0.45c0.44,0.18,0.88,0.34,1.34,0.47c0.44,0.19,0.89,0.35,1.35,0.5c0.37,0.17,0.76,0.31,1.15,0.44
			c0.36,0.17,0.72,0.32,1.09,0.46c0.34,0.17,0.67,0.33,1.02,0.47c0.44,0.23,0.89,0.44,1.36,0.63c0.47,0.29,0.96,0.55,1.47,0.78
			c0.18,0.12,0.36,0.23,0.54,0.34C474.74,294.08,474.91,290.73,476.35,287.26z"
        />
        <path
          class="st4"
          d="M444.91,275.75c-18.42-3.24-33.71-3.75-47.97-2.73c0.24,4.57,0.69,9.11,1.47,12.75c0.12,0,0.25,0,0.37,0
			c0.29-0.02,0.57-0.05,0.86-0.08c0.06,0,0.12,0.01,0.18,0.01c0.59,0,1.17-0.04,1.74-0.11c0.08,0,0.16,0.01,0.25,0.01
			c0.58,0,1.14-0.04,1.7-0.1c0.11,0,0.21,0.02,0.32,0.02c0.56,0,1.12-0.04,1.67-0.1c0.13,0,0.26,0.02,0.39,0.02
			c0.52,0,1.03-0.03,1.54-0.08c0.12,0,0.25,0.02,0.37,0.02c0.45,0,0.89-0.03,1.34-0.07c0.19,0.01,0.37,0.03,0.55,0.03
			c0.39,0,0.78-0.03,1.16-0.06c0.25,0.01,0.5,0.04,0.75,0.04c0.33,0,0.66-0.03,0.99-0.05c0.32,0.02,0.63,0.05,0.95,0.05
			c0.28,0,0.55-0.03,0.82-0.04c0.38,0.03,0.76,0.06,1.15,0.06c0.22,0,0.43-0.02,0.65-0.03c0.44,0.04,0.89,0.07,1.34,0.07
			c0.16,0,0.31-0.02,0.47-0.02c0.5,0.05,1.02,0.08,1.53,0.08c0.13,0,0.26-0.02,0.39-0.02c0.54,0.06,1.08,0.09,1.63,0.09
			c0.11,0,0.21-0.01,0.31-0.02c0.57,0.07,1.14,0.11,1.73,0.11c0.08,0,0.15-0.01,0.23-0.01c0.6,0.07,1.2,0.12,1.82,0.12
			c0.05,0,0.1-0.01,0.15-0.01c0.63,0.08,1.26,0.14,1.91,0.14c0.02,0,0.04,0,0.06,0c0.64,0.09,1.29,0.14,1.95,0.15
			c0.62,0.09,1.25,0.15,1.89,0.16c0.62,0.1,1.25,0.16,1.89,0.17c0.62,0.1,1.25,0.17,1.89,0.19c0.61,0.11,1.24,0.18,1.88,0.21
			c0.61,0.12,1.24,0.19,1.88,0.23c0.64,0.13,1.29,0.2,1.96,0.25c0.63,0.13,1.28,0.22,1.94,0.27c0.63,0.14,1.27,0.23,1.93,0.29
			c0.41,0.09,0.82,0.16,1.24,0.22C444.89,285.38,444.39,280.9,444.91,275.75z"
        />
      </g>
      <g>
        <path
          class="st5"
          d="M387.5,432.81c-13.57-1.17-29.53-4.93-30.43-4.75c-0.93,0.19,10.96,6.85,30.17,9.29
			C387.34,435.81,387.43,434.29,387.5,432.81z"
        />
        <path
          class="st5"
          d="M392.73,433.13c0,0-1.72-0.1-3.13-0.18c-0.03,1.55-0.11,3.1-0.21,4.66c0.7,0.07,1.42,0.14,1.42,0.14
			c20.95,1.98,45.99-0.62,48.54-3.97C441.91,430.42,406.87,433.78,392.73,433.13z"
        />
      </g>
      <g>
        <path
          class="st5"
          d="M384.35,395.47c-9.44-1.45-17.72-3.18-17.35-2.49c0.41,0.76,6.63,4.01,16.85,6.3
			C384.01,397.97,384.18,396.7,384.35,395.47z"
        />
        <path
          class="st5"
          d="M400.51,397.17c-3.72-0.09-8.1-0.56-12.45-1.16c-0.59-0.08-1.35-0.19-1.82-0.26
			c-0.14,1.12-0.3,2.42-0.48,3.94c0.01,0,0.02,0,0.03,0.01c0.66,0.14,2.15,0.41,2.15,0.41c3.47,0.62,7.29,1.1,11.43,1.34
			c19.22,1.13,29.82-1.74,31.75-4.59C433.05,394,413.55,397.48,400.51,397.17z"
        />
      </g>
      <g>
        <path
          class="st5"
          d="M393.84,337.81c-4.52-0.41-10.04-0.47-15.8,0.41c-14.28,2.19-22.23,5.77-22.47,8.07
			c-0.24,2.29,16.99-3.61,25.79-4.97c4.4-0.76,8.67-1.09,12.34-1.21C393.74,339.31,393.79,338.54,393.84,337.81z"
        />
        <path
          class="st5"
          d="M396.37,338.08c0,0-0.03,0-0.07-0.01c-0.03,0.64-0.05,1.3-0.08,1.98c5.01-0.07,8.42,0.18,8.61-0.03
			C405,339.81,401.63,338.75,396.37,338.08z"
        />
      </g>
      <g>
        <path
          class="st5"
          d="M339.43,270.71c-1.18,0.29-2.35,0.58-3.52,0.87c-6.29,1.6-11.11,2.8-15.24,3.82
			c-0.05,0.26-0.09,0.52-0.15,0.78c-0.06,0.74-0.17,1.46-0.34,2.16c-0.06,0.73-0.17,1.44-0.33,2.13c-0.01,0.13-0.03,0.26-0.05,0.39
			c6.48-1.58,13.01-3.19,16.79-4.16c1.55-0.43,3.23-0.84,4.98-1.23C340.91,273.68,340.18,272.07,339.43,270.71z"
        />
        <path
          class="st5"
          d="M372.77,267.22c-2.6-2.85-17.08-0.38-31.37,3.02c0.71,1.43,1.4,3.06,2.03,4.85
			C357.57,272.12,375.39,270.19,372.77,267.22z"
        />
      </g>
      <g>
        <path
          class="st5"
          d="M267.3,289.12c-4.33,1.13-9.06,2.37-10.97,2.88c-3.87,1.04-17.76,4.16-26.88,5.66
			c-8.57,1.3-16.56,1.89-22.3,2.27c0,0.94,0,1.92,0.01,2.94c5.43,0.56,12.94,0.71,21.36-0.22c6.55-0.8,15.92-2.9,26.1-5.35
			c4.84-1.16,10.28-2.53,14.67-3.65C268.67,291.95,268,290.41,267.3,289.12z"
        />
        <path
          class="st5"
          d="M204.99,300.07c-4.47,0.29-7.05,0.45-6.6,0.82c0.62,0.56,2.98,1.23,6.58,1.72
			C204.97,301.73,204.98,300.88,204.99,300.07z"
        />
        <path
          class="st5"
          d="M287.24,284.96c0-0.01,0.01-0.02,0.01-0.03c0.03-0.17,0.12-0.78,0.18-1.16c0-0.01,0.01-0.03,0.01-0.04
			c-5.56,1.49-10.33,2.81-11.63,3.17c-0.04,0.01-2.85,0.74-6.38,1.66c0.69,1.37,1.34,2.9,1.94,4.56c3.74-0.96,6.31-1.63,6.35-1.64
			c0.96-0.25,5.29-1.38,10.5-2.72C287.41,287.52,287.03,286.23,287.24,284.96z"
        />
      </g>
      <g>
        <path
          class="st5"
          d="M201.87,335.5c-10.42,0.14-20.2-0.57-20.84-0.32c-0.7,0.28,7.54,3.57,20.79,4.39
			C201.82,338.14,201.83,336.78,201.87,335.5z"
        />
        <path
          class="st5"
          d="M215.29,334.66c0,0-3.07,0.32-4.22,0.44c-2.29,0.18-4.67,0.3-7.05,0.36c-0.01,1.34-0.01,2.75,0,4.22
			c2.42,0.09,4.98,0.1,7.67,0c0.24,0,2.58-0.14,2.58-0.14c19.96-1.3,42.99-7.78,44.83-11.5
			C260.93,324.31,228.65,333.1,215.29,334.66z"
        />
      </g>
      <g>
        <path
          class="st5"
          d="M215.33,242.8c-2.27-0.39-4.63-0.69-7.07-0.85c-16.07-1.05-25.58,0.93-26.39,3.37
			c-0.81,2.44,19.36,0.16,29.26,0.8c1.26,0.06,2.51,0.15,3.73,0.26C215.01,245.15,215.16,243.95,215.33,242.8z"
        />
        <path
          class="st5"
          d="M228.23,246.21c0,0-1.85-0.64-2.14-0.73c-2.62-0.86-5.63-1.67-8.87-2.32c-0.13,0.98-0.26,2.11-0.42,3.42
			c3.02,0.33,5.88,0.79,8.43,1.27c0.19,0.03,2.2,0.44,2.2,0.43c5.55,1.14,9.27,2.26,9.53,2.07
			C237.2,250.17,233.8,248.21,228.23,246.21z"
        />
      </g>
      <g>
        <path
          class="st5"
          d="M217.97,24.47c-1.43,0.45-2.9,1.2-4.34,2.24c7.54,5.64,17.64,13.9,22.49,18.52
			c5.01,4.78,9.77,9.94,14.71,15.28c1.21-0.42,2.41-0.73,3.55-0.88c-2.97-4.04-6.88-8.73-11.68-13.45
			c-7.43-7.27-14.11-13.26-19.1-17.31C221.36,27.1,219.48,25.63,217.97,24.47z"
        />
        <path
          class="st5"
          d="M252.71,62.55c4.67,5.14,6.36,7.81,8.15,8.92c1.09,0.68-0.6-3.38-4.8-9.48
			C255,62.03,253.87,62.22,252.71,62.55z"
        />
      </g>
      <g>
        <path
          class="st5"
          d="M47.21,252.32c0,0-2.21-0.99-2.38-1.06c-0.71-0.31-1.47-0.61-2.24-0.92c-0.91,0.65-1.8,1.46-2.62,2.43
			c0.85,0.25,1.69,0.51,2.54,0.76c0.39,0.13,2.43,0.74,2.43,0.74c5.84,1.82,8.32,3.09,10.19,3.13
			C56.28,257.43,53.17,255.09,47.21,252.32z"
        />
        <path
          class="st5"
          d="M29.82,246.21c-0.16-0.04-0.31-0.07-0.46-0.11c-0.99,0.77-1.94,1.75-2.8,2.9c3.68,0.92,7.35,1.96,11.09,3.07
			c0.75-1.04,1.54-1.96,2.37-2.72C36.96,248.23,33.54,247.14,29.82,246.21z"
        />
      </g>
      <g>
        <path
          class="st6"
          d="M126.51,299.39c-0.18-0.23-0.36-0.46-0.52-0.71c-0.62-0.73-1.16-1.52-1.63-2.37
			c-0.56-0.79-1.04-1.63-1.44-2.52c-0.5-0.86-0.92-1.78-1.24-2.74c-0.42-0.93-0.75-1.91-0.98-2.94c-0.33-1.01-0.56-2.06-0.67-3.16
			c-0.02-0.08-0.03-0.17-0.05-0.25c-0.01-0.06-0.02-0.08-0.04-0.11c0,0,0-0.01-0.01-0.01c-0.01-0.01-0.02-0.04-0.05-0.1
			c-0.17-0.37-0.33-0.74-0.48-1.13c-0.13-0.35-0.25-0.7-0.35-1.05c0.05,0.17,0.1,0.34,0.16,0.53c-0.54-0.47-1.11-0.89-1.7-1.29
			c-1.26,2.83-1.77,7.07-0.3,12.71c0.58,2.23,1.52,4.3,2.65,6.22C122.11,299.63,124.37,299.29,126.51,299.39z"
        />
        <path
          class="st6"
          d="M176.79,327.88c-0.55-0.13-1.11-0.23-1.69-0.29c-0.51-0.12-1.02-0.22-1.55-0.29c-0.49-0.13-1-0.23-1.51-0.31
			c-0.48-0.13-0.97-0.24-1.46-0.33c-0.47-0.14-0.95-0.26-1.44-0.35c-0.49-0.15-0.99-0.28-1.49-0.38c-0.42-0.14-0.85-0.25-1.28-0.35
			c-0.39-0.14-0.79-0.25-1.2-0.36c-0.37-0.14-0.75-0.27-1.13-0.37c-0.35-0.14-0.71-0.28-1.07-0.39c-0.42-0.18-0.85-0.33-1.29-0.47
			c-0.45-0.2-0.92-0.39-1.4-0.55c-0.45-0.21-0.6-0.24-0.65-0.27c-1.42-0.62-3.25-1.37-3.63-1.52c-2.19-0.9-4.74-0.48-7.14,1.04
			c1.53,0.59,3.18,1.19,4.97,1.79c11.9,3.97,22.31,3.78,24.73,3.68C177.97,328.03,177.39,327.94,176.79,327.88z"
        />
        <path
          class="st6"
          d="M151.1,319.12c-0.16-0.09-0.31-0.18-0.47-0.26c-0.44-0.29-0.9-0.56-1.37-0.8c-0.45-0.31-0.92-0.61-1.4-0.87
			c-0.37-0.27-0.76-0.52-1.16-0.75c-0.37-0.29-0.76-0.56-1.16-0.82c-0.42-0.35-0.85-0.67-1.3-0.97c-0.34-0.3-0.7-0.58-1.07-0.85
			c-0.33-0.32-0.68-0.62-1.05-0.9c-0.37-0.38-0.76-0.74-1.17-1.08c-0.27-0.29-0.55-0.56-0.84-0.83c-0.05-0.06-0.1-0.11-0.15-0.17
			c0,0-0.01-0.01-0.02-0.03c-0.64-0.35-1.26-0.74-1.84-1.18c-0.84-0.46-1.62-1-2.35-1.61c-0.71-0.45-1.37-0.95-1.99-1.51
			c-0.78-0.54-1.51-1.15-2.18-1.82c-0.69-0.55-1.33-1.16-1.92-1.82c-0.25-0.23-0.49-0.47-0.73-0.71c-2.44-0.6-5.06-0.53-7.72,0.41
			c2.87,4.1,6.48,7.33,9.07,9.46c3.27,2.7,7.6,6.07,15.97,9.6C147.82,320.32,149.47,319.48,151.1,319.12z"
        />
      </g>
      <g>
        <path
          class="st6"
          d="M336.93,406.71c-0.06-0.04-0.13-0.07-0.19-0.11c-0.75-0.33-1.46-0.71-2.14-1.15
			c-0.7-0.33-1.39-0.71-2.03-1.14c-0.64-0.32-1.25-0.68-1.83-1.09c-0.14-0.07-0.27-0.15-0.4-0.23c-1.33-0.03-2.64-0.28-3.9-0.78
			c-0.02,0-0.04,0.01-0.04,0.01s-0.79-0.31-1.19-0.48c-3.01-1.31-5.23-3.83-6.45-6.96c-0.49-0.36-0.96-0.74-1.4-1.15
			c-0.51-0.39-1-0.79-1.46-1.24c-0.49-0.38-0.95-0.78-1.39-1.22c-0.45-0.36-0.87-0.75-1.27-1.16c-0.46-0.38-0.89-0.8-1.31-1.24
			c-0.44-0.38-0.86-0.79-1.25-1.22c-0.42-0.38-0.82-0.78-1.2-1.2c-0.41-0.37-0.79-0.76-1.16-1.18c-0.39-0.37-0.76-0.75-1.11-1.16
			c-0.37-0.36-0.73-0.73-1.06-1.13c-0.38-0.37-0.73-0.77-1.07-1.18c-0.34-0.35-0.67-0.72-0.98-1.11c-0.33-0.34-0.64-0.7-0.94-1.08
			c-0.21-0.23-0.24-0.26-0.25-0.27c0,0.01,0,0.01,0,0.02c-1.45,2.77-1.85,5.64-1.22,8.91c0.16,0.8,0.38,1.57,0.67,2.31
			c-0.04,0.4-0.07,0.81-0.08,1.22c-0.08,0.6-0.13,1.21-0.15,1.84c2.41,3.1,5.1,5.62,7.13,7.4c3.52,3.07,8.28,7,18.32,11.21
			C330.67,408.9,333.97,407.1,336.93,406.71z"
        />
        <path
          class="st6"
          d="M356.14,417.9c-0.49-0.25-1-0.46-1.51-0.65c-0.54-0.29-1.1-0.54-1.67-0.76c-0.52-0.29-1.06-0.56-1.61-0.79
			c-0.45-0.26-0.92-0.51-1.39-0.72c-0.4-0.25-0.82-0.48-1.25-0.7c-0.45-0.3-0.92-0.57-1.4-0.82c-0.42-0.29-0.85-0.57-1.3-0.81
			c-0.13-0.09-0.26-0.17-0.39-0.26c0,0,0,0,0,0c0.02,0.05,0.04,0.1,0.06,0.16c-1.23-0.92-2.84-2.07-3.18-2.31
			c-3.25-2.33-8.33-1.23-12.69,2.82c0.85,0.33,1.73,0.67,2.65,1.01c12.61,4.61,28.01,7.08,34.38,7.52
			C360.19,419.66,356.59,418.04,356.14,417.9z"
        />
      </g>
      <g>
        <path
          class="st6"
          d="M262.34,322.73c-4.82-3.22-10.78-3.53-15.41-1.09c0.02-0.02,0.03-0.03,0.05-0.05c0,0,0,0-0.01,0
			c-0.13,0.06-0.26,0.11-0.38,0.17c-0.47,0.17-0.93,0.36-1.37,0.57c-0.53,0.17-1.03,0.37-1.53,0.59c-0.56,0.17-1.1,0.37-1.63,0.59
			c-0.54,0.16-1.07,0.33-1.59,0.55c-0.51,0.14-1.01,0.3-1.49,0.48c-0.52,0.12-1.02,0.28-1.52,0.45c-0.56,0.12-1.1,0.28-1.64,0.46
			c-0.59,0.12-1.16,0.27-1.73,0.45c-0.59,0.11-1.18,0.25-1.74,0.42c-0.09,0.02-0.18,0.04-0.27,0.06c0.16-0.02,0.32-0.03,0.48-0.05
			c0.11,0,0.22,0.01,0.34,0.01c0.73-0.02,1.45-0.09,2.16-0.19c0.08,0,0.15,0.01,0.22,0.01c0.77-0.02,1.52-0.1,2.26-0.21
			c0.04,0,0.07,0,0.11,0c0.8-0.02,1.59-0.11,2.36-0.23c0.87-0.02,1.72-0.12,2.56-0.26c0.87-0.03,1.71-0.13,2.54-0.28
			c0.86-0.04,1.7-0.14,2.52-0.3c0.85-0.05,1.68-0.15,2.49-0.32c0.84-0.06,1.66-0.16,2.47-0.33c0.83-0.07,1.64-0.17,2.44-0.35
			c0.8-0.07,1.59-0.18,2.35-0.36c0.78-0.08,1.55-0.2,2.29-0.37c0.77-0.08,1.52-0.21,2.26-0.39
			C262.06,322.78,262.2,322.75,262.34,322.73z"
        />
        <path
          class="st6"
          d="M284.8,312.68c0.03-0.32,0.07-0.63,0.12-0.94c0.03-0.34,0.08-0.68,0.13-1.02c0.02-0.28,0.07-0.55,0.11-0.82
			c-0.54,0.16-1.09,0.3-1.66,0.41c-0.65,0.22-1.33,0.39-2.02,0.51c-0.65,0.21-1.31,0.38-1.99,0.51c-0.64,0.21-1.29,0.38-1.97,0.5
			c-0.63,0.21-1.28,0.37-1.94,0.49c-0.6,0.2-1.22,0.35-1.86,0.47c-0.44,1.86-1.18,3.07-2.19,3.33c-0.36,0.09-0.95,0.22-0.95,0.22
			s0,0-0.01-0.01c-0.97,0.2-2.1-0.5-3.26-1.88c0,0,0,0-0.01-0.01c-0.3,0.08-0.61,0.14-0.91,0.2c-0.56,0.18-1.13,0.32-1.72,0.43
			c-0.55,0.17-1.1,0.31-1.67,0.42c-0.53,0.17-1.07,0.3-1.63,0.41c-0.51,0.16-1.04,0.29-1.58,0.4c-0.51,0.16-1.03,0.28-1.55,0.39
			c-0.49,0.15-0.99,0.27-1.5,0.37c-0.47,0.14-0.95,0.26-1.45,0.36c-0.2,0.06-0.4,0.11-0.6,0.17l-0.01,0.01
			c-0.36,0.19-0.65,0.38-0.99,0.59c0,0,0,0,0,0c4.01-0.6,8.4,0.85,11.9,3.96c0.25-0.05,0.49-0.1,0.74-0.16
			c0.77-0.1,1.52-0.26,2.25-0.45c0.76-0.1,1.49-0.27,2.21-0.46c0.74-0.11,1.46-0.27,2.17-0.47c0.72-0.12,1.43-0.28,2.12-0.48
			c0.71-0.12,1.4-0.28,2.08-0.49c0.69-0.13,1.37-0.29,2.03-0.5c0.67-0.13,1.32-0.29,1.96-0.5c0.39-0.08,0.78-0.19,1.16-0.3
			C282.19,316.18,283.07,314.24,284.8,312.68z"
        />
      </g>
    </g>
    <g id="Details">
      <path
        class="st7"
        d="M292.26,252.69c-0.06,0.38-0.16,0.99-0.18,1.16c0,0.01-0.01,0.02-0.01,0.03c-0.21,1.33,0.19,2.68,1.07,3.97
		c0.28-1.78,0.52-3.34,0.56-3.59c0.68-4.21,7.84-6.55,15.99-5.24c8.16,1.31,14.22,5.79,13.54,9.99c-0.05,0.3-0.29,1.85-0.57,3.56
		c1.2-0.93,1.99-2.05,2.22-3.34c0,0,0.01,0,0.01,0s0-0.03,0.01-0.06c0,0,0,0,0-0.01c0,0,0,0,0-0.01c0.03-0.21,0.13-0.83,0.19-1.18
		c0.75-4.68-5.99-9.65-15.06-11.11C300.97,245.41,293.01,248.02,292.26,252.69z"
      />
      <path
        class="st8"
        d="M292.07,253.88c-0.21,1.33,0.19,2.68,1.07,3.97c0.28-1.78,0.52-3.34,0.56-3.59c0.68-4.21,7.84-6.55,15.99-5.24
		c8.16,1.31,14.22,5.79,13.54,9.99c-0.05,0.3-0.29,1.85-0.57,3.57c1.22-0.95,2.03-2.09,2.24-3.41c0.75-4.68-5.99-9.65-15.06-11.11
		C300.78,246.59,292.82,249.2,292.07,253.88z"
      />
      <path
        class="st9"
        d="M292.26,252.69c-0.06,0.38-0.16,0.99-0.18,1.16c0.78-4.66,8.73-7.26,17.78-5.8
		c9.07,1.46,15.8,6.43,15.06,11.11c0.03-0.21,0.13-0.83,0.19-1.18c0.75-4.68-5.99-9.65-15.06-11.11
		C300.97,245.41,293.01,248.02,292.26,252.69z"
      />
      <path
        class="st7"
        d="M287.43,283.77c-0.06,0.38-0.16,0.99-0.18,1.16c0,0.01-0.01,0.02-0.01,0.03c-0.21,1.33,0.19,2.68,1.07,3.97
		c0.28-1.78,0.52-3.34,0.56-3.59c0.68-4.21,7.84-6.55,15.99-5.24c8.16,1.31,14.22,5.79,13.54,9.99c-0.05,0.3-0.29,1.85-0.57,3.56
		c1.2-0.93,1.99-2.05,2.22-3.34c0,0,0.01,0,0.01,0s0-0.03,0.01-0.06c0,0,0,0,0-0.01c0,0,0,0,0-0.01c0.03-0.21,0.13-0.83,0.19-1.18
		c0.75-4.68-5.99-9.65-15.06-11.11S288.18,279.09,287.43,283.77z"
      />
      <path
        class="st8"
        d="M287.24,284.96c-0.21,1.33,0.19,2.68,1.07,3.97c0.28-1.78,0.52-3.34,0.56-3.59c0.68-4.21,7.84-6.55,15.99-5.24
		c8.16,1.31,14.22,5.79,13.54,9.99c-0.05,0.3-0.29,1.85-0.57,3.57c1.22-0.95,2.03-2.09,2.24-3.41c0.75-4.68-5.99-9.65-15.06-11.11
		C295.95,277.67,287.99,280.28,287.24,284.96z"
      />
      <path
        class="st9"
        d="M287.43,283.77c-0.06,0.38-0.16,0.99-0.18,1.16c0.78-4.66,8.73-7.26,17.78-5.8
		c9.07,1.46,15.8,6.43,15.06,11.11c0.03-0.21,0.13-0.83,0.19-1.18c0.75-4.68-5.99-9.65-15.06-11.11S288.18,279.09,287.43,283.77z"
      />
      <path
        class="st7"
        d="M296.83,223.78c-0.06,0.38-0.16,0.99-0.18,1.16c0,0.01-0.01,0.02-0.01,0.03c-0.21,1.33,0.19,2.68,1.07,3.97
		c0.28-1.78,0.52-3.34,0.56-3.59c0.68-4.21,7.84-6.55,15.99-5.24c8.16,1.31,14.22,5.79,13.54,9.99c-0.05,0.3-0.29,1.85-0.57,3.56
		c1.2-0.93,1.99-2.05,2.22-3.34c0,0,0.01,0,0.01,0s0-0.03,0.01-0.06c0,0,0,0,0-0.01c0,0,0,0,0-0.01c0.03-0.21,0.13-0.83,0.19-1.18
		c0.75-4.68-5.99-9.65-15.06-11.11C305.55,216.49,297.58,219.1,296.83,223.78z"
      />
      <path
        class="st8"
        d="M296.64,224.97c-0.21,1.33,0.19,2.68,1.07,3.97c0.28-1.78,0.52-3.34,0.56-3.59c0.68-4.21,7.84-6.55,15.99-5.24
		c8.16,1.31,14.22,5.79,13.54,9.99c-0.05,0.3-0.29,1.85-0.57,3.57c1.22-0.95,2.03-2.09,2.24-3.41c0.75-4.68-5.99-9.65-15.06-11.11
		C305.35,217.68,297.39,220.29,296.64,224.97z"
      />
      <path
        class="st9"
        d="M296.83,223.78c-0.06,0.38-0.16,0.99-0.18,1.16c0.78-4.66,8.73-7.26,17.78-5.8
		c9.07,1.46,15.8,6.43,15.06,11.11c0.03-0.21,0.13-0.83,0.19-1.18c0.75-4.68-5.99-9.65-15.06-11.11
		C305.55,216.49,297.58,219.1,296.83,223.78z"
      />
      <path
        class="st7"
        d="M301.47,194.38c-0.06,0.38-0.16,0.99-0.18,1.16c0,0.01-0.01,0.02-0.01,0.03c-0.21,1.33,0.19,2.68,1.07,3.97
		c0.28-1.78,0.52-3.34,0.56-3.59c0.68-4.21,7.84-6.55,15.99-5.24c8.16,1.31,14.22,5.79,13.54,9.99c-0.05,0.3-0.29,1.85-0.57,3.56
		c1.2-0.93,1.99-2.05,2.22-3.34c0,0,0.01,0,0.01,0s0-0.03,0.01-0.06c0,0,0,0,0-0.01c0,0,0,0,0-0.01c0.03-0.21,0.13-0.83,0.19-1.18
		c0.75-4.68-5.99-9.65-15.06-11.11C310.18,187.09,302.22,189.7,301.47,194.38z"
      />
      <path
        class="st8"
        d="M301.28,195.56c-0.21,1.33,0.19,2.68,1.07,3.97c0.28-1.78,0.52-3.34,0.56-3.59c0.68-4.21,7.84-6.55,15.99-5.24
		c8.16,1.31,14.22,5.79,13.54,9.99c-0.05,0.3-0.29,1.85-0.57,3.57c1.22-0.95,2.03-2.09,2.24-3.41c0.75-4.68-5.99-9.65-15.06-11.11
		C309.99,188.28,302.03,190.89,301.28,195.56z"
      />
      <path
        class="st9"
        d="M301.47,194.38c-0.06,0.38-0.16,0.99-0.18,1.16c0.78-4.66,8.73-7.26,17.78-5.8
		c9.07,1.46,15.8,6.43,15.06,11.11c0.03-0.21,0.13-0.83,0.19-1.18c0.75-4.68-5.99-9.65-15.06-11.11
		C310.18,187.09,302.22,189.7,301.47,194.38z"
      />
      <path
        class="st7"
        d="M305.52,165.96c-0.04,0.38-0.1,1-0.12,1.17c0,0.01-0.01,0.02-0.01,0.03c-0.14,1.34,0.34,2.66,1.28,3.9
		c0.18-1.79,0.34-3.36,0.37-3.61c0.45-4.24,7.47-6.97,15.69-6.1c8.21,0.87,14.51,5.01,14.06,9.25c-0.03,0.3-0.19,1.86-0.37,3.59
		c1.15-0.99,1.88-2.15,2.04-3.45c0,0,0.01-0.01,0.01-0.01s0-0.03,0.01-0.06c0,0,0,0,0-0.01c0,0,0,0,0-0.01
		c0.02-0.21,0.09-0.84,0.13-1.19c0.5-4.71-6.5-9.32-15.63-10.29C313.83,158.21,306.02,161.25,305.52,165.96z"
      />
      <path
        class="st8"
        d="M305.39,167.16c-0.14,1.34,0.34,2.66,1.28,3.9c0.18-1.79,0.34-3.36,0.37-3.61c0.45-4.24,7.47-6.97,15.69-6.1
		c8.21,0.87,14.51,5.01,14.06,9.25c-0.03,0.3-0.19,1.86-0.37,3.59c1.17-1.01,1.91-2.2,2.05-3.53c0.5-4.71-6.5-9.32-15.63-10.29
		C313.7,159.41,305.89,162.45,305.39,167.16z"
      />
      <path
        class="st9"
        d="M305.52,165.96c-0.04,0.38-0.1,1-0.12,1.17c0.53-4.69,8.32-7.72,17.44-6.75c9.13,0.97,16.13,5.57,15.63,10.28
		c0.02-0.21,0.09-0.84,0.13-1.19c0.5-4.71-6.5-9.32-15.63-10.29C313.83,158.21,306.02,161.25,305.52,165.96z"
      />
      <path
        class="st7"
        d="M236.65,82.76c0.28,0.34,0.72,0.9,0.85,1.05c0.01,0.01,0.01,0.02,0.02,0.03c0.97,1.2,2.35,1.96,4,2.31
		c-1.19-1.45-2.1-2.59-2.62-3.25c-3.07-3.82-0.36-11.08,6.05-16.23c6.41-5.15,14.09-6.23,17.15-2.41c0.44,0.55,1.46,1.78,2.64,3.2
		c0.01-1.63-0.45-3.09-1.37-4.27c0,0,0-0.01,0-0.01s-0.02-0.02-0.05-0.06c0,0,0,0,0-0.01c0,0,0,0,0,0c-0.15-0.19-0.6-0.75-0.86-1.07
		c-3.41-4.24-11.95-3.04-19.07,2.68S233.24,78.52,236.65,82.76z"
      />
      <path
        class="st8"
        d="M237.52,83.84c0.97,1.2,2.35,1.96,4,2.31c-1.28-1.57-2.4-2.97-2.62-3.25c-3.07-3.82-0.36-11.08,6.05-16.23
		c6.41-5.15,14.09-6.23,17.15-2.41c0.25,0.32,1.39,1.69,2.64,3.21c0.01-1.67-0.46-3.15-1.42-4.35c-3.41-4.24-11.95-3.04-19.07,2.68
		S234.11,79.59,237.52,83.84z"
      />
      <path
        class="st9"
        d="M236.65,82.76c0.28,0.34,0.72,0.9,0.85,1.05c-3.38-4.25-0.36-12.31,6.75-18.02
		c7.12-5.72,15.66-6.92,19.07-2.69c-0.15-0.19-0.6-0.75-0.86-1.07c-3.41-4.24-11.95-3.04-19.07,2.68S233.24,78.52,236.65,82.76z"
      />
      <path
        class="st7"
        d="M441.47,419.88c-0.34,0.1-0.88,0.26-1.03,0.31c-0.01,0-0.02,0-0.03,0c-1.18,0.35-2.13,1.26-2.83,2.58
		c1.43-0.44,2.55-0.76,3.2-0.94c3.75-1.1,8.68,4.43,11,12.34c2.32,7.92,1.16,15.23-2.59,16.33c-0.54,0.16-1.76,0.54-3.16,0.98
		c1.26,0.71,2.51,0.92,3.67,0.61c0,0,0.01,0,0.01,0s0.02-0.01,0.06-0.02c0,0,0,0,0.01,0c0,0,0,0,0,0c0.18-0.05,0.74-0.22,1.06-0.31
		c4.17-1.22,5.46-9.35,2.88-18.16C451.12,424.8,445.65,418.66,441.47,419.88z"
      />
      <path
        class="st8"
        d="M440.41,420.19c-1.18,0.35-2.13,1.26-2.83,2.58c1.55-0.47,2.92-0.87,3.2-0.94c3.75-1.1,8.68,4.43,11,12.34
		c2.32,7.92,1.16,15.23-2.59,16.33c-0.31,0.09-1.67,0.51-3.17,0.98c1.29,0.72,2.56,0.94,3.74,0.59c4.17-1.22,5.46-9.35,2.88-18.16
		C450.06,425.11,444.59,418.97,440.41,420.19z"
      />
      <path
        class="st9"
        d="M441.47,419.88c-0.34,0.1-0.88,0.26-1.03,0.31c4.17-1.19,9.63,4.95,12.21,13.73
		c2.58,8.8,1.29,16.93-2.88,18.16c0.18-0.05,0.74-0.22,1.06-0.31c4.17-1.22,5.46-9.35,2.88-18.16
		C451.12,424.8,445.65,418.66,441.47,419.88z"
      />
      <path
        class="st7"
        d="M439.89,384.07c-0.39,0.13-1.01,0.33-1.18,0.39c-0.01,0-0.02,0-0.03,0.01c-1.35,0.44-2.44,1.44-3.25,2.83
		c1.64-0.55,2.92-0.97,3.65-1.2c4.29-1.41,9.85,3.81,12.42,11.65c2.57,7.84,1.18,15.34-3.11,16.74c-0.62,0.2-2.01,0.69-3.62,1.24
		c1.44,0.62,2.85,0.74,4.18,0.33c0,0,0.01,0,0.01,0s0.03-0.01,0.06-0.02c0,0,0,0,0.01,0c0,0,0,0,0.01,0
		c0.21-0.07,0.85-0.28,1.21-0.4c4.77-1.56,6.32-9.9,3.46-18.62C450.85,388.3,444.66,382.5,439.89,384.07z"
      />
      <path
        class="st8"
        d="M438.68,384.47c-1.35,0.44-2.44,1.44-3.25,2.83c1.77-0.59,3.34-1.11,3.65-1.2c4.29-1.41,9.85,3.81,12.42,11.65
		c2.57,7.84,1.18,15.34-3.11,16.74c-0.36,0.11-1.91,0.65-3.62,1.24c1.47,0.63,2.91,0.75,4.26,0.31c4.77-1.56,6.32-9.9,3.46-18.62
		C449.63,388.7,443.45,382.9,438.68,384.47z"
      />
      <path
        class="st9"
        d="M439.89,384.07c-0.39,0.13-1.01,0.33-1.18,0.39c4.77-1.53,10.93,4.26,13.78,12.96
		c2.86,8.72,1.31,17.05-3.45,18.62c0.21-0.07,0.85-0.28,1.21-0.4c4.77-1.56,6.32-9.9,3.46-18.62
		C450.85,388.3,444.66,382.51,439.89,384.07z"
      />
      <path
        id="_x3C_Pfad_x3E__15_"
        class="st7"
        d="M465.36,407.69c-0.1,0.12-0.19,0.24-0.29,0.36c-0.05,0.06-0.11,0.1-0.17,0.16
		c-0.53,0.59-0.96,1.22-1.34,1.89c4.13-3.89,10.63-5.11,16.52-2.56c7.69,3.32,11.72,11.89,8.61,18.99
		c-0.74,1.68-2.17,3.16-2.95,3.95c-0.78,0.79-1.16,1.06-1.54,1.36c-0.14,0.11-0.38,0.31-0.61,0.5c1.85-0.61,3.52-1.64,4.86-3.12
		c0.1-0.12,0.19-0.24,0.29-0.36c0,0,0,0,0,0c0.05-0.06,0.11-0.11,0.17-0.16c4.85-5.4,3.52-14.47-2.98-20.27
		C479.42,402.62,470.22,402.3,465.36,407.69z M473.28,404.45C473.28,404.45,473.28,404.45,473.28,404.45
		C473.28,404.45,473.28,404.45,473.28,404.45z"
      />
      <path
        class="st8"
        d="M485.39,409.02c6.5,5.8,7.86,14.84,3.05,20.2c-1.33,1.48-3.01,2.51-4.86,3.12c0.24-0.19,0.47-0.39,0.61-0.5
		c0.38-0.3,0.76-0.57,1.54-1.36c0.78-0.79,2.22-2.27,2.95-3.95c3.11-7.11-0.92-15.67-8.61-18.99c-5.89-2.55-12.39-1.33-16.52,2.56
		c0.38-0.66,0.82-1.3,1.34-1.89C469.72,402.86,478.9,403.22,485.39,409.02z"
      />
      <path
        class="st9"
        d="M485.92,408.42c6.5,5.8,7.83,14.88,2.98,20.27c-0.05,0.06-0.11,0.11-0.17,0.16
		c4.45-5.39,3.02-14.16-3.34-19.84c-6.43-5.74-15.47-6.14-20.32-0.96c0.1-0.12,0.18-0.25,0.29-0.36
		C470.22,402.3,479.42,402.62,485.92,408.42z"
      />
      <path
        id="_x3C_Pfad_x3E__20_"
        class="st7"
        d="M249.31,319.8c-0.13,0.08-0.25,0.18-0.38,0.27c-0.07,0.04-0.14,0.07-0.2,0.11
		c-0.66,0.42-1.26,0.92-1.8,1.46c5.02-2.65,11.61-2.07,16.6,1.96c6.52,5.26,8.11,14.59,3.21,20.6c-1.16,1.42-2.94,2.46-3.9,3.01
		c-0.96,0.55-1.4,0.71-1.85,0.9c-0.17,0.07-0.45,0.19-0.73,0.32c1.95-0.09,3.84-0.64,5.52-1.71c0.13-0.08,0.25-0.18,0.37-0.27
		c0,0,0,0,0,0c0.07-0.04,0.14-0.07,0.2-0.11c6.12-3.9,7.26-13,2.56-20.33C264.21,318.68,255.43,315.9,249.31,319.8z M257.81,318.8
		C257.81,318.8,257.81,318.8,257.81,318.8C257.81,318.8,257.81,318.8,257.81,318.8z"
      />
      <path
        class="st8"
        d="M268.25,326.45c4.71,7.33,3.6,16.41-2.47,20.28c-1.68,1.07-3.57,1.61-5.52,1.71c0.28-0.12,0.56-0.25,0.73-0.32
		c0.44-0.19,0.88-0.34,1.85-0.9c0.96-0.55,2.74-1.59,3.9-3.01c4.9-6.01,3.31-15.34-3.21-20.6c-4.99-4.03-11.58-4.6-16.6-1.96
		c0.54-0.54,1.14-1.03,1.8-1.46C254.8,316.32,263.55,319.12,268.25,326.45z"
      />
      <path
        class="st9"
        d="M268.92,326.01c4.71,7.33,3.56,16.43-2.56,20.33c-0.07,0.04-0.14,0.07-0.2,0.11c5.73-4,6.7-12.84,2.1-20.01
		c-4.66-7.25-13.26-10.06-19.32-6.37c0.13-0.09,0.24-0.19,0.38-0.27C255.43,315.9,264.21,318.68,268.92,326.01z"
      />
      <path
        id="_x3C_Pfad_x3E__14_"
        class="st7"
        d="M455.94,259.28c0.49,0.08,1.1,0.19,1.58,0.27c-0.62-1.08-1.39-1.77-2.3-1.93
		c-0.02,0-0.05,0-0.07,0c0,0,0,0,0,0c0,0,0-0.01,0-0.01s-0.66-0.07-1.01-0.13c-3.36-0.57-7.31,6.3-8.83,15.34
		c-1.52,9.05-0.02,16.84,3.34,17.41c0.42,0.07,1.26,0.17,1.26,0.17s0.01-0.01,0.01-0.01c0.95,0.09,1.91-0.36,2.88-1.31
		c-0.01,0-1.13-0.16-1.79-0.27c-3.39-0.58-5.03-7.66-3.67-15.81C448.69,264.84,452.55,258.7,455.94,259.28z"
      />
      <path
        class="st8"
        d="M450.99,288.81c-3.39-0.58-5.03-7.65-3.67-15.81c1.37-8.15,5.22-14.3,8.62-13.72c0.49,0.08,1.1,0.19,1.58,0.27
		c-0.62-1.08-1.39-1.77-2.3-1.93c-3.39-0.58-7.37,6.29-8.89,15.33c-1.52,9.05,0.01,16.85,3.4,17.42c1.01,0.17,2.02-0.28,3.05-1.28
		C452.28,289.02,451.65,288.92,450.99,288.81z"
      />
      <path
        class="st9"
        d="M449.73,290.37c-3.39-0.58-4.91-8.38-3.4-17.42c1.5-8.98,5.44-15.8,8.81-15.34c0,0,0-0.01,0-0.01
		s-0.66-0.07-1.01-0.13c-3.36-0.57-7.31,6.3-8.83,15.34c-1.52,9.05-0.02,16.84,3.34,17.41c0.42,0.07,1.26,0.17,1.26,0.17
		s0.01-0.01,0.01-0.01C449.84,290.38,449.78,290.38,449.73,290.37z"
      />
      <path
        class="st7"
        d="M344.74,279.31c-2.35-8.87-6.39-15.59-9.03-15.01c-0.33,0.07-0.97,0.26-0.97,0.26s0,0.01,0,0.01
		c0.04-0.01,0.09-0.03,0.13-0.04c-0.79,0.17-1.34,0.93-1.71,2.2c0.38-0.09,0.87-0.21,1.39-0.33c2.66-0.59,6.26,5.42,8.38,13.42
		c2.12,8,1.95,14.96-0.71,15.55c-0.38,0.08-0.87,0.19-1.24,0.28c0.86,0.8,1.68,1.18,2.39,1.02c0.02,0,0.04-0.02,0.06-0.02
		c0,0,0,0,0,0c0,0,0.01,0.01,0.01,0.01s0.51-0.15,0.78-0.21C346.86,295.86,347.09,288.19,344.74,279.31z M345.54,291.08
		c0,0.02,0,0.04,0,0.06C345.54,291.12,345.54,291.1,345.54,291.08z"
      />
      <path
        class="st8"
        d="M334.56,266.4c2.66-0.59,6.26,5.42,8.38,13.42c2.12,8,1.95,14.96-0.71,15.55c-0.38,0.08-0.87,0.19-1.24,0.28
		c0.86,0.8,1.68,1.18,2.39,1.02c2.66-0.59,2.92-8.26,0.57-17.14c-2.35-8.87-6.41-15.59-9.07-15c-0.79,0.17-1.34,0.93-1.71,2.2
		C333.55,266.64,334.04,266.52,334.56,266.4z"
      />
      <path
        class="st9"
        d="M334.87,264.53c2.66-0.59,6.72,6.13,9.07,15c2.33,8.81,2.09,16.43-0.51,17.11c0,0,0.01,0.01,0.01,0.01
		s0.51-0.15,0.78-0.21c2.64-0.58,2.87-8.25,0.52-17.13c-2.35-8.87-6.39-15.59-9.03-15.01c-0.33,0.07-0.97,0.26-0.97,0.26
		s0,0.01,0,0.01C334.78,264.56,334.83,264.54,334.87,264.53z"
      />
      <path
        class="st7"
        d="M272.75,297.64c-2.41-9.45-7.06-16.47-9.93-15.74c-0.32,0.08-0.7,0.17-0.86,0.2c0,0,0,0,0,0
		c-0.01,0-0.02,0-0.02,0c-0.99,0.25-1.67,1.45-2.04,3.28c1.1-0.29,2.21-0.58,2.69-0.7c2.4-0.61,6.01,5.4,8.05,13.42
		c2.05,8.03,1.76,15.03-0.64,15.64c-0.39,0.1-1.52,0.39-2.68,0.69c1.16,1.38,2.29,2.08,3.26,1.88c0,0,0.01,0.01,0.01,0.01
		s0.59-0.13,0.95-0.22C274.42,315.38,275.16,307.09,272.75,297.64z"
      />
      <path
        class="st8"
        d="M262.6,284.69c2.4-0.61,6.01,5.4,8.05,13.42c2.05,8.03,1.76,15.03-0.64,15.64c-0.39,0.1-1.52,0.39-2.68,0.69
		c1.19,1.41,2.35,2.13,3.33,1.87c2.83-0.72,3.48-9,1.07-18.45c-2.41-9.45-6.97-16.48-9.8-15.76c-0.99,0.25-1.67,1.45-2.04,3.28
		C261.01,285.1,262.12,284.81,262.6,284.69z"
      />
      <path
        class="st9"
        d="M271.74,297.87c2.41,9.45,1.75,17.73-1.07,18.45c-0.02,0.01-0.05,0-0.07,0.01c0,0,0.01,0.01,0.01,0.01
		s0.59-0.13,0.95-0.22c2.87-0.73,3.61-9.03,1.2-18.48c-2.41-9.45-7.06-16.47-9.93-15.74c-0.32,0.08-0.7,0.17-0.86,0.2
		C264.79,281.43,269.34,288.45,271.74,297.87z"
      />
      <path
        class="st7"
        d="M302.42,390.64c-0.31-0.79-0.55-1.62-0.72-2.48c-0.64-3.27-0.23-6.14,1.22-8.91c0.52,0.6,1.26,1.34,1.58,1.82
		C302.69,386.15,302.42,390.64,302.42,390.64z"
      />
      <path
        class="st8"
        d="M302.42,390.64c-0.31-0.79-0.55-1.62-0.72-2.48c-0.64-3.27-0.23-6.14,1.22-8.91c0.52,0.6,1.26,1.34,1.58,1.82
		C302.69,386.15,302.42,390.64,302.42,390.64z"
      />
      <path
        class="st7"
        d="M149.38,271.69c-1.98-4.87-6.31-8.68-11.86-9.76c-8.73-1.68-17.17,4.02-18.85,12.74
		c-0.67,3.46-0.16,6.86,1.23,9.83c0.14,0.35,0.01-0.21-0.02-0.56s-0.06-0.69-0.06-0.69s-0.04-0.39-0.06-1.03s-0.11-1.68,0.08-3.78
		c0.19-2.09,0.46-3.61,1.21-5.37c3.28-7.59,12.1-11.08,19.69-7.79c4.96,2.15,8.15,6.66,8.86,11.65c0.17,0.73,0.14,2.22,0.14,2.22
		s-0.04,0.39-0.08,1.01c0.18,0.48,0.59,0.92,0.95,1.34C151.28,278.06,150.76,274.66,149.38,271.69z"
      />
      <path
        class="st8"
        d="M119.9,284.5c-1.13-2.78-1.51-5.91-0.9-9.08c1.68-8.72,10.12-14.42,18.85-12.74c5.27,1.02,9.42,4.5,11.53,9.01
		c1.39,2.96,1.9,6.37,1.23,9.83c-0.35-0.42-0.76-0.86-0.95-1.34c0.04-0.62,0.08-1.01,0.08-1.01s0.03-1.49-0.14-2.22
		c-0.71-4.99-3.9-9.5-8.86-11.65c-7.59-3.28-16.4,0.21-19.69,7.79c-0.76,1.75-1.02,3.27-1.21,5.37c-0.19,2.09-0.1,3.14-0.08,3.78
		c0.02,0.64,0.06,1.03,0.06,1.03s0.03,0.33,0.06,0.69S120.04,284.85,119.9,284.5z"
      />
      <path
        class="st9"
        d="M137.85,262.69c-8.73-1.68-17.17,4.02-18.85,12.74c-0.61,3.17-0.24,6.29,0.9,9.08
		c-1.39-2.96-1.9-6.37-1.23-9.83c1.68-8.72,10.12-14.42,18.85-12.74c5.56,1.07,9.88,4.88,11.86,9.76
		C147.27,267.18,143.12,263.7,137.85,262.69z"
      />
      <path
        class="st7"
        d="M457.44,370.16c2.67-4.44,7.45-7.49,13.02-7.68c8.74-0.31,16.08,6.52,16.39,15.25
		c0.12,3.46-0.89,6.7-2.69,9.37c-0.19,0.32,0.02-0.21,0.1-0.54c0.08-0.34,0.17-0.66,0.17-0.66s0.1-0.37,0.21-0.99
		c0.12-0.62,0.36-1.62,0.49-3.69c0.13-2.07,0.11-3.58-0.37-5.4c-2.04-7.88-10.08-12.61-17.96-10.57c-5.15,1.33-8.94,5.24-10.39,9.98
		c-0.1,0.24-0.18,0.57-0.25,0.91c-0.27,0.46-0.97,1.11-1.37,1.48C455.03,374.87,455.97,372.33,457.44,370.16z"
      />
      <path
        class="st8"
        d="M484.16,387.09c1.52-2.53,2.36-5.52,2.25-8.69c-0.31-8.73-7.65-15.56-16.39-15.25
		c-5.28,0.19-9.84,2.94-12.58,7.01c-1.46,2.17-2.41,4.71-2.64,7.45c0.32-0.3,1.04-0.93,1.37-1.47c0.07-0.33,0.16-0.67,0.25-0.91
		c1.45-4.74,5.24-8.65,10.39-9.98c7.88-2.04,15.92,2.69,17.96,10.57c0.47,1.82,0.49,3.34,0.37,5.4c-0.13,2.07-0.38,3.07-0.49,3.69
		c-0.12,0.62-0.21,0.99-0.21,0.99s-0.08,0.32-0.17,0.66C484.18,386.89,483.96,387.41,484.16,387.09z"
      />
      <path
        class="st9"
        d="M470.02,363.15c8.74-0.31,16.08,6.52,16.39,15.25c0.11,3.17-0.73,6.16-2.25,8.69c1.8-2.67,2.81-5.91,2.69-9.37
		c-0.31-8.73-7.65-15.56-16.39-15.25c-5.57,0.2-10.35,3.25-13.02,7.68C460.17,366.09,464.74,363.34,470.02,363.15z"
      />
      <path
        class="st7"
        d="M329.68,402.56c-0.54-0.3-1.06-0.63-1.55-0.99c-0.53-0.31-1.04-0.65-1.53-1.03c-0.23-0.14-0.46-0.29-0.68-0.44
		c-0.1-0.06-0.19-0.14-0.29-0.2c-0.14-0.11-0.29-0.21-0.43-0.32c-0.05-0.04-0.1-0.07-0.14-0.11c-0.21-0.14-0.37-0.3-0.5-0.47
		c-4.12-3.94-5.23-10.87-2.29-17.08c3.55-7.51,11.67-11.13,18.12-8.08c0.44,0.21,0.86,0.45,1.26,0.7c0.01,0,0.01,0,0.02,0.01
		c0.49,0.32,0.95,0.63,1.41,1c0.23,0.16,0.47,0.32,0.7,0.5c0.26,0.17,0.51,0.35,0.76,0.53c0.27,0.16,0.54,0.33,0.81,0.51
		c-1.19-2.28-2.97-4.13-5.31-5.24c-0.18-0.09-0.37-0.14-0.55-0.22c-0.01-0.02-0.02-0.03-0.02-0.03s-0.59-0.23-0.77-0.31
		c-6.83-2.98-15.71,1.44-19.38,9.85c-3.67,8.41-0.91,17.61,5.92,20.59c0.4,0.17,1.19,0.48,1.19,0.48s0.01,0,0.04-0.01
		c1.27,0.5,2.6,0.76,3.94,0.78C330.15,402.85,329.91,402.71,329.68,402.56z"
      />
      <path
        class="st8"
        d="M329.68,402.56c-0.54-0.3-1.06-0.63-1.55-0.99c-0.53-0.31-1.04-0.65-1.53-1.03c-0.23-0.14-0.46-0.29-0.68-0.44
		c-0.1-0.06-0.19-0.14-0.29-0.2c-0.14-0.11-0.29-0.21-0.43-0.32c-0.05-0.04-0.1-0.07-0.14-0.11c-0.21-0.14-0.37-0.3-0.5-0.47
		c-4.12-3.94-5.23-10.87-2.29-17.08c3.55-7.51,11.67-11.13,18.12-8.08c0.44,0.21,0.86,0.45,1.26,0.7c0.01,0,0.01,0,0.02,0.01
		c0.49,0.32,0.95,0.63,1.41,1c0.23,0.16,0.47,0.32,0.7,0.5c0.26,0.17,0.51,0.35,0.76,0.53c0.27,0.16,0.54,0.33,0.81,0.51
		c-1.19-2.28-2.97-4.13-5.31-5.24c-6.74-3.19-15.61,1.01-19.54,9.32c-3.93,8.31-1.43,17.58,5.3,20.77c1.47,0.69,3.03,1.02,4.61,1.05
		C330.15,402.85,329.91,402.71,329.68,402.56z"
      />
      <path
        class="st9"
        d="M325.78,401.94c-6.74-3.19-9.23-12.46-5.3-20.77c3.83-8.09,12.33-12.26,18.99-9.54
		c-0.01-0.02-0.02-0.03-0.02-0.03s-0.59-0.23-0.77-0.31c-6.83-2.98-15.71,1.44-19.38,9.85c-3.67,8.41-0.91,17.61,5.92,20.59
		c0.4,0.17,1.19,0.48,1.19,0.48s0.01,0,0.04-0.01C326.22,402.12,326,402.04,325.78,401.94z"
      />
      <path
        class="st7"
        d="M116.36,302.3c-8.02,5.48-9.77,15.04-6.4,21.1c0.23,0.4,0.7,1.17,0.7,1.17s0.02,0.01,0.04,0.02
		c1.43,2.3,3.48,3.97,5.85,4.98c-2.01-2.42-3.25-3.95-4.13-5.3c-3.58-6.82-1-16.08,5.89-20.33c3.61-2.19,7.26-2.61,10.57-1.81
		c-1-1.14-1.88-2.16-2.39-2.77C123.2,299.23,119.65,300.11,116.36,302.3z"
      />
      <path
        class="st8"
        d="M117.32,302.34c-7.67,4.72-10.85,14.32-7.11,21.45c1.44,2.74,3.7,4.71,6.37,5.83
		c-2.02-2.44-3.27-3.97-4.16-5.33c-3.58-6.82-1-16.08,5.89-20.33c3.61-2.18,7.28-2.6,10.61-1.79c-0.57-0.62-1.67-1.86-2.13-2.39
		C123.68,299.63,120.37,300.46,117.32,302.34z"
      />
      <path
        class="st9"
        d="M116.36,302.3c-8.02,5.48-9.77,15.04-6.4,21.1c0.23,0.4,0.7,1.17,0.7,1.17s0.02,0.01,0.04,0.02
		c-0.17-0.27-0.34-0.53-0.49-0.82c-3.74-7.12-0.56-16.72,7.11-21.45c3.06-1.88,6.36-2.7,9.47-2.56c-0.07-0.09-0.24-0.31-0.32-0.4
		C123.2,299.23,119.65,300.11,116.36,302.3z"
      />
      <path
        class="st7"
        d="M99.15,280.12c-7.61,6.04-8.67,15.69-4.88,21.5c0.26,0.39,0.78,1.12,0.78,1.12s0.02,0.01,0.05,0.02
		c1.59,2.19,3.76,3.72,6.19,4.55c-2.18-2.27-3.52-3.71-4.5-5c-4.06-6.54-2.14-15.97,4.43-20.69c6.28-4.45,13.17-2.95,18.01,1.22
		c-0.44-1.33-0.59-2.26-0.71-3.05C113.93,275.61,105.76,275.02,99.15,280.12z"
      />
      <path
        class="st8"
        d="M100.12,280.09c-7.31,5.26-9.8,15.06-5.57,21.9c1.63,2.63,4.03,4.43,6.77,5.36c-2.19-2.28-3.54-3.73-4.53-5.02
		c-4.06-6.54-2.14-15.97,4.43-20.69c6.27-4.44,13.23-2.92,18.01,1.22c-0.32-0.91-0.56-2.02-0.67-2.82
		C113.76,275.87,106.22,275.7,100.12,280.09z"
      />
      <path
        class="st9"
        d="M99.15,280.12c-7.61,6.04-8.67,15.69-4.88,21.5c0.26,0.39,0.78,1.12,0.78,1.12s0.02,0.01,0.05,0.02
		c-0.19-0.26-0.38-0.51-0.55-0.78c-4.24-6.84-1.75-16.64,5.57-21.9c6.12-4.4,13.65-4.23,18.44-0.05c-0.01-0.07-0.02-0.15-0.03-0.24
		C113.93,275.6,105.77,275.01,99.15,280.12z"
      />
      <path
        class="st7"
        d="M478.76,282.94c-5.19,7.31-4.79,15.02,0.83,18.32c0.33,0.17,0.96,0.48,0.96,0.48s0.02,0,0.04-0.01
		c0.74,0.33,1.53,0.55,2.36,0.68c-1.2-1.19-2.74-2.72-3.06-3.04c-3.4-3.49-3.05-9.95,1.19-15.6c4.9-6.52,13.15-9.49,18.42-6.63
		c0.52,0.29,1,0.62,1.43,0.99c0.38,0.33,1.44,1.36,2.53,2.45c-0.46-1.88-1.43-3.48-2.93-4.6c0,0,0,0,0,0s-0.87-0.69-2.02-1.22
		C492.87,271.93,483.94,275.63,478.76,282.94z"
      />
      <path
        class="st8"
        d="M479.8,282.96c-5.4,7.21-5.31,15.49,0.21,18.5c0.9,0.49,1.9,0.8,2.96,0.96c-1.2-1.19-2.75-2.73-3.07-3.05
		c-3.4-3.49-3.05-9.95,1.19-15.6c4.9-6.52,13.15-9.49,18.42-6.63c0.52,0.29,1,0.62,1.43,0.99c0.38,0.33,1.45,1.37,2.54,2.46
		c-0.55-2.26-1.85-4.11-3.9-5.23C494.05,272.35,485.2,275.76,479.8,282.96z"
      />
      <path
        class="st9"
        d="M478.76,282.94c-5.19,7.31-4.79,15.02,0.83,18.32c0.33,0.17,0.96,0.48,0.96,0.48s0.02,0,0.04-0.01
		c-0.2-0.09-0.4-0.17-0.59-0.27c-5.52-3.01-5.61-11.29-0.21-18.5c5.4-7.21,14.25-10.61,19.77-7.6c0.34,0.19,0.66,0.39,0.96,0.62
		c0,0,0,0,0,0s-0.87-0.69-2.02-1.22C492.87,271.93,483.94,275.63,478.76,282.94z"
      />
      <path
        class="st7"
        d="M304.04,128.08c-6.84,5.79-8.38,13.36-3.75,17.95c0.28,0.24,0.81,0.7,0.81,0.7s0.02,0,0.04,0.01
		c0.63,0.5,1.35,0.91,2.12,1.24c-0.87-1.45-1.98-3.32-2.2-3.71c-2.42-4.23-0.48-10.4,5.03-14.81c6.37-5.1,15.09-5.92,19.49-1.83
		c0.44,0.41,0.82,0.85,1.13,1.31c0.29,0.41,1.05,1.68,1.84,3c0.02-1.93-0.52-3.72-1.69-5.19c0,0,0,0,0,0s-0.67-0.88-1.66-1.69
		C320.45,120.93,310.88,122.3,304.04,128.08z"
      />
      <path
        class="st8"
        d="M305.04,128.37c-7.03,5.64-9,13.68-4.4,17.97c0.75,0.7,1.65,1.25,2.63,1.66c-0.87-1.46-1.99-3.33-2.21-3.72
		c-2.42-4.23-0.48-10.4,5.03-14.81c6.37-5.1,15.09-5.92,19.49-1.83c0.44,0.41,0.82,0.85,1.13,1.31c0.29,0.42,1.06,1.69,1.85,3.02
		c0.03-2.32-0.77-4.44-2.48-6.04C321.49,121.64,312.07,122.73,305.04,128.37z"
      />
      <path
        class="st9"
        d="M304.04,128.08c-6.84,5.79-8.38,13.36-3.75,17.95c0.28,0.24,0.81,0.7,0.81,0.7s0.02,0,0.04,0.01
		c-0.17-0.13-0.35-0.26-0.5-0.41c-4.6-4.29-2.63-12.33,4.4-17.97c7.03-5.64,16.45-6.73,21.04-2.44c0.28,0.26,0.54,0.54,0.77,0.83
		c0,0,0,0,0,0s-0.67-0.88-1.66-1.69C320.45,120.93,310.88,122.3,304.04,128.08z"
      />
      <path
        class="st7"
        d="M294.98,309.05c-8.8,0.65-13.99,5.24-12.39,10.81c0.11,0.31,0.34,0.91,0.34,0.91s0.01,0.01,0.03,0.03
		c0.28,0.68,0.68,1.32,1.17,1.94c0-1.46,0.01-3.34,0.02-3.73c0.1-4.21,4.91-7.6,11.87-7.95c8.05-0.41,15.92,3.4,17.58,8.5
		c0.17,0.51,0.26,1.01,0.3,1.5c0.03,0.44,0.04,1.72,0.04,3.05c1.01-1.35,1.46-2.89,1.21-4.52c0,0,0,0,0,0s-0.12-0.96-0.55-2.03
		C312.65,312.24,303.78,308.39,294.98,309.05z"
      />
      <path
        class="st8"
        d="M295.69,309.75c-8.88,0.45-14.68,5.15-12.95,10.5c0.28,0.88,0.77,1.71,1.39,2.5c0-1.47,0.01-3.35,0.02-3.74
		c0.1-4.21,4.91-7.6,11.87-7.95c8.05-0.41,15.92,3.4,17.58,8.5c0.17,0.51,0.26,1.01,0.3,1.5c0.03,0.44,0.04,1.73,0.04,3.07
		c1.22-1.63,1.62-3.53,0.97-5.52C313.18,313.26,304.57,309.3,295.69,309.75z"
      />
      <path
        class="st9"
        d="M294.98,309.05c-8.8,0.65-13.99,5.24-12.39,10.81c0.11,0.31,0.34,0.91,0.34,0.91s0.01,0.01,0.03,0.03
		c-0.08-0.18-0.16-0.36-0.22-0.54c-1.73-5.34,4.06-10.04,12.95-10.5c8.88-0.45,17.49,3.51,19.22,8.85c0.11,0.33,0.18,0.66,0.23,0.98
		c0,0,0,0,0,0s-0.12-0.96-0.55-2.03C312.65,312.24,303.78,308.39,294.98,309.05z"
      />
      <path
        class="st7"
        d="M294.56,341.93c-7.24,5.44-9.33,13.55-5.05,19.21c0.26,0.3,0.76,0.88,0.76,0.88s0.02,0,0.04,0.01
		c0.59,0.64,1.28,1.18,2.02,1.65c-0.76-1.71-1.73-3.91-1.92-4.37c-2.1-4.97,0.28-11.48,6.1-15.59c6.72-4.75,15.48-4.48,19.56,0.59
		c0.41,0.51,0.75,1.04,1.04,1.6c0.25,0.49,0.93,1.98,1.62,3.54c0.16-2.12-0.24-4.16-1.31-5.92c0,0,0,0,0,0s-0.6-1.06-1.53-2.08
		C311.44,336.27,301.8,336.49,294.56,341.93z"
      />
      <path
        class="st8"
        d="M295.53,342.38c-7.41,5.25-9.97,13.82-5.7,19.14c0.7,0.87,1.55,1.59,2.5,2.18c-0.76-1.71-1.74-3.92-1.93-4.38
		c-2.1-4.97,0.28-11.48,6.1-15.59c6.72-4.75,15.48-4.48,19.56,0.59c0.41,0.51,0.75,1.04,1.04,1.6c0.26,0.49,0.93,2,1.62,3.56
		c0.2-2.55-0.44-4.98-2.03-6.97C312.42,337.18,302.95,337.13,295.53,342.38z"
      />
      <path
        class="st9"
        d="M294.56,341.93c-7.24,5.44-9.33,13.55-5.05,19.21c0.26,0.3,0.76,0.88,0.76,0.88s0.02,0,0.04,0.01
		c-0.16-0.17-0.33-0.33-0.47-0.51c-4.27-5.32-1.72-13.89,5.7-19.14c7.41-5.25,16.89-5.19,21.15,0.13c0.26,0.33,0.5,0.67,0.71,1.02
		c0,0,0,0,0,0s-0.6-1.06-1.53-2.08C311.44,336.27,301.8,336.49,294.56,341.93z"
      />
      <path
        class="st7"
        d="M385.07,457.93C385.07,457.94,385.07,457.94,385.07,457.93c0.21,0.04,1.1,0.14,1.41,0.17
		c1.29-4.74,4.2-22.5,2.77-34.52c-0.45-0.05-1.25-0.13-1.36-0.14c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0
		c-0.18,0-0.42,0.83-0.68,2.26c0.11,0.02,0.22,0.03,0.33,0.04c0.43,8.91-1.3,22.8-2.51,29.84c-0.09-0.01-0.17-0.02-0.26-0.03
		C384.78,457.05,384.88,457.92,385.07,457.93z"
      />
      <path
        class="st8"
        d="M385.07,457.93c1.53-5.25,4.11-24.3,2.81-34.48c-0.18,0-0.42,0.83-0.68,2.26c0.11,0.02,0.22,0.03,0.33,0.04
		c0.43,8.91-1.3,22.8-2.51,29.84c-0.09-0.01-0.17-0.02-0.26-0.03C384.78,457.05,384.88,457.92,385.07,457.93z"
      />
      <path
        class="st9"
        d="M387.88,423.45c0.1,0.01,0.91,0.09,1.36,0.14c1.43,12.01-1.48,29.78-2.77,34.52
		c-0.31-0.04-1.19-0.14-1.41-0.17C386.6,452.69,389.17,433.64,387.88,423.45z"
      />
      <path
        class="st7"
        d="M396.5,253.56C396.5,253.56,396.5,253.56,396.5,253.56c-0.26-0.01-1.36,0-1.74,0
		c-0.85,4.86-1.69,22.83,1.89,34.56c0.55-0.01,1.55-0.03,1.68-0.03c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0
		c0.22-0.02,0.38-0.87,0.49-2.33c-0.13,0-0.27,0-0.41,0c-1.88-8.78-1.89-22.79-1.48-29.92c0.11,0,0.21-0.01,0.32-0.02
		C396.98,254.36,396.72,253.55,396.5,253.56z"
      />
      <path
        class="st8"
        d="M396.5,253.56c-1.07,5.39-1.3,24.59,1.83,34.53c0.22-0.02,0.38-0.87,0.49-2.33c-0.13,0-0.27,0-0.41,0
		c-1.99-8.78-1.99-21.98-1.48-29.92c0.11,0,0.21-0.01,0.32-0.02C396.98,254.36,396.72,253.55,396.5,253.56z"
      />
      <path
        class="st9"
        d="M398.33,288.09c-0.12,0-1.13,0.02-1.68,0.03c-3.57-11.73-2.74-29.7-1.89-34.56c0.38,0,1.47-0.01,1.74,0
		C395.43,258.95,395.2,278.16,398.33,288.09z"
      />
      <path
        class="st7"
        d="M209.11,324.15c-0.11,0-0.22,0-0.33,0.01c-1.62-8.76-1.79-22.75-1.54-29.88c0.09,0,0.17,0,0.26-0.01
		c-0.23-1.46-0.44-2.31-0.63-2.3c-0.03,0.17-0.03,0.17,0,0c-0.22-0.01-1.11,0.01-1.42,0.02c-0.64,4.87-1.13,22.85,1.91,34.55
		c0.45-0.01,1.27-0.04,1.37-0.04c0,0,0,0,0,0C208.92,326.46,209.04,325.61,209.11,324.15z"
      />
      <path
        class="st8"
        d="M206.87,291.96c-0.81,5.4-0.79,24.61,1.87,34.52c0.18-0.02,0.3-0.88,0.37-2.33c-0.11,0-0.22,0-0.33,0.01
		c-1.62-8.76-1.79-22.75-1.54-29.88c0.09,0,0.17,0,0.26-0.01C207.27,292.8,207.05,291.95,206.87,291.96z"
      />
      <path
        class="st9"
        d="M208.74,326.48c-0.1,0-0.92,0.03-1.37,0.04c-3.04-11.7-2.56-29.68-1.91-34.55c0.31,0,1.2-0.03,1.42-0.02
		C206.06,297.36,206.08,316.57,208.74,326.48z"
      />
      <path
        class="st7"
        d="M205.78,359.64c-0.11,0-0.22,0-0.33,0c-1.55-8.78-1.6-22.77-1.29-29.9c0.09,0,0.17,0,0.26,0
		c-0.22-1.47-0.43-2.31-0.61-2.31c-0.03,0.17-0.03,0.17,0,0c-0.22-0.01-1.11,0.01-1.42,0.01c-0.68,4.86-1.31,22.84,1.63,34.56
		c0.45-0.01,1.27-0.03,1.37-0.03c0,0,0,0,0,0C205.57,361.95,205.7,361.09,205.78,359.64z"
      />
      <path
        class="st8"
        d="M203.81,327.43c-0.86,5.4-0.99,24.6,1.58,34.53c0.18-0.02,0.31-0.87,0.39-2.33c-0.11,0-0.22,0-0.33,0
		c-1.55-8.78-1.6-22.77-1.29-29.9c0.09,0,0.17,0,0.26,0C204.2,328.27,203.99,327.43,203.81,327.43z"
      />
      <path
        class="st9"
        d="M205.39,361.97c-0.1,0-0.92,0.02-1.37,0.03c-2.94-11.72-2.31-29.7-1.63-34.56c0.31,0,1.2-0.02,1.42-0.01
		C202.95,332.83,202.82,352.04,205.39,361.97z"
      />
      <path
        class="st7"
        d="M397.59,362.98c-0.13,0-0.26,0-0.38-0.01c-1.53-8.81-1.18-22.78-0.61-29.9c0.1,0,0.2,0,0.3,0
		c-0.21-1.47-0.42-2.32-0.63-2.32c-0.04,0.17-0.04,0.17,0,0c-0.25-0.01-1.28-0.02-1.64-0.03c-0.93,4.84-2.19,22.78,0.86,34.57
		c0.52,0,1.47,0,1.58,0c0,0,0,0,0,0C397.27,365.28,397.45,364.43,397.59,362.98z"
      />
      <path
        class="st8"
        d="M396.26,330.76c-1.15,5.37-1.87,24.55,0.81,34.54c0.21-0.02,0.38-0.86,0.52-2.32c-0.13,0-0.26,0-0.38-0.01
		c-1.53-8.81-1.18-22.78-0.61-29.9c0.1,0,0.2,0,0.3,0C396.69,331.61,396.47,330.75,396.26,330.76z"
      />
      <path
        class="st9"
        d="M397.07,365.3c-0.11,0-1.06,0-1.58,0c-3.06-11.79-1.8-29.73-0.86-34.57c0.36,0.01,1.39,0.02,1.64,0.03
		C395.11,336.12,394.38,355.31,397.07,365.3z"
      />
      <path
        class="st7"
        d="M441.57,348.25c4.35-7.71,10.98-10.51,15.71-6.74c0.25,0.23,0.74,0.68,0.74,0.68s0.03,0.02,0.06,0.06
		c0.54,0.54,0.98,1.11,1.37,1.81c-1.42-0.61-3.23-1.34-3.61-1.5c-4.12-1.66-9.47,1.3-12.75,7.47c-3.79,7.13-3.42,15.85,0.82,19.48
		c0.42,0.36,0.87,0.66,1.33,0.89c0.91,0.51,2.34,0.95,2.85,1.32c-1.74,0.35-3.84,0.11-5.31-0.8c0,0-0.06-0.04-0.06-0.04
		s-0.54-0.26-1.34-1.12C437.22,365.15,437.23,355.96,441.57,348.25z"
      />
      <path
        class="st8"
        d="M441.96,349.19c4.19-7.87,11.19-11.17,15.64-7.38c0.73,0.62,1.36,1.36,1.86,2.25
		c-1.42-0.61-3.26-1.35-3.64-1.5c-4.12-1.66-9.46,1.3-12.73,7.46c-3.79,7.13-3.42,15.85,0.82,19.48c0.42,0.36,0.87,0.66,1.33,0.89
		c0.43,0.26,2.15,0.85,2.85,1.32c-2.09,0.43-3.99-0.01-5.65-1.43C437.98,366.5,437.77,357.05,441.96,349.19z"
      />
      <path
        class="st9"
        d="M441.57,348.25c4.43-7.95,11.21-10.41,15.71-6.74c0.25,0.23,0.74,0.68,0.74,0.68s0,0.02,0.01,0.04
		c-0.14-0.14-0.28-0.3-0.43-0.43c-4.45-3.79-11.45-0.49-15.64,7.38c-4.19,7.87-3.98,17.32,0.47,21.11c0.27,0.23,0.56,0.44,0.85,0.62
		c0,0,0.69,0.52,2.34,0.91c-1.07-0.11-2.66-0.48-4-1.79C437.14,365.33,437.23,355.96,441.57,348.25z"
      />
      <path
        class="st7"
        d="M69.25,266.31c4.6-7.56,11.32-10.14,15.92-6.21c0.25,0.24,0.71,0.71,0.71,0.71s0.03,0.02,0.06,0.06
		c0.52,0.55,0.94,1.14,1.31,1.85c-1.4-0.65-3.18-1.45-3.56-1.62c-4.06-1.8-9.51,0.99-12.99,7.04c-4.02,7-3.94,15.73,0.17,19.49
		c0.41,0.37,0.84,0.69,1.3,0.94c0.89,0.53,2.31,1.02,2.8,1.42c-1.75,0.29-3.85-0.02-5.28-0.98c0,0-0.06-0.04-0.06-0.04
		s-0.53-0.28-1.3-1.17C64.34,283.06,64.65,273.88,69.25,266.31z"
      />
      <path
        class="st8"
        d="M69.61,267.26c4.45-7.72,11.55-10.79,15.87-6.85c0.71,0.65,1.32,1.4,1.79,2.31c-1.4-0.65-3.21-1.45-3.59-1.62
		c-4.06-1.8-9.49,0.98-12.97,7.04c-4.02,7-3.94,15.73,0.17,19.49c0.41,0.37,0.84,0.69,1.3,0.94c0.42,0.27,2.12,0.92,2.8,1.42
		c-2.1,0.36-3.99-0.15-5.6-1.61C65.06,284.44,65.16,274.99,69.61,267.26z"
      />
      <path
        class="st9"
        d="M69.25,266.31c4.69-7.8,11.55-10.03,15.92-6.21c0.25,0.24,0.71,0.71,0.71,0.71s0,0.02,0.01,0.04
		c-0.14-0.15-0.27-0.3-0.42-0.44c-4.32-3.94-11.43-0.87-15.87,6.85c-4.45,7.72-4.55,17.18-0.23,21.11c0.27,0.24,0.54,0.46,0.83,0.65
		c0,0,0.67,0.54,2.3,0.99c-1.06-0.14-2.65-0.57-3.94-1.92C64.25,283.24,64.65,273.88,69.25,266.31z"
      />
      <path
        class="st7"
        d="M279.89,98c6.51-6,13.68-6.62,17.02-1.57c0.17,0.3,0.49,0.88,0.49,0.88s0.02,0.03,0.04,0.07
		c0.34,0.68,0.59,1.35,0.75,2.14c-1.16-1.01-2.66-2.27-2.98-2.54c-3.41-2.85-9.41-1.68-14.43,3.18c-5.8,5.62-8.14,14.02-5.22,18.78
		c0.29,0.47,0.62,0.89,0.99,1.26c0.71,0.76,1.93,1.62,2.3,2.14c-1.76-0.2-3.69-1.08-4.81-2.4c0,0-0.05-0.05-0.05-0.05
		s-0.43-0.42-0.93-1.48C270.54,112.73,273.38,103.99,279.89,98z"
      />
      <path
        class="st8"
        d="M279.97,99.01c6.41-6.19,14.09-7.18,17.15-2.2c0.5,0.82,0.88,1.71,1.08,2.72c-1.17-1.02-2.69-2.28-3-2.55
		c-3.41-2.85-9.4-1.68-14.41,3.18c-5.8,5.62-8.14,14.02-5.22,18.78c0.29,0.47,0.62,0.89,0.99,1.26c0.33,0.37,1.78,1.47,2.3,2.14
		c-2.12-0.24-3.79-1.24-4.94-3.1C270.85,114.26,273.56,105.2,279.97,99.01z"
      />
      <path
        class="st9"
        d="M279.89,98c6.66-6.2,13.87-6.45,17.02-1.57c0.17,0.3,0.49,0.88,0.49,0.88s0,0.02,0,0.04
		c-0.09-0.18-0.17-0.37-0.28-0.54c-3.06-4.98-10.74-3.99-17.15,2.2c-6.41,6.19-9.12,15.25-6.06,20.23c0.19,0.31,0.4,0.59,0.62,0.85
		c0,0,0.49,0.71,1.94,1.59c-0.98-0.43-2.39-1.28-3.25-2.94C270.4,112.88,273.38,103.99,279.89,98z"
      />
      <path
        class="st7"
        d="M35.72,255.24c3.99-7.9,10.48-11.01,15.38-7.45c0.26,0.22,0.77,0.65,0.77,0.65s0.03,0.02,0.06,0.05
		c0.56,0.51,1.03,1.06,1.45,1.74c-1.45-0.54-3.29-1.19-3.68-1.33c-4.19-1.47-9.4,1.74-12.39,8.05c-3.46,7.3-2.68,15.99,1.72,19.42
		c0.44,0.34,0.9,0.62,1.37,0.83c0.93,0.46,2.38,0.84,2.9,1.19c-1.72,0.43-3.84,0.28-5.35-0.56c0,0-0.06-0.03-0.06-0.03
		s-0.55-0.24-1.39-1.06C32.15,272.33,31.74,263.15,35.72,255.24z"
      />
      <path
        class="st8"
        d="M36.15,256.16c3.82-8.05,10.66-11.67,15.28-8.09c0.76,0.59,1.42,1.3,1.96,2.17c-1.45-0.54-3.32-1.19-3.71-1.33
		c-4.19-1.47-9.38,1.73-12.37,8.05c-3.46,7.3-2.68,15.99,1.72,19.42c0.44,0.34,0.9,0.62,1.37,0.83c0.44,0.24,2.19,0.75,2.9,1.19
		c-2.07,0.52-3.99,0.17-5.71-1.16C32.98,273.64,32.33,264.21,36.15,256.16z"
      />
      <path
        class="st9"
        d="M35.72,255.24c4.06-8.15,10.72-10.91,15.38-7.45c0.26,0.22,0.77,0.65,0.77,0.65s0,0.01,0.01,0.04
		c-0.15-0.14-0.29-0.28-0.45-0.41c-4.62-3.58-11.46,0.04-15.28,8.09c-3.82,8.05-3.17,17.48,1.44,21.07
		c0.28,0.22,0.58,0.41,0.88,0.58c0,0,0.71,0.49,2.38,0.8c-1.07-0.06-2.68-0.36-4.08-1.6C32.08,272.51,31.74,263.15,35.72,255.24z"
      />
      <path
        class="st7"
        d="M210.16,26.74c6.38-6.13,13.54-6.9,16.98-1.93c0.18,0.3,0.51,0.86,0.51,0.86s0.02,0.03,0.04,0.07
		c0.36,0.67,0.62,1.34,0.79,2.13c-1.19-0.99-2.71-2.22-3.03-2.47c-3.47-2.78-9.45-1.48-14.36,3.48c-5.68,5.74-7.84,14.19-4.82,18.89
		c0.3,0.47,0.64,0.88,1.02,1.24c0.72,0.74,1.97,1.58,2.34,2.09c-1.76-0.16-3.71-1.01-4.86-2.3c0,0-0.05-0.05-0.05-0.05
		s-0.44-0.41-0.96-1.46C201.12,41.67,203.78,32.87,210.16,26.74z"
      />
      <path
        class="st8"
        d="M210.26,27.75c6.28-6.33,13.93-7.47,17.1-2.56c0.52,0.81,0.91,1.69,1.13,2.69c-1.19-0.99-2.73-2.23-3.06-2.49
		c-3.47-2.78-9.43-1.48-14.34,3.48c-5.68,5.74-7.84,14.19-4.82,18.89c0.3,0.47,0.64,0.88,1.02,1.24c0.33,0.37,1.81,1.44,2.34,2.09
		c-2.12-0.19-3.82-1.16-5-2.99C201.47,43.18,203.99,34.07,210.26,27.75z"
      />
      <path
        class="st9"
        d="M210.16,26.74c6.53-6.34,13.73-6.74,16.98-1.93c0.18,0.3,0.51,0.86,0.51,0.86s0,0.02,0,0.04
		c-0.1-0.18-0.18-0.36-0.29-0.53c-3.17-4.91-10.82-3.77-17.1,2.56c-6.28,6.33-8.8,15.44-5.63,20.35c0.2,0.3,0.41,0.58,0.64,0.84
		c0,0,0.51,0.7,1.97,1.55c-0.99-0.41-2.41-1.23-3.31-2.87C200.99,41.82,203.78,32.87,210.16,26.74z"
      />
      <path
        class="st7"
        d="M22.9,250.75c3.96-7.92,10.44-11.04,15.35-7.51c0.26,0.22,0.77,0.64,0.77,0.64s0.03,0.02,0.06,0.05
		c0.56,0.51,1.03,1.06,1.46,1.74c-1.45-0.54-3.29-1.18-3.68-1.32c-4.2-1.46-9.4,1.77-12.36,8.09c-3.43,7.31-2.63,16,1.79,19.41
		c0.44,0.34,0.9,0.61,1.37,0.83c0.93,0.46,2.38,0.83,2.91,1.18c-1.72,0.44-3.83,0.3-5.35-0.54c0,0-0.06-0.03-0.06-0.03
		s-0.55-0.24-1.39-1.05C19.39,267.85,18.94,258.67,22.9,250.75z"
      />
      <path
        class="st8"
        d="M23.33,251.67c3.79-8.06,10.62-11.71,15.25-8.14c0.76,0.58,1.43,1.29,1.97,2.16
		c-1.45-0.54-3.32-1.18-3.71-1.32c-4.2-1.46-9.38,1.77-12.35,8.09c-3.43,7.31-2.63,16,1.79,19.41c0.44,0.34,0.9,0.61,1.37,0.83
		c0.44,0.23,2.19,0.74,2.91,1.18c-2.07,0.53-3.99,0.19-5.71-1.14C20.22,269.16,19.54,259.73,23.33,251.67z"
      />
      <path
        class="st9"
        d="M22.9,250.75c4.03-8.16,10.68-10.95,15.35-7.51c0.26,0.22,0.77,0.64,0.77,0.64s0,0.01,0.01,0.04
		c-0.15-0.14-0.29-0.28-0.45-0.4c-4.63-3.57-11.46,0.08-15.25,8.14c-3.79,8.06-3.11,17.49,1.52,21.06c0.29,0.22,0.58,0.41,0.88,0.58
		c0,0,0.71,0.49,2.38,0.8c-1.07-0.05-2.69-0.35-4.08-1.59C19.32,268.04,18.94,258.67,22.9,250.75z"
      />
      <path
        class="st7"
        d="M278.09,258.96C278.09,258.96,278.09,258.96,278.09,258.96c0-0.01-0.36-0.56-0.55-0.85
		c-3.46-4.69-10.67-3.99-16.95,2.64c-6.15,6.42-8.57,15.52-5.38,21.21c0.97,1.61,2.44,2.34,3.46,2.71
		c-0.02-0.01-0.04-0.02-0.06-0.03c0.48,0.23,0.95,0.39,1.37,0.44c0.04-0.19,0.11-0.45,0.18-0.67c-0.45-0.35-1.28-1-1.52-1.19
		c-0.39-0.34-0.75-0.74-1.07-1.2c-3.22-4.59-1.41-13.16,4.05-19.15c4.72-5.18,10.65-6.74,14.24-4.09c0.33,0.25,1.94,1.42,3.17,2.37
		C278.82,260.34,278.5,259.62,278.09,258.96z"
      />
      <path
        class="st8"
        d="M260.73,261.76c6.03-6.61,13.67-8.08,17.05-3.28c0.55,0.79,0.99,1.66,1.25,2.66
		c-1.23-0.94-2.84-2.12-3.17-2.37c-3.59-2.64-9.52-1.09-14.24,4.09c-5.46,5.99-7.27,14.57-4.05,19.15c0.32,0.46,0.68,0.86,1.07,1.2
		c0.23,0.19,1.07,0.84,1.52,1.19c-0.07,0.22-0.13,0.49-0.18,0.67c-1.26-0.17-3.01-1.2-4.04-2.67
		C252.55,277.62,254.7,268.37,260.73,261.76z"
      />
      <path
        class="st9"
        d="M260.59,260.75c6.29-6.64,13.49-7.33,16.95-2.64c0.19,0.29,0.55,0.85,0.55,0.85s0,0.02,0,0.04
		c-0.1-0.17-0.2-0.36-0.31-0.52c-3.38-4.8-11.02-3.33-17.05,3.28c-6.03,6.61-8.18,15.86-4.8,20.65c0.21,0.3,1.22,1.46,2.73,2.26
		c-1.01-0.37-2.48-1.1-3.46-2.71C252.02,276.27,254.44,267.17,260.59,260.75z"
      />
      <path
        class="st7"
        d="M160.46,286.24c0.15,0.14,0.27,0.3,0.41,0.45c-0.01-0.03-0.01-0.04-0.01-0.04s-0.46-0.47-0.7-0.72
		c-4.32-3.88-11.21-1.75-16,5.99c-4.71,7.5-5.24,16.85-0.99,21.77c1.27,1.37,2.85,1.82,3.91,1.98c-0.14-0.04-0.27-0.08-0.4-0.13
		c0.9,0.25,1.85,0.29,2.86,0.14c-1.04-0.4-2.37-1.04-2.78-1.31c-0.45-0.26-0.84-0.52-1.24-0.9c-4.07-3.82-4.07-12.75,0.05-19.69
		c3.56-6,9.03-8.71,13.07-6.86c0.37,0.17,2.18,1,3.57,1.67C161.75,287.66,161.16,286.9,160.46,286.24z"
      />
      <path
        class="st8"
        d="M144.49,292.87c4.55-7.66,11.7-10.63,15.97-6.63c0.7,0.66,1.3,1.42,1.75,2.34c-1.39-0.67-3.19-1.5-3.57-1.67
		c-4.04-1.86-9.51,0.85-13.07,6.86c-4.12,6.94-4.12,15.86-0.06,19.69c0.4,0.38,0.79,0.65,1.24,0.9c0.41,0.28,1.74,0.91,2.78,1.31
		c-2.11,0.33-3.99-0.2-5.58-1.69C139.7,309.98,139.93,300.53,144.49,292.87z"
      />
      <path
        class="st9"
        d="M144.15,291.92c4.8-7.73,11.69-9.86,16-5.99c0.24,0.24,0.7,0.72,0.7,0.72s0,0.02,0.01,0.04
		c-0.14-0.15-0.26-0.31-0.41-0.45c-4.26-4-11.41-1.03-15.97,6.63c-4.55,7.66-4.79,17.11-0.53,21.11c0.26,0.25,0.54,0.46,0.82,0.66
		c0,0,0.66,0.55,2.29,1.02c-1.06-0.16-2.64-0.61-3.91-1.98C138.91,308.77,139.44,299.41,144.15,291.92z"
      />
      <path
        class="st7"
        d="M157.78,320.92c0.15,0.13,0.29,0.28,0.43,0.43c-0.01-0.03-0.01-0.04-0.01-0.04s-0.48-0.45-0.73-0.69
		c-4.47-3.7-11.27-1.29-15.75,6.63c-4.4,7.68-4.55,17.05-0.1,21.79c1.33,1.32,2.92,1.7,3.99,1.82c-0.14-0.04-0.27-0.07-0.4-0.11
		c0.91,0.21,1.86,0.22,2.87,0.02c-1.06-0.36-2.41-0.94-2.83-1.2c-0.46-0.24-0.86-0.49-1.28-0.85c-4.22-3.66-4.58-12.57-0.75-19.67
		c3.32-6.14,8.67-9.07,12.78-7.38c0.38,0.16,2.22,0.91,3.63,1.52C159.13,322.29,158.5,321.54,157.78,320.92z"
      />
      <path
        class="st8"
        d="M142.09,328.19c4.24-7.84,11.26-11.09,15.68-7.27c0.72,0.63,1.35,1.37,1.85,2.27
		c-1.42-0.62-3.25-1.37-3.63-1.52c-4.11-1.69-9.46,1.24-12.78,7.38c-3.83,7.1-3.47,16.02,0.75,19.67c0.42,0.36,0.82,0.61,1.28,0.85
		c0.42,0.26,1.78,0.84,2.83,1.2c-2.09,0.41-3.99-0.04-5.64-1.46C138,345.48,137.85,336.03,142.09,328.19z"
      />
      <path
        class="st9"
        d="M141.71,327.25c4.48-7.92,11.28-10.33,15.75-6.63c0.25,0.23,0.73,0.69,0.73,0.69s0,0.02,0.01,0.04
		c-0.14-0.14-0.28-0.3-0.43-0.43c-4.42-3.82-11.44-0.57-15.68,7.27c-4.24,7.84-4.09,17.29,0.33,21.11c0.27,0.24,0.56,0.44,0.85,0.62
		c0,0,0.68,0.53,2.33,0.93c-1.07-0.11-2.66-0.5-3.99-1.82C137.17,344.3,137.32,334.93,141.71,327.25z"
      />
      <path
        class="st7"
        d="M342.37,409.37c-1.21-0.56-2.64-1.22-3.49-1.63c-0.85-0.41-1.55-0.85-1.95-1.03
		c-3.04,0.41-6.43,2.27-9.56,5.66c-6.02,6.44-8.32,15.5-5.09,21.11c0.98,1.58,2.44,2.32,3.45,2.68c-0.13-0.07-0.25-0.13-0.37-0.2
		c0.83,0.41,1.76,0.64,2.78,0.68c-0.94-0.59-2.12-1.46-2.47-1.81c-0.39-0.34-0.72-0.67-1.04-1.12c-3.25-4.51-1.56-13.24,3.78-19.26
		c4.63-5.2,10.49-6.81,14.09-4.23c0.33,0.24,1.94,1.39,3.18,2.31c-0.21-0.76-0.52-1.44-0.91-2.07
		C344.1,410.17,343.58,409.93,342.37,409.37z"
      />
      <path
        class="st8"
        d="M327.52,413.37c3.27-3.67,7.03-5.78,10.33-6.14c0.82,0.42,2.06,1,3.5,1.67c1.44,0.67,2.66,1.22,3.42,1.56
		c0.39,0.63,0.69,1.31,0.91,2.07c-1.23-0.92-2.84-2.07-3.18-2.31c-3.6-2.58-9.46-0.97-14.09,4.23c-5.35,6.01-7.04,14.74-3.78,19.26
		c0.32,0.45,0.65,0.78,1.04,1.12c0.35,0.35,1.53,1.22,2.47,1.81c-2.12-0.08-3.86-0.95-5.14-2.71
		C319.59,429.2,321.61,420,327.52,413.37z"
      />
      <path
        class="st9"
        d="M327.37,412.37c3.14-3.39,6.53-5.26,9.56-5.66c0.21,0.12,0.5,0.29,0.92,0.52c-3.3,0.36-7.06,2.47-10.33,6.14
		c-5.91,6.63-7.93,15.84-4.51,20.56c0.21,0.29,0.44,0.56,0.68,0.8c0,0,0.54,0.67,2.05,1.43c-1.01-0.36-2.47-1.09-3.45-2.68
		C319.05,427.87,321.34,418.81,327.37,412.37z"
      />
      <path
        class="st7"
        d="M172.31,249.18c-4.59-7.74-12.08-10.6-17.75-6.87c-0.31,0.23-0.89,0.67-0.89,0.67s0,0.01-0.01,0.02
		c-0.66,0.54-1.23,1.18-1.73,1.88c1.67-0.59,3.83-1.36,4.28-1.51c4.85-1.63,10.82,1.37,14.25,7.56c3.98,7.16,3.07,15.86-2.03,19.45
		c-0.51,0.36-1.04,0.65-1.58,0.88c-0.49,0.21-1.96,0.74-3.48,1.28c2.03,0.38,4.02,0.13,5.8-0.8c-0.03,0.02-0.06,0.04-0.09,0.05
		c0,0,0,0,0,0s1.04-0.5,2.08-1.32C176.37,266.55,176.89,256.92,172.31,249.18z"
      />
      <path
        class="st8"
        d="M171.81,250.11c-4.4-7.9-12.29-11.26-17.64-7.5c-0.88,0.61-1.62,1.39-2.24,2.28c1.67-0.59,3.83-1.36,4.28-1.51
		c4.85-1.63,10.82,1.37,14.25,7.56c3.98,7.16,3.07,15.86-2.03,19.45c-0.51,0.36-1.04,0.65-1.58,0.88c-0.49,0.21-1.96,0.74-3.48,1.28
		c2.39,0.44,4.73,0.04,6.73-1.36C175.44,267.45,176.2,258,171.81,250.11z"
      />
      <path
        class="st9"
        d="M172.31,249.18c-4.59-7.74-12.08-10.6-17.75-6.87c-0.31,0.23-0.89,0.67-0.89,0.67s-0.01,0.02-0.01,0.04
		c0.17-0.14,0.34-0.29,0.52-0.42c5.34-3.75,13.24-0.39,17.64,7.5c4.4,7.9,3.63,17.34-1.72,21.09c-0.33,0.23-0.67,0.43-1.02,0.61
		c0,0,0,0,0,0s1.04-0.5,2.08-1.32C176.37,266.55,176.89,256.92,172.31,249.18z"
      />
      <path
        class="st7"
        d="M348.79,352c-5.19-7.17-12.31-8.99-16.87-4.42c-0.24,0.28-0.7,0.81-0.7,0.81s0,0.01,0,0.02
		c-0.51,0.64-0.94,1.36-1.29,2.15c1.42-0.84,3.24-1.92,3.63-2.13c4.12-2.33,9.88-0.15,13.83,5.62c4.56,6.67,4.96,15.6,0.89,19.95
		c-0.4,0.43-0.84,0.8-1.3,1.11c-0.35,0.24-1.3,0.81-2.37,1.45c0.06,0.05,0.35,0.26,0.48,0.32c1.47-0.12,2.86-0.65,4.04-1.62
		c-0.02,0.02-0.05,0.05-0.07,0.07c0,0,0,0,0,0s0.87-0.65,1.68-1.63C354.86,368.98,353.98,359.17,348.79,352z"
      />
      <path
        class="st8"
        d="M348.48,353.01c-5.04-7.36-12.59-9.63-16.85-5.08c-0.7,0.75-1.25,1.64-1.69,2.63
		c1.42-0.84,3.24-1.92,3.63-2.13c4.12-2.33,9.88-0.15,13.83,5.62c4.56,6.67,4.96,15.6,0.89,19.95c-0.4,0.43-0.84,0.8-1.3,1.11
		c-0.35,0.24-1.3,0.81-2.37,1.45c0.13,0.1,0.35,0.25,0.48,0.32c1.8-0.14,3.46-0.89,4.79-2.32
		C354.15,370.02,353.52,360.37,348.48,353.01z"
      />
      <path
        class="st9"
        d="M348.79,352c-5.19-7.17-12.31-8.99-16.87-4.42c-0.24,0.28-0.7,0.81-0.7,0.81s0,0.02-0.01,0.04
		c0.13-0.17,0.26-0.34,0.41-0.5c4.27-4.55,11.81-2.27,16.85,5.08c5.04,7.36,5.67,17.01,1.4,21.55c-0.26,0.28-0.54,0.53-0.82,0.76
		c0,0,0,0,0,0s0.87-0.65,1.68-1.63C354.86,368.98,353.98,359.17,348.79,352z"
      />
      <path
        class="st7"
        d="M504.23,316.34c-8.64-2.44-17.79,0.52-20.24,6.56c-0.53,1.21-0.75,2.34-0.75,2.34s0,0,0,0
		c0.01-0.03,0.02-0.07,0.03-0.1c-0.45,1.95-0.17,3.94,0.71,5.8c0.13-1.61,0.27-3.17,0.34-3.69c0.08-0.59,0.23-1.17,0.44-1.75
		c2.16-5.83,10.32-8.94,18.23-6.93c6.85,1.73,11.26,6.72,10.94,11.81c-0.03,0.47-0.22,2.75-0.36,4.51c0.55-0.66,1.02-1.38,1.37-2.15
		c0.01,0,0.02-0.01,0.02-0.01s0.28-0.68,0.42-1.03C517.53,325.28,512.86,318.79,504.23,316.34z"
      />
      <path
        class="st8"
        d="M503.45,317.06c8.73,2.22,13.99,8.97,11.74,15.08c-0.37,1-0.93,1.91-1.63,2.75c0.14-1.77,0.33-4.04,0.36-4.51
		c0.33-5.09-4.09-10.07-10.94-11.81c-7.91-2-16.08,1.1-18.23,6.93c-0.21,0.58-0.36,1.17-0.44,1.75c-0.08,0.52-0.21,2.07-0.34,3.69
		c-1.04-2.19-1.25-4.55-0.41-6.83C485.81,318,494.72,314.84,503.45,317.06z"
      />
      <path
        class="st9"
        d="M504.23,316.34c8.63,2.44,13.3,8.94,11.16,15.35c-0.14,0.35-0.42,1.03-0.42,1.03s-0.01,0.01-0.04,0.02
		c0.09-0.2,0.2-0.4,0.27-0.61c2.25-6.11-3.01-12.86-11.74-15.08c-8.73-2.22-17.64,0.94-19.89,7.05c-0.14,0.38-0.25,0.76-0.33,1.14
		c0,0,0,0,0,0s0.21-1.13,0.75-2.34C486.44,316.87,495.59,313.9,504.23,316.34z"
      />
      <path
        class="st7"
        d="M506.04,297.98c-8.69-2.35-17.84,0.74-20.23,6.82c-0.52,1.22-0.72,2.36-0.72,2.36s0,0,0,0
		c0.01-0.03,0.02-0.07,0.03-0.1c-0.43,1.96-0.13,3.95,0.78,5.81c0.11-1.62,0.23-3.18,0.3-3.7c0.08-0.59,0.22-1.18,0.42-1.76
		c2.09-5.87,10.24-9.09,18.2-7.17c6.89,1.66,11.38,6.6,11.11,11.71c-0.02,0.47-0.18,2.76-0.31,4.53c0.55-0.67,1.01-1.4,1.35-2.17
		c0,0,0.02-0.01,0.02-0.01s0.27-0.68,0.41-1.04C519.49,306.79,514.73,300.33,506.04,297.98z"
      />
      <path
        class="st8"
        d="M505.27,298.71c8.79,2.12,14.14,8.83,11.96,14.99c-0.36,1.01-0.91,1.93-1.6,2.77
		c0.12-1.77,0.28-4.06,0.31-4.53c0.27-5.11-4.22-10.06-11.11-11.71c-7.96-1.91-16.11,1.3-18.2,7.17c-0.21,0.58-0.35,1.17-0.42,1.76
		c-0.07,0.52-0.19,2.08-0.3,3.7c-1.07-2.18-1.3-4.55-0.49-6.85C487.59,299.86,496.48,296.59,505.27,298.71z"
      />
      <path
        class="st9"
        d="M506.04,297.98c8.69,2.35,13.45,8.81,11.38,15.27c-0.14,0.36-0.41,1.04-0.41,1.04s-0.01,0.01-0.04,0.03
		c0.09-0.2,0.19-0.4,0.27-0.61c2.18-6.16-3.17-12.87-11.96-14.99c-8.79-2.12-17.68,1.15-19.86,7.31c-0.13,0.38-0.24,0.76-0.32,1.14
		c0,0,0,0,0,0s0.2-1.14,0.72-2.36C488.2,298.72,497.35,295.64,506.04,297.98z"
      />
      <path
        class="st7"
        d="M501.9,336.7c-8.64-2.44-17.79,0.52-20.24,6.56c-0.53,1.21-0.75,2.34-0.75,2.34s0,0,0,0
		c0.01-0.03,0.02-0.07,0.03-0.1c-0.45,1.95-0.17,3.94,0.71,5.8c0.13-1.61,0.27-3.17,0.34-3.69c0.08-0.59,0.23-1.17,0.44-1.75
		c2.16-5.83,10.32-8.94,18.23-6.93c6.85,1.73,11.26,6.72,10.94,11.81c-0.03,0.47-0.22,2.75-0.36,4.51c0.55-0.66,1.02-1.38,1.37-2.15
		c0.01,0,0.02-0.01,0.02-0.01s0.28-0.68,0.42-1.03C515.21,345.64,510.54,339.14,501.9,336.7z"
      />
      <path
        class="st8"
        d="M501.13,337.42c8.73,2.22,13.99,8.97,11.74,15.08c-0.37,1-0.93,1.91-1.63,2.75c0.14-1.77,0.33-4.04,0.36-4.51
		c0.33-5.09-4.09-10.07-10.94-11.81c-7.91-2-16.08,1.1-18.23,6.93c-0.21,0.58-0.36,1.17-0.44,1.75c-0.08,0.52-0.21,2.07-0.34,3.69
		c-1.04-2.19-1.25-4.55-0.41-6.83C483.49,338.36,492.4,335.2,501.13,337.42z"
      />
      <path
        class="st9"
        d="M501.9,336.7c8.63,2.44,13.3,8.94,11.16,15.35c-0.14,0.35-0.42,1.03-0.42,1.03s-0.01,0.01-0.04,0.02
		c0.09-0.2,0.2-0.4,0.27-0.61c2.25-6.11-3.01-12.86-11.74-15.08c-8.73-2.22-17.64,0.94-19.89,7.05c-0.14,0.38-0.25,0.76-0.33,1.14
		c0,0,0,0,0,0s0.21-1.13,0.75-2.34C484.11,337.23,493.27,334.26,501.9,336.7z"
      />
      <path
        class="st7"
        d="M499.52,357.94c-6.86-1.94-14.07-0.44-17.97,3.27c0.37,0.6,0.77,1.29,1.18,2.04
		c3.58-3.22,9.64-4.58,15.56-3.09c6.85,1.73,11.26,6.72,10.94,11.81c-0.03,0.47-0.22,2.75-0.36,4.51c0.55-0.66,1.02-1.38,1.37-2.15
		c0.01,0,0.02-0.01,0.02-0.01s0.28-0.68,0.42-1.03C512.82,366.88,508.15,360.38,499.52,357.94z"
      />
      <path
        class="st8"
        d="M498.74,358.66c8.73,2.22,13.99,8.97,11.74,15.08c-0.37,1-0.93,1.91-1.63,2.75c0.14-1.77,0.33-4.04,0.36-4.51
		c0.33-5.09-4.09-10.07-10.94-11.81c-5.92-1.5-11.98-0.14-15.56,3.09c-0.3-0.56-0.67-1.19-0.94-1.62
		C485.66,358.33,492.25,357.01,498.74,358.66z"
      />
      <path
        class="st9"
        d="M499.52,357.94c8.63,2.44,13.3,8.94,11.16,15.35c-0.14,0.35-0.42,1.03-0.42,1.03s-0.01,0.01-0.04,0.02
		c0.09-0.2,0.2-0.4,0.27-0.61c2.25-6.11-3.01-12.86-11.74-15.08c-6.49-1.65-13.08-0.33-16.96,2.97c-0.09-0.17-0.17-0.3-0.24-0.42
		C485.44,357.48,492.64,356,499.52,357.94z"
      />
      <path
        class="st7"
        d="M498.64,381.39c-4.19-1.88-8.74-2.37-12.62-1.64c-0.08,0.59-0.25,1.77-0.41,2.61
		c3.5-0.84,7.63-0.55,11.49,1.05c6.52,2.71,10.17,8.28,9.11,13.27c-0.1,0.46-0.61,2.69-1.01,4.41c0.65-0.58,1.21-1.22,1.67-1.93
		c0.01,0,0.02-0.01,0.02-0.01s0.37-0.63,0.57-0.96C510.51,392.17,506.83,385.06,498.64,381.39z"
      />
      <path
        class="st8"
        d="M497.78,381.99c8.32,3.46,12.54,10.91,9.43,16.63c-0.51,0.94-1.2,1.76-2.01,2.48c0.4-1.73,0.91-3.95,1.01-4.41
		c1.06-4.99-2.58-10.56-9.11-13.27c-3.59-1.49-7.4-1.84-10.73-1.22c0.12-0.49,0.28-1.31,0.35-1.81
		C490.18,379.95,494.07,380.45,497.78,381.99z"
      />
      <path
        class="st9"
        d="M498.64,381.39c8.19,3.67,11.86,10.78,8.81,16.81c-0.19,0.33-0.57,0.96-0.57,0.96s-0.01,0.01-0.04,0.02
		c0.12-0.19,0.25-0.37,0.36-0.56c3.11-5.72-1.11-13.16-9.43-16.63c-3.71-1.54-7.6-2.04-11.05-1.6c0.04-0.23,0.07-0.52,0.08-0.78
		C490.5,379.08,494.72,379.63,498.64,381.39z"
      />
      <path
        class="st7"
        d="M217.89,236.04C217.89,236.04,217.89,236.04,217.89,236.04c-0.14-0.01-1.26-0.16-1.38-0.18
		c-1.86,8.53-3.65,28.2-3.32,34.53c0.19,0.03,1.21,0.13,1.34,0.15c0,0,0,0,0,0c0.18,0,0.43-0.84,0.72-2.27
		c-0.1-0.01-0.19-0.02-0.29-0.02c0.02-1.81,0.19-5.94,1.09-14.73c0.94-9.21,1.57-13.41,1.86-15.12c0.08,0.01,0.17,0.02,0.25,0.03
		C218.16,236.94,218.07,236.06,217.89,236.04z"
      />
      <path
        class="st8"
        d="M214.53,270.54c0.18,0,0.43-0.84,0.72-2.27c-0.1-0.01-0.19-0.02-0.29-0.02c0.02-1.81,0.19-5.94,1.09-14.73
		c0.94-9.21,1.57-13.41,1.86-15.12c0.08,0.01,0.17,0.02,0.25,0.03c0-1.48-0.08-2.37-0.26-2.38
		C216.42,244.17,214.53,259.61,214.53,270.54z"
      />
      <path
        class="st9"
        d="M214.53,270.54c-0.13-0.02-1.14-0.12-1.34-0.15c-0.33-6.33,1.46-26,3.32-34.53c0.12,0.02,1.24,0.17,1.38,0.18
		C216.42,244.17,214.53,259.61,214.53,270.54z"
      />
      <path
        class="st7"
        d="M387,388.22C387,388.22,387,388.22,387,388.22c-0.14-0.01-1.25-0.17-1.37-0.18
		c-1.87,8.48-3.7,28.06-3.39,34.36c0.19,0.03,1.2,0.13,1.33,0.15c0,0,0,0,0,0c0.18,0,0.43-0.83,0.72-2.26
		c-0.1-0.01-0.19-0.02-0.29-0.03c0.02-1.8,0.21-5.91,1.12-14.66c0.96-9.16,1.59-13.34,1.89-15.04c0.08,0.01,0.17,0.02,0.25,0.03
		C387.26,389.11,387.18,388.23,387,388.22z"
      />
      <path
        class="st8"
        d="M383.57,422.54c0.18,0,0.43-0.83,0.72-2.26c-0.1-0.01-0.19-0.02-0.29-0.03c0.02-1.8,0.21-5.91,1.12-14.66
		c0.96-9.16,1.59-13.34,1.89-15.04c0.08,0.01,0.17,0.02,0.25,0.03c0-1.48-0.08-2.35-0.26-2.37
		C385.51,396.3,383.6,411.66,383.57,422.54z"
      />
      <path
        class="st9"
        d="M383.57,422.54c-0.13-0.02-1.14-0.12-1.33-0.15c-0.31-6.3,1.52-25.88,3.39-34.36
		c0.12,0.02,1.24,0.17,1.37,0.18C385.51,396.3,383.6,411.66,383.57,422.54z"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: "SlideOverview",
  props: {
    index: { type: Number, default: 0 },
    color: { type: String, default: "" },
    overview: { type: Boolean, default: false },
    colorarray: { type: Array, default: () => [] },
  },
  data() {
    return {
      internalColor: "",
      internalColorArray: [],
      defaultColor: "orange",
    };
  },
  watch: {
    index: {
      handler: function (index) {
        if (this.internalColor.indexOf("#grad1_") >= 0)
          this.internalColor = "url(#grad1_" + index + ")";
        if (this.internalColor.indexOf("#grad2_") >= 0)
          this.internalColor = "url(#grad2_" + index + ")";
        if (this.internalColor.indexOf("#grad3_") >= 0)
          this.internalColor = "url(#grad3_" + index + ")";
      },
    },
    color: {
      handler: function (color) {
        switch (color) {
          case "rot":
            this.internalColor = "#e63232";
            break;
          case "grün":
            this.internalColor = "#8cc83c";
            break;
          case "blau":
            this.internalColor = "#14b4f0";
            break;
          case "weiß":
            this.internalColor = "#e6e6e6";
            break;
          case "gelb":
            this.internalColor = "#f0dc1e";
            break;
          case "magenta":
            this.internalColor = "#FF00FF";
            break;
          case "cyan":
            this.internalColor = "#00FFFF";
            break;
          case "Regenbogen":
            this.internalColor = "url(#grad1_" + this.index + ")";
            break;
          case "cyan-magenta-gelb":
            this.internalColor = "url(#grad2_" + this.index + ")";
            break;
          case "blau-weiß":
            this.internalColor = "url(#grad3_" + this.index + ")";
            break;
          case "gelb-rot":
            this.internalColor = "url(#grad4_" + this.index + ")";
            break;
          case "cyan-magenta":
            this.internalColor = "url(#grad5_" + this.index + ")";
            break;
          default:
            this.internalColor = this.defaultColor;
            break;
        }
      },
      immediate: true,
    },
  },
  mounted() {
    this.mapColors(this.colorarray);
  },
  methods: {
    mapColors(colorArray) {
      for (let i = 0; i < colorArray.length; i++) {
        switch (colorArray[i].colorName) {
          case "rot":
            this.internalColorArray.push("#e63232");
            break;
          case "grün":
            this.internalColorArray.push("#8cc83c");
            break;
          case "blau":
            this.internalColorArray.push("#14b4f0");
            break;
          case "weiß":
            this.internalColorArray.push("#e6e6e6");
            break;
          case "orange":
            this.internalColorArray.push("#ffa500");
            break;
          case "gelb":
            this.internalColorArray.push("#f0dc1e");
            break;
          case "magenta":
            this.internalColorArray.push("#dc00dc");
            break;
          case "cyan":
            this.internalColorArray.push("#00dcdc");
            break;
          case "Regenbogen":
            this.internalColorArray.push("url(#grad1_" + i + ")");
            break;
          case "cyan-magenta-gelb":
            this.internalColorArray.push("url(#grad2_" + i + ")");
            break;
          case "blau-weiß":
            this.internalColorArray.push("url(#grad3_" + i + ")");
            break;
          case "gelb-rot":
            this.internalColorArray.push("url(#grad4_" + i + ")");
            break;
          case "cyan-magenta":
            this.internalColorArray.push("url(#grad5_" + i + ")");
            break;
        }
      }
    },
    emitSelect(selected) {
      this.$emit("selected", selected);
    },
  },
};
</script>

<style scoped>
.inactive {
  fill: #cccccc !important;
}

/*
.click:hover {
  fill: darkorange !important;
  cursor: pointer;
}
 */

.stAlt0 {
  fill: #cccccc;
}
.stAlt1 {
  fill: #f0dc1e;
}
.stAlt2 {
  fill: #f08c1e;
}
.stAlt3 {
  fill: #8cc83c;
}
.stAlt4 {
  fill: #14b4f0;
}
.stAlt5 {
  fill: #e63232;
}
.stAlt6 {
  opacity: 0.2;
}
.stAlt7 {
  opacity: 0.1;
}
.stAlt8 {
  opacity: 0.7;
  fill: #ffffff;
}
.stAlt9 {
  opacity: 0.6;
  fill: #ffffff;
}
.stAlt10 {
  opacity: 0.4;
}
.stAlt11 {
  opacity: 0.4;
  fill: #ffffff;
}
.stAlt12 {
  fill: #ffffff;
}
.stAlt13 {
  fill: #b3b3b3;
}
.stAlt14 {
  opacity: 0.5;
}
.stAlt15 {
  opacity: 0.07;
  fill: #ffffff;
}
.st0 {
  fill: #cccccc;
}
.st1 {
  fill: #f0dc1e;
}
.st2 {
  fill: #e63232;
}
.st3 {
  fill: #8cc83c;
}
.st4 {
  opacity: 0.2;
}
.st5 {
  opacity: 0.7;
  fill: #ffffff;
}
.st6 {
  opacity: 0.1;
}
.st7 {
  display: none;
  fill: #808080;
}
.st8 {
  opacity: 0.4;
}
.st9 {
  opacity: 0.4;
  fill: #ffffff;
}
</style>
